export const hiData = {
  locale: {
    home_instavc_build: "कंपनियों और कर्मचारियों के बीच सार्थक संबंध बनाएं",
    home_instavc_conference_platform:
      "एक अनपेक्षित उपयोगकर्ता अनुभव के साथ कोफेरेन्सिंग प्लेटफार्म",
    home_instavc_start_conference:
      "कान्फरेन्स शुरू करें | कान्फरेन्स में शामिल हों | इंस्टा कान्फरेन्स",
    home_instavc_Hippa:
      "HIPAA ELIGIBLE AND PCI DSS, SOC, ISO/EIC 27001, ISO/EIC 27017, ISO/EIC 27018, AND ISO 9001 COMPLIANT.",
    home_instavc_copyrights:
      "© 2018 · instaVC · PeopleLink Unified Communications Pvt. Ltd.",
    home_instavc_terms_agree: "मैं इसके लिए सहमत हूँ",
    home_instavc_terms: "नियम एवं शर्तें",

    visibility: "दृश्यता",
    members: "सदस्यों",
    create_class: " कक्षा बनाएं",
    public_class: "सार्वजनिक - केवल कक्षा के सदस्य ही शामिल हो सकते हैं",
    private_class: "निजी - आपके संस्थान में कोई भी शामिल हो सकता है",
    private: "निजी",
    filter_by: "फिल्टर के द्वारा:",
    blocked: "अवरोधित",
    deleted: " हटाए गए",
    unblock: "राज्य",
    make_active: "सक्रिय बनाना",
    addNewSubject: "नया विषय जोड़ें",
    editSubject: "विषय संपादित करें",
    editQuestionnarie: "प्रश्नावली संपादित करें",
    editAssignment: "असाइनमेंट संपादित करें",
    addNewClass: "नई कक्षा जोड़ें",
    assign_teacher: "शिक्षक असाइन करें",
    exculde_students: " छात्रों को बाहर करें",
    dateOfJoining: "शामिल होने की तिथि",
    classes: "कक्षाओं",
    users: "उपयोगकर्ताओं",
    classList: "कक्षा सूची",
    add_teacher: "शिक्षक जोड़ें",
    add_student: "छात्र जोड़ें",
    mySessions: "मेरे सत्र",
    reports: "रिपोर्टों",

    inclass_admin_teacher: "शिक्षकों की",
    inclass_admin_student: "छात्र",
    inclass_admin_studentName: "छात्र का नाम",
    inclass_admin_studentID: "स्टूडेंट आईडी",
    inclass_teacher_designation: "पद",
    inclass_teacher_department: "विभाग",
    inclass_student_rollnumber: "रोल नंबर",
    inclass_teacher_status: "स्थिति",
    inclass_admin_user_info: "उपयोगकर्ता के लिए जानकारी",
    inclass_admin_professional_info: "व्यावसायिक जानकारी",
    inclass_student_classname: "कक्षा का नाम",

    instavc_login: "लॉग इन करें",
    instavc_login_email: "ईमेल",
    instavc_login_password: "कुंजिका/पासवर्ड",
    instavc_login_button: "लॉग इन करें",
    instavc_login_forgotpassword: "पासवर्ड भूल गए",
    instavc_login_have_account: "खाता नहीं है",
    instavc_login_signup: "साइन अप करें/खाता खोले",
    instavc_signup: "साइन अप करें/खाता खोले",
    instavc_signup_firstname: "पहला नाम",
    instavc_signup_lastname: "अंतिम नाम",
    instavc_signup_email: "ईमेल",
    instavc_signup_password: "कुंजिका/पासवर्ड",
    instavc_signup_cpassword: "पासवर्ड की पुष्टि कीजिये",
    instavc_signup_button: "साइन अप करें/खाता खोले",
    instavc_signup_already_have_account:
      "क्या आपके पास पहले से एक खाता मौजूद है",
    instavc_signup_login: "लॉग इन करें",
    instavc_signup_fname_error: "पहला नाम केवल अक्षर होना चाहिए",
    instavc_signup_lname_error: "अंतिम नाम केवल अक्षर होना चाहिए",
    instavc_signup_email_error: "ईमेल एक उचित प्रारूप में होना चाहिए",
    instavc_signup_password_error:
      "पासवर्ड आठ वर्णों का होना चाहिए और एक अपरकेस, एक लोअरकेस, एक अंक और एक विशेष वर्ण का संयोजन होना चाहिए",
    instavc_signup_cpassword_error:
      "पासवर्ड की पुष्टि करें उपरोक्त पासवर्ड से मेल खाना चाहिए",
    instavc_forgotpassword_link:
      "अपने खाते से जुड़ी ईमेल आईडी दर्ज करें। आपका पासवर्ड रीसेट करने के लिए हम आपको एक ओटीपी मेल करेंगे।",
    instavc_forgotpassword_email: "ईमेल पता दर्ज करें",
    instavc_forgotpassword: "पासवर्ड भूल गए",
    instavc_forgotpassword_button: "पासवर्ड भूल गए",
    instavc_confirmpass_heading: "छात्र बनाएं",
    instavc_confirmpass_verificationcode:
      "सत्यापन कोड दर्ज करें/ मोबाइल / एमाइल पर जो कोड आया है वो लिखें",
    instavc_confirmpass_newpassword: "नया पासवर्ड लिखें",
    instavc_confirmpass_retypepassword: "नया पासवर्ड दोबारा लिखें",
    instavc_confirmpass_button: "शिक्षक बनाएँ",
    instavc_forgotpassword_signin: "साइन इन करें",
    instavc_forgotpassword_passwordcreated:
      "बधाई हो! आपका नया पासवर्ड अपडेट कर दिया गया है, अब आप कक्षा में साइन इन कर सकते हैं।",
    instavc_dashboard: "डैशबोर्ड",
    instavc_dashboard_schedule: "अनुसूची सत्र",
    instavc_dashboard_meetinglist: "पिछले सत्र",
    instavc_dashboard_conferenceplatform:
      "एक अनपेक्षित उपयोगकर्ता अनुभव के साथ कोफेरेन्सिंग प्लेटफार्म",
    instavc_dashboard_SC_room: "कान्फरेन्स शुरू करें",
    instavc_dashboard_SC_roomlist: "अपने निर्धारित सत्र का चयन करके",
    instavc_dashboard_startconference: "कान्फरेन्स शुरू करें",
    instavc_dashboard_JC: "कान्फरेन्स में शामिल हों",
    instavc_dashboard_JC_ID: "कान्फरेन्स आईडी या अनुसूचित के माध्यम से",
    instavc_dashboard_JC_button: "कान्फरेन्स में शामिल हों",
    instavc_dashboard_SC: "कान्फरेन्स शुरू करें",
    instavc_dashboard_SC_p2p: "अपनी सूची में से एक कक्ष का चयन करके ",
    instavc_dashboard_instaconference: "इंस्टा कान्फरेन्स",
    instavc_dashboard_buynow: "अभी खरीदें",
    instavc_dashboard_myprofile: "अपने बारे मे बताएँ",
    instavc_dashboard_settings: "समायोजन/सेट्टिंग्स",
    instavc_dashboard_myadmin: "मेरे व्यवस्थापक / मेरा आडमिन",
    instavc_dashboard_affiliate: "मेरे सहयोगी",
    instavc_dashboard_logout: "लॉग आउट",
    conference_myrooms: "मेरे कक्ष",
    conference_myrooms_host: "शिक्षक आईडी",
    conference_myrooms_roomhost: "आप इस कक्ष के लिए एक मेजबान / अध्यक्ष हैं",
    conference_myrooms_search: "खोजें....",
    conference_myrooms_hostuser: "मेज़बान/ अध्यक्ष उपयोगकर्ता",
    conference_myrooms_gotopremium: "प्रीमियम पर जाएं",
    conference_myrooms_buynow: "अभी खरीदें",
    conference_myrooms_renewal: "रिन्यू / रीचार्ज करें",
    conference_setup: " सेट अप",
    conference_myrooms_renewnow: "अभी रिन्यू / रीचार्ज करें", // "conference_myrooms_hosts": "मेज़बान/ अध्यक्ष",",
    conference_myrooms_join: "कान्फरेन्स मे जुड़ें",
    conference_myrooms_setup: "नये कक्ष बनाए",
    conference_myrooms_sethost_email:
      "अपने आप को एक मेज़बान/ अध्यक्ष बनाए, या एक मेज़बान/ अध्यक्ष के रूप में किसी और को बनाने के लिए उपयोगकर्ता का ईमेल पता दर्ज करें",
    conference_myrooms_selfhost: "अपने आप को एक मेज़बान/ अध्यक्ष बनाए",
    conference_myrooms_otherhost:
      "यदि आप किसी भी उपयोगकर्ता को मेज़बान/ अध्यक्ष बनाना चाहते हैं, तो उसका ईमेल पता दर्ज करें",
    conference_myrooms_email: "ईमेल पता",
    Cancel: "रद्द करे",
    conference_myrooms_apply: "लागू करे",
    view_schedule_myrooms: "मेरे कक्ष",
    view_schedule_search: "खोजें....",
    view_schedule_schedule: "अनुसूची / शेड्यूल",
    view_schedule_calender: "निम्न कॅलंडर मैं कक्ष के शेड्यूल की जानकारी है",
    video_recordings: "वीडियो रेकॉर्डिंग्स",
    view_recordings_search: "खोजें",
    view_recordings_month: "इस महीने",
    view_recordings_week: "पिछले सात दिन",
    view_recordings_today: "आज",
    no_recordings: "कोई रिकॉर्डिंग नहीं",
    no_recordings_message: "अभी यहां कोई वीडियो नहीं है",
    no_recordings_startmessage:
      "एक बार रिकॉर्डिंग शुरू करने के बाद आप अपने सभी वीडियो यहाँ देख सकते हैं",
    stop_recording: "क्या आप इस रिकॉर्डिंग को रोकना चाहते हैं ?",
    stop_recording_agree: "इस बात से सहमत",
    stop_recording_disagree: "इस बात से असहमत",
    conference_in_use: "कान्फरेन्स चल रही है",
    conference_mode: "कान्फरेन्स  मोड",
    large_conference_mode: "लार्ज कान्फरेन्स मोड",
    conference_setup_configuration: "कॉन्फ़िगरेशन / व्यवस्था का प्रारूप",
    conference_setup_generateid: "कोई सत्र आईडी नहीं मिली, एक उत्पन्न करें!",
    conference_setup_regenerate: "फिर से बनाए",
    conference_setup_meetingid: "सत्र आईडी",
    conference_setup_camera: "फेस टाइम एच डी  कैमरा",
    conference_setup_defaultmicrophone: "डिफ़ॉल्ट - आंतरिक माइक्रोफोन",
    conference_setup_microphone: "आंतरिक माइक्रोफोन",
    conference_setup_volume: "आवाज़",
    conference_setup_videomode: "वीडियो मोड",
    conference_setup_forward: "फ़ॉरवर्ड",
    conference_setup_mix: "मिक्स",
    conference_setup_invite: "निमन्त्रण",
    conference_setup_invitepeople: "लोगो को निमंत्रण भेजो",
    conference_setup_invitefriends:
      "सहयोग करने के लिए अपने मित्रों और सहकर्मियों को आमंत्रित करें",
    conference_setup_invite_directlink: "अपने कक्ष से सीधा लिंक",
    conference_setup_invite_sharelink:
      "अपनी कान्फरेन्स में शामिल होने के लिए अपने प्रतिभागियों के साथ इस लिंक को साझा करें",
    conference_setup_invite_link:
      "https://connect.instavc.com/conference-guest/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9/f",
    conference_setup_invitebyemail: "मेल द्वारा आमंत्रित करें",
    conference_setup_invite_enteremail:
      "अपने प्रतिभागियों को आमंत्रित करने के लिए उनका ईमेल पता डालें",
    conference_setup_invite_emailid: "ईमेल पता",
    conference_setup_invite_close: "बंद करे",
    conference_setup_invite_button: "आमंत्रित करे",
    conference_setup_advancesettings: "अग्रिम सेटिंग्स",
    conference_setup_changeresolution: "रेज़ल्यूशन चुनें",
    conference_setup_lowbandwidth: "कम बैंडविड्थ",
    conference_setup_poornetwork: "खराब नेटवर्क",
    conference_setup_vga: "वीजीए - (640x480)",
    conference_setup_vga_graphics:
      "वीडियो ग्राफिक्स ऐरे (वीजीए) वीडियो रिज़ॉल्यूशन के लिए",
    conference_setup_hd1080: "ऐच डी 1080 पी  - (1920x1080)",
    conference_setup_fhd: "पूर्ण हाइ डेफिनेशन  (FHD) वीडियो रिज़ॉल्यूशन के लिए",
    conference_setup_4k: "4K - (3840 x 2160)",
    conference_setup_4k_fhd:
      "पूर्ण हाइ डेफिनेशन  (FHD) वीडियो रिज़ॉल्यूशन के लिए",
    conference_setup_sif: "SIF - (320x240)",
    conference_setup_sif_vr: "For SIF Video Resolution",
    conference_setup_hd720: "HD720p - (1280x720)",
    conference_setup_hd720_vr: "पूर्ण हाइ डेफिनेशन  (FHD) वीडियो रिज़ॉल्यूशन",
    conference_setup_2k: "2K - (2048×1080)",
    conference_setup_2k_fhd: "पूर्ण हाइ डेफिनेशन  (FHD) वीडियो रिज़ॉल्यूशन",
    conference_setup_broadcastoptions: "प्रसारण विकल्प",
    conference_setup_enable: "सक्षम करें",
    conference_setup_disable: "अक्षम करें",
    conference_setup_reportquality:
      "आवाज और वीडियो कॉल को बेहतर बनाने में मदद करने के लिए गुणवत्ता के आंकड़ों की रिपोर्ट करें",
    conference_setup_havetroubleshoot:
      "क्या आप एक कान्फरेन्स समस्या का निवारण करना चाहते हैं, तो यहां लिंक पर क्लिक करें",
    conference_setup_conferencetroubleshoot:
      "अगर कान्फरेन्स मैं कोई कठिनाई आए तो यहाँ क्लिक करें",
    conference_troubleshoot:
      "अगर कान्फरेन्स मैं कोई कठिनाई आए तो यहाँ क्लिक करें",
    conference_troubleshoot_faq: "अधिकतर पूछे जाने वाले सवाल",
    conference_troubleshoot_emailreport: "ए मैल रिपोर्ट",
    conference_troubleshoot_gotoconference: "कान्फरेन्स पर जाएं",
    conference_troubleshoot_os: "ऑपरेटिंग सिस्टम",
    conference_troubleshoot_version: "संस्करण",
    conference_troubleshoot_browser: "ब्राउज़र",
    conference_troubleshoot_chromeversion: "क्रोम संस्करण",
    conference_troubleshoot_privatebrowsing: "निजी ब्राउज़िंग",
    conference_troubleshoot_displayresolution: "डिसप्ले रेज़ल्यूशन्स",
    conference_troubleshoot_aspectratio: "पहलू अनुपात प्रदर्शित करें",
    conference_troubleshoot_hasspeakers: "क्या आपके कंप्यूटर मैं स्पीकर हैं",
    conference_troubleshoot_foundspeaker: "स्पीकर डिवाइस मिले ",
    conference_troubleshoot_hasmicrophone: "क्या आपके कंप्यूटर मैं माइक हैं",
    conference_troubleshoot_foundmicrophone: "माइक्रोफोन उपकरण मिले",
    conference_troubleshoot_haswebcam: "क्या आपके कंप्यूटर मैं कैमरा  हैं",
    conference_troubleshoot_foundcameras: "कैमरा उपकरण मिले",
    conference_troubleshoot_webcampermission: "वेबसाइट में कैमरा की अनुमति है?",
    conference_troubleshoot_microphonepermission:
      "वेबसाइट में माइक्रोफ़ोन की अनुमति है?",
    conference_troubleshoot_getUsermedia:
      "ब्राउज़र इस पेज पर उपयोगकर्ता मीडिया प्राप्त करने की अनुमति देता है?",
    conference_troubleshoot_changeoutput_audiodevice:
      "क्या आप आउटपुट ध्वनि उपकरण बदल सकते हैं?",
    conference_troubleshoot_changecamera_resolution:
      "क्या आप नए कान्फरेन्स के अनुरोध के बिना कैमरा रिज़ॉल्यूशन बदल सकते हैं?",
    conference_troubleshoot_supportwebrtc:
      "ब्राउज़र वेबआरटीसी (या तो 1.0 या 1.1) का समर्थन करता है?",
    conference_troubleshoot_supportortc:
      "ब्राउज़र ORTC (WebRTC 1.1) का समर्थन करता है?",
    conference_troubleshoot_turnserver:
      "क्या टर्न सर्वर तक पहुचा जा स्कता है क्या?",
    conference_troubleshoot_turn: "turn:139.59.64.172:443",
    conference_troubleshoo_coturn: "turn:coturn.instavc.com:443",
    conference_troubleshoot_replacetracks:
      "क्या आप कोई दखल दिए बिना ट्रॅक्स बदल सकते हैं",
    conference_troubleshoot_record_remoteaudio:
      "क्या आपका ब्राउजर रिमोट ऑडियो रिकॉर्ड कर सकता है या वेबएडियो एपीआई में रिमोट ऑडियो स्ट्रीम प्रोसेस कर सकता है",
    conference_troubleshoot_browsersupports_websocketapi:
      "ब्राउज़र WebSockets API का समर्थन करते हैं",
    conference_troubleshoot_blockwebsocket:
      "आपके सिस्टम ने WebSockets प्रोटोकॉल को अवरुद्ध कर दिया है, या WebSockets सर्वर सुलभ नहीं है? नहीं",
    conference_troubleshoot_supportwebaudioapi:
      "ब्राउज़र WebAudio एपीआई का समर्थन करता है",
    conference_troubleshoot_supportsctp:
      "ब्राउज़र SCTP डेटा चैनल का समर्थन करता है",
    conference_troubleshoot_supportsrtp:
      "ब्राउज़र आरटीपी डेटा चैनल का समर्थन करता है",
    conference_troubleshoot_support_screencapturing:
      "यह पृष्ठ स्क्रीन कैप्चरिंग एपीआई का समर्थन करता है",
    conference_troubleshoot_support_multimonitor:
      "क्या ब्राउज़र किसी भी मॉनिटर के मल्टी-मॉनिटर चयन और कैप्चरिंग स्क्रीन का समर्थन करता है?",
    conference_troubleshoot_mobiledevice: "क्या यह एक मोबाइल डिवाइस है?",
    conference_troubleshoot_supportscreencap_canvas:
      "क्या ब्राउज़र कैनवास से स्क्रीन कैप्चरिंग का समर्थन करता है?",
    conference_troubleshoot_supportscreencap_video:
      "क्या ब्राउज़र वीडियो से स्क्रीन कैप्चरिंग का समर्थन करता है?",
    conference_troubleshoot_supportpromisses:
      "क्या ब्राउज़र समर्थन का वादा करता है?",
    conference_troubleshoot_ipaddress: "आई पी अड्रेस जानने के लिए क्लिक करें",
    conference_troubleshoot_stunserver: "क्या स्टन सर्वर तक पहुच पा रहे हैं?",
    cancel: "रद्द करें",
    instavc_conference_revoke_fromhost: "मेज़बान/ अध्यक्ष से रद्द करें",
    instavc_conference_startvideoconf_button: "वीडियो कान्फरेन्स शुरू करें",
    instavc_conference_loading:
      "कान्फरेन्स शुरू हो रही है कृपया प्रतीक्षा करें",
    instavc_conference_authenticating: "इंस्टा वीसी सर्वर से कनेक्ट हो रहा है",
    instavc_conference_joinconference: "कान्फरेन्स से जुड़ रहे हैं",
    instavc_conference_publishyourvideo: "आपका वीडियो प्रकाशित हो रहा है",
    instavc_conference_publishyouraudio: "आपका ऑडियो प्रकाशित हो रहा है",
    instavc_conference_settings: "सेटिंग्स",
    instavc_conference_setting: "कान्फरेन्स सेट्टिंग्स",
    instavc_conference_setting_source: "स्रोत",
    instavc_conference_setting_camera: "कैमरा",
    instavc_conference_audioinputs: "ऑडियो इनपुट्स",
    instavc_conference_setting_apply: "लागू / अप्लाइ",
    instavc_conference_setting_resolution: "रेज़ल्यूशन",
    instavc_conference_setting_qr: "QR(BETA)",
    instavc_conference_whiteboard: "वाइटबोर्ड",
    instavc_conference_screenshare: "अपनी स्क्रीन दूसरो को दिखाएँ",
    instavc_conference_presenter: "्रस्तुतकर्ता",
    instavc_conference_stopshare: "शेयर बंद करें",
    instavc_conf_install_Screenshare: "इंस्टॉल करें स्क्रीनशेयर",
    instavc_conference_videosync: "साथ मैं देखें",
    instavc_conference_videourl: "वीडियो का लिंक",
    instavc_conference_enter_videourl: "वीडियो का लिंक डालें",
    instavc_conference_videourl_note:
      "नोट: केवल सक्रिय प्रतिभागी ही इस वीडियो को देख सकते हैं, दिवंगत जोइन वीडियो नहीं देख सकते हैं ",
    instavc_conf_recordings: "रिकॉर्डिंग",
    instavc_conference_sharecontent: "अपनी स्क्रीन साझा करें",
    instavc_conference_sharecontent_screen:
      "connect.instavc.com आपकी स्क्रीन की सामग्री को साझा करना चाहता है। चुनें कि आप क्या साझा करना चाहते हैं ",
    instavc_conference_shareentire_screen: "आपका पूरा स्क्रीन",
    instavc_conference_sharescreen_applicationwindow: "अनुप्रयोग विंडो",
    instavc_conference_sharescreen_chrometab: "क्रोम टैब",
    instavc_conference_sharescreen_share: "शेयर",
    instavc_conf_sharescreen: "आप अपनी स्क्रीन साझा कर रहे हैं!",
    instavc_conf_share_otherparticipants:
      "अन्य प्रतिभागी आपकी स्क्रीन पर एप्लिकेशन और दस्तावेज़ देख सकते हैं",
    instavc_stopsharing: "सांझा करना बंद करो",
    instavc_conference_chat: "चैट",
    instavc_conference_additional_camera: "अतिरिक्त कैमरा",
    instavc_conference_sharescreen_groupchat: "समूह बातचीत",
    instavc_conference_sharescreen_GC: "जी सी",
    instavc_conference_entermessage: "कुछ कहें!",
    instavc_conference_adddevice: "फ़ोन जोड़ें",
    instavc_conference_adddevice_addcamera: "कैमरा जोड़ें",
    instavc_conference_adddevice_source: "स्रोत",
    instavc_conference_adddevice_camera: "कैमरा",
    instavc_conference_adddevice_cameraname: "फेसटाइम एचडी कैमरा",
    instavc_conference_adddevice_close: "बंद करे ",
    instavc_conference_adddevice_publish: "प्रकाशित करें",
    instavc_conference_info: "जानकारी",
    questions: "प्रशन",
    instavc_conference_askquestions: "सवाल पूछो",
    instavc_conference_info_meetingid: "व्यक्तिगत सत्र आईडी",
    instavc_conference_fullscreen: "पूर्ण स्क्रीन",
    conference_setup_invitepeoplel: "लोगो को निमंत्रण भेजो",
    conference_setup_invite_linktojoin:
      "https://connect.instavc.com/conference-guest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
    conference_setup_invite_byemail: "मेल द्वारा आमंत्रित करें",
    instavc_conference_participants: "प्रतिभागियों",
    instavc_conference_participants_search: "खोज ...",
    instavc_conference_participant: "प्रतिभागियों",
    instavc_conference_participants_muteall: "सब म्यूट",
    instavc_conference_participants_unmuteall: "सब अनम्यूट",
    instavc_conference: "सम्मेलन",
    instavc_conf_more: "अधिक",
    instavc_conference_picturemode:
      "यह वीडियो पिक्चर-इन-पिक्चर मोड में चल रहा है",
    instavc_conference_mediastreams_stats: "मीडिया स्ट्रीम आँकड़े",
    instavc_conference_mediastreams_audio: "ऑडियो",
    instavc_conference_mediastreams_audio_send: "भेजें",
    instavc_conference_mediastreams_audio_codec: "कोडेक",
    instavc_conference_mediastreams_audio_rates: "दरें (केबीपीएस)",
    instavc_conference_mediastreams_audio_lost: "खो गया",
    instavc_conference_mediastreams_audio_fraction: "अंश",
    instavc_conference_mediastreams_video: "वीडियो",
    instavc_conference_mediastreams_video_send: "भेजें",
    instavc_conference_mediastreams_video_codec: "कोडेक",
    instavc_conference_mediastreams_video_rates: "दरें (केबीपीएस)",
    instavc_conference_mediastreams_video_lost: "खो गया",
    instavc_conference_mediastreams_video_fraction: "अंश",
    instavc_conference_resolution: "संकल्प",
    instavc_conference_framerate: "फ्रेम रेट",
    instavc_conference_nack: "Nack",
    instavc_conference_pli: "पी एल आई",
    instavc_conference_bw: "उपलब्ध बी डब्ल्यू",
    instavc_conference_audiomuted: "ऑडियो म्यूट किया गया",
    instavc_conference_microphonemuted: "आपका माइक्रोफ़ोन म्यूट किया गया",
    join_conference_join_meetinginvitation: "सत्र आमंत्रण में शामिल हों",
    join_conference_search: "खोज ...",
    "join_conference_meeting details":
      "मीटिंग का नाम  n द्वारा दिया गया:  Ninvitor नाम",
    join_conference_join: "शामिल हों",
    join_conference_nomeetings: "कोई सत्र नहीं",
    join_conference_noupcomingmeetings:
      "उफ़! आपका अभी तक कोई आगामी सत्र नहीं है!",
    insta_conference_mycontacts: "मेरे संपर्क",
    insta_conference_search: "खोज ...",
    insta_conference_typemessage: "एक संदेश लिखें",
    insta_conference_addcontact: "संपर्क जोड़ें",
    insta_conference_enteremail: "मेल आईडी दर्ज करें",
    insta_conference_add: "जोड़ें",
    insta_conference_nouserfound:
      "इस ईमेल पते के साथ ऐसा कोई उपयोगकर्ता नहीं मिला",
    instavc_conf_callnot_allowed:
      "जब आप पहले से कॉल करते हैं तो आप अन्य उपयोगकर्ताओं को कॉल नहीं कर सकते",
    insta_conference_pendingapproval: "लंबित अनुमोदन",
    insta_conference_outgoingvideocall: "आउटगोइंग वीडियो कॉल",
    insta_conference_calling: "कॉलिंग ....",
    insta_conference_incomingvideocall: "इनकमिंग वीडियो कॉल",
    insta_conference_calldecline: "पतन",
    insta_conference_callaccept: "स्वीकार करना",
    insta_conference_instavcalert: "connect.instavc.com अनुमति देना चाहता है",
    insta_conference_usemicrophone: "अपने माइक्रोफ़ोन का उपयोग करें",
    insta_conference_usecamera: "अपने कैमरे का उपयोग करें",
    insta_conference_blockdevices: "खंड मैथा",
    insta_conference_allowdevices: "अनुमति",
    instavc_schedulemeeting_createmeeting: "नया सत्र बनाएं / संपादित करें",
    instavc_schedulewebinar_createmeeting: "नई वेबिनार बनाएं / संपादित करें",
    instavc_schedulemeeting_meetingname: "अपने सत्र को एक नाम दें",
    instavc_schedulemeeting_selectnames_tomeeting:
      "अपने सत्र के लिए एक कमरा चुनें",
    instavc_schedulemeeting_setduration: "सेट अवधि",
    instavc_schedulemeeting_15min: "पन्द्रह मिनट",
    instavc_schedulemeeting_30min: "तीस मिनट",
    instavc_schedulemeeting_60min: "साठ मिनट ",
    instavc_schedulemeeting_setcustom: "सेट कस्टम",
    instavc_schedulemeeting_customduration: "कस्टम अवधि",
    instavc_schedulemeeting_minutes: "मिनट",
    instavc_schedulemeeting_setconfpassword: "अपना कॉन्फ्रेंस पासवर्ड सेट करें",
    instavc_schedulemeeting_typepassword: "अपने सत्र के लिए पासवर्ड टाइप करें",
    instavc_schedulemeeting_conferencecolor: "अपने कॉन्फ्रेंस आइकन को रंग दें",
    instavc_schedulemeeting_invitepeople: "लोगों को इस सत्र में आमंत्रित करें",
    instavc_schedulemeeting_search: "खोज ...",
    instavc_schedulemeeting_SM: "एस एम",
    instvc_SM_message:
      "अधिकृत उपयोगकर्ता लाइसेंस वाले उपयोगकर्ताओं की संख्या लाइसेंस सीमा से अधिक हो गई है। यदि आप अधिक लोगों को आमंत्रित करना चाहते हैं तो आप कर सकते हैं",
    instavc_SM_message_href: "प्रीमियम पर जाएं",
    instavc_schedulemeeting_notify:
      "इस सत्र के बारे में चयनित लोगों को सूचित करें",
    instavc_schedulemeeting_addreminder: "रिमाइंडर जोड़ें",
    instavc_schedulemeeting_add: "जोड़ें",
    instavc_schedulemeeting_addmeetingreminder: "सत्र अनुस्मारक जोड़ें",
    instavc_schedulemeeting_adddatetime: "डेट पिकर, टाइम पिकर",
    instavc_schedulemeeting_apply: "लागू",
    instavc_schedulemeeting_name: "कृपया सत्र का नाम दर्ज करें",
    instavc_schedulemeeting_selectroom: "कृपया कमरे का चयन करें",
    instavc_schedulemeeting_selectduration: "कृपया अवधि चुनें",
    instavc_recuring_schedule: "आवर्ती अनुसूची",
    instavc_schedulemeeting_nothinginreminders: "रिमाइंडर में कुछ भी नहीं",
    instavc_schedulemeeting_createbutton: "सृजन करना",
    instavc_schedulemeeting_createdsuccessfully: "अनुसूची सफलतापूर्वक बनाई गई",
    instavc_meetinglist_calender: "पंचांग",
    instavc_meetinglist_selecteddates: "आपकी चयनित तिथियां",
    instavc_meetinglist_schedulecreted: "शेड्यूल बनाया गया",
    instavc_meetinglist_pastschedule: "अतीत अनुसूची",
    instavc_meetinglist: "सत्र सूची",
    instavc_meetinglist_meetingdetils:
      "सत्र का नाम, सत्र का समय, द्वारा आयोजित",
    instavc_meetinglist_search: "खोज ...",
    instavc_meetinglist_deleterecuring: "पुनरावर्ती शेड्यूल हटाएं",
    instavc_meetinglist_alow_deleterecuring:
      "क्या आप पुनरावृत्ति में केवल वर्तमान शेड्यूल या सभी शेड्यूल हटाना चाहते हैं?",
    instavc_meetinglist_schedule_series:
      "श्रृंखला में अन्य सभी कार्यक्रम रहेंगे:",
    instavc_meetinglist_schedule_seriesdelete:
      "श्रृंखला में सभी अनुसूचियों को हटा दिया जाएगा:",
    instavc_meetinglist_allrecuringsch: "परिवर्तन रद्द करें",
    instavc_meetinglist_noschedules: "नो शेड्यूल",
    instavc_ml_schedulemessage:
      "अभी तक कोई सत्र शेड्यूल नहीं बनाया गया है! नीचे दिए गए बटन पर क्लिक करके अपना शेड्यूल बनाएं।",
    instavc_create_schedule: "शेड्यूल बनाएं",
    instavc_meetinglist_currentschedule: "वर्तमान सत्र",
    instavc_meetinglist_join: "शामिल हों",
    instavc_meetinglist_buynow: "अभी खरीदें",
    instavc_dashboard_chooseplan: "एक योजना चुनें",
    instavc_package_smbplan: "एसएमबी योजनाएं",
    instavc_package_smbplan_host: "(होस्ट आधारित लाइसेंस)",
    instavc_package_smbplandescription:
      "एक कमरे में एक समय में केवल 1 होस्ट हो सकता है। एक खरीदार मेजबान खाते को सेट या बदल सकता है, जो कमरे को नियंत्रित कर सकता है। कॉल के दौरान होस्ट एक्सेस साझा नहीं किया जा सकता है। अन्य सभी उपयोगकर्ता तब तक बातचीत नहीं कर सकते हैं जब तक कि होस्ट शामिल नहीं होता है। सम्मेलन। ",
    instavc_package_basic: "मूल",
    instavc_package_hostuser_smb: "मैं मेजबान और",
    instavc_package_hostuser_smb_users: "उपयोगकर्ता",
    instavc_package_currency: "$",
    instavc_package_permonth: "/ महीना",
    instavc_package_bill_smb: "सालाना बिल किया",
    instavc_package_include_smb: "इस पैकेज में शामिल हैं",
    instavc_package_specifictions_Whiteboard: "व्हाइटबोर्ड",
    instavc_package_specifictions_Screen: "स्क्रीन शेयर",
    instavc_package_specifictions_nChat: "चैट",
    instavc_package_specifictions_Recording: "रिकॉर्डिंग",
    instavc_package_specifictions_PresenterMode: "प्रस्तुतकर्ता मोड",
    instavc_create_schedule: "शेड्यूल बनाएं",
    instavc_meetinglist_currentschedule: "वर्तमान सत्र",
    instavc_meetinglist_join: "शामिल हों",
    instavc_meetinglist_buynow: "अभी खरीदें",
    instavc_dashboard_chooseplan: "एक योजना चुनें",
    instavc_package_smbplan: "एसएमबी योजनाएं",
    instavc_package_smbplan_host: "(होस्ट आधारित लाइसेंस)",
    instavc_package_smbplandescription:
      "एक कमरे में एक समय में केवल 1 होस्ट हो सकता है। एक खरीदार मेजबान खाते को सेट या बदल सकता है, जो कमरे को नियंत्रित कर सकता है। कॉल के दौरान होस्ट एक्सेस साझा नहीं किया जा सकता है। अन्य सभी उपयोगकर्ता तब तक बातचीत नहीं कर सकते हैं जब तक कि होस्ट शामिल नहीं होता है। सम्मेलन। ",
    instavc_package_basic: "मूल",
    instavc_package_hostuser_smb: "मैं मेजबान और",
    instavc_package_hostuser_smb_users: "उपयोगकर्ता",
    instavc_package_currency: "$",
    instavc_package_permonth: "/ महीना",
    instavc_package_bill_smb: "सालाना बिल किया",
    instavc_package_include_smb: "इस पैकेज में शामिल हैं",
    instavc_package_specifictions_Whiteboard: "व्हाइटबोर्ड",
    instavc_package_specifictions_Screen: "स्क्रीन शेयर",
    instavc_package_specifictions_nChat: "चैट",
    instavc_package_specifictions_Recording: "रिकॉर्डिंग",
    instavc_package_specifictions_PresenterMode: "प्रस्तुतकर्ता मोड",
    instavc_package_smbplan_basic: "एसएमबी प्लान - बेसिक",
    instavc_package_plandetails:
      "$ 144.02  n  nबिल प्रति वर्ष 1 वर्ष  n$ 13 प्रति माह",
    instavc_package_term: "अवधि",
    instavc_package_1year: "1 साल",
    instavc_package_2years: "2 साल",
    instavc_package_3years: "3 साल",
    instavc_package_4years: "4 साल",
    instavc_package_5years: "5 साल",
    instavc_package_subtotal: "उप कुल",
    instavc_package_taxes: "कर और शुल्क (जी एस टी + 18%)",
    instavc_package_launchoffer: "लॉंच ऑफ",
    instavc_package_promo: "प्रोमो सफलतापूर्वक लागू किया गया",
    instavc_package_remove: "हटाना",
    instavc_package_havepromocode: "एक प्रोमो कोड है? यहाँ लागू करें",
    instavc_package_entercouponcode: "कृपया मान्य कूपन कोड दर्ज करें",
    instavc_package_total: "संपूर्ण",
    instavc_package_offerdisclaimer: "देखें प्रस्ताव अस्वीकरण",
    instavc_package_paynow: "अब भुगतान करें",
    instavc_package_payment_instavclicense:
      "इंस्टा वीसी  लाइसेंस के लिए PeopleLink एकीकृत संचार  n भुगतान",
    instavc_package_phone: "फ़ोन",
    instavc_package_entervalid_contactnumber:
      "कृपया मान्य संपर्क नंबर दर्ज करें",
    instavc_package_email: "ईमेल",
    instavc_package_enteremail:
      "कृपया एक मान्य ईएमआई आईडी दर्ज करें। उदाहरण: you@example.com",
    instavc_package_paybycard: "कार्ड द्वारा भुगतान",
    instavc_package_securedbyrazorpay: "रज़ोरॉय द्वारा सुरक्षित",
    instavc_package_card: "कार्ड",
    instavc_package_enterotp:
      "Xxxxxxxxx  n तक पहुँच सहेजे गए कार्ड पर भेजे गए ओटीपी दर्ज करें",
    instavc_package_resendotp: "ओटीपी पुनः भेजें",
    instavc_package_skipsavedcards: "सेव्ड कार्ड्स छोड़ें",
    instavc_package_enter_otp: "कृपया ओटीपी दर्ज करें",
    instavc_package_skipthesavedcards: "बचाए गए कार्ड छोड़ें",
    instavc_package_cardnumber: "कार्ड नंबर",
    instavc_package_entervalid_cardnumber: "कृपया वैध कार्ड नंबर दर्ज करें",
    instavc_package_expiry: "समाप्ति",
    instavc_package_cardholdername: "कार्डधारक का नाम",
    instavc_package_cvv: "सीवीवी",
    instavc_package_3digitcode:
      "यह आपके कार्ड के पीछे मुद्रित 3 अंकों का कोड है",
    instavc_package_pay: "वेतन",
    instavc_package_remembercard: "याद रखें कार्ड",
    instavc_package_medium: "मध्यम",
    instavc_package_hostuser_medium: "1 मेजबान और 50 उपयोगकर्ता",
    instavc_package_month_medium: "$ 15 / माह",
    instavc_package_bill_medium: "बिल भेजा वार्षिक + जी एस टी ​​18%",
    instavc_package_include_medium: "इस पैकेज में शामिल हैं",
    instavc_package_specifictions_medium:
      "व्हाइटबोर्ड  n स्क्रीन साझा करें  nचैट n रिकॉर्डिंग  n प्रस्तुतकर्ता मोड ",
    instavc_package_buynow_medium: "अभी खरीदें",
    instavc_package_fullfeatures_medium: "पूर्ण विशेषताएं",
    instavc_package_advanced: "उन्नत",
    instavc_package_hostuser_advanced: "1 मेजबान और 100 उपयोगकर्ता",
    instavc_package_month_advanced: "$ 16 / माह",
    instavc_package_bill_advanced: "बिल भेजा वार्षिक + जी एस टी ​​18%",
    instavc_package_include_advanced: "इस पैकेज में शामिल हैं",
    instavc_package_specifictions_advanced:
      "व्हाइटबोर्ड  n स्क्रीन साझा करें  nचैट n रिकॉर्डिंग  n प्रस्तुतकर्ता मोड ",
    instavc_package_buynow_advanced: "अभी खरीदें",
    instavc_package_fullfeatures_advanced: "पूर्ण विशेषताएं",
    instavc_package_virtualmcu: "वर्चुअल एमसीयू लाइसेंस",
    instavc_package_virtualmcu_room: "(कमरा आधारित लाइसेंस)",
    instavc_package_vmcudetails:
      "एक कमरे में एक समय में केवल 1 होस्ट हो सकता है। एक खरीदार मेजबान खाते को सेट या बदल सकता है, जो कमरे को नियंत्रित कर सकता है। कॉल के दौरान होस्ट एक्सेस साझा नहीं किया जा सकता है। अन्य सभी उपयोगकर्ता तब तक बातचीत नहीं कर सकते हैं जब तक कि होस्ट शामिल नहीं होता है। सम्मेलन। ",
    instavc_package_instavc: "InstaVC",
    instavc_package_silver: "चांदी",
    instavc_package_userrooms_silver_users: "उपयोगकर्ता ",
    instavc_package_userrooms_silver_rooms: "कमरे",
    instavc_package_month_silver: "$ 281 / माह",
    instavc_package_bill_silver: "बिल भेजा वार्षिक + जीएसटी 18%",
    instavc_package_include_silver: "इस पैकेज में शामिल हैं",
    instavc_package_specifictions_silver:
      "व्हाइटबोर्ड  n स्क्रीन साझा करें  nचैट n रिकॉर्डिंग  n प्रस्तुतकर्ता मोड ",
    instavc_package_buynow_silver: "अभी खरीदें",
    instavc_package_fullfeatures_silver: "पूर्ण विशेषताएं",
    instavc_package_gold: "सोना",
    instavc_package_userrooms_gold: "200 उपयोगकर्ता - 30 कमरे",
    instavc_package_month_gold: "$ 467 / माह",
    instavc_package_bill_gold: "बिल भेजा वार्षिक + जीएसटी ​​18%",
    instavc_package_include_gold: "इस पैकेज में शामिल हैं",
    instavc_package_specifictions_gold:
      "व्हाइटबोर्ड  n स्क्रीन साझा करें  nचैट n रिकॉर्डिंग  n प्रस्तुतकर्ता मोड ",
    instavc_package_buynow_gold: "अभी खरीदें",
    instavc_package_fullfeatures_gold: "फ्यूएल फीचर्स",
    instavc_package_platinum: "प्लेटिनम",
    instavc_package_userrooms_platinum: "500 उपयोगकर्ता - 50 कमरे",
    instavc_package_month_platinum: "$ 933 / माह",
    instavc_package_bill_platinum: "बिल भेजा वार्षिक + जीएसटी ​​18%",
    instavc_package_include_platinum: "इस पैकेज में शामिल हैं",
    instavc_package_specifictions_platinum:
      "व्हाइटबोर्ड  n स्क्रीन साझा करें  nचैट n रिकॉर्डिंग  n प्रस्तुतकर्ता मोड ",
    instavc_package_buynow_platinum: "अभी खरीदें",
    instavc_package_fullfeatures_platinum: "फ्यूएल फीचर्स",
    instavc_package_legacybaselicense: "विरासत आधारित लाइसेंस",
    instavc_package_licensebased_ports: "पोर्ट की संख्या के आधार पर लाइसेंस",
    instavc_package_hardwareendpoint:
      "हार्डवेयर समापन बिंदु के साथ इंस्टा वीसी",
    instavc_package_webrtcconf_legacysupport:
      "लिगेसी सपोर्ट्स के साथ वेबआरटीसी कॉन्फ्रेंसिंग",
    instavc_package_sip: "“एस आई पी / बी एफ सी पी सपोर्ट",
    instavc_package_chh323: "ChH323 / H.239 समर्थन",
    instavc_package_contactus: "संपर्क करें",
    instavc_myprofile_dashboard: "डैशबोर्ड",
    instavc_myprofile_settings: "समायोजन",
    instavc_myprofile: "मेरी प्रोफाइल",
    instavc_myprofile_personaldetail: "व्यक्तिगत विवरण",
    instavc_myprofile_personaldetails_name: "नाम",
    instavc_myprofile_personaldetails_email: "ईमेल",
    instavc_myprofile_personaldetails_phoneno: "फोन नंबर",
    instavc_myprofile_personaldetails_address: "पता",
    instavc_myprofile_personaldetails_city: "शहर",
    instavc_myprofile_edit: "संपादित करें",
    instavc_myprofile_personaldetails: "व्यक्तिगत विवरण",
    instavc_myprofile_firstname: "पहला नाम",
    instavc_myprofile_lastname: "अंतिम नाम",
    instavc_myprofile_email: "ईमेल",
    instavc_myprofile_phoneno: "फोन नंबर",
    instavc_myprofile_professionaldetails: "पेशेवर विवरण",
    instavc_myprofile_position: "स्थान",
    instavc_myprofile_professionaldetails_email: "ईमेल",
    instavc_myprofile_professionaldetails_phoneno: "फोन नंबर",
    instavc_myprofile_professionaldetails_address: "पता",
    instavc_myprofile_professionaldetails_branch: "शाखा",
    instavc_myprofile_professionaldetails_edit: "संपादित करें",
    instavc_myprofile_officialdetails: "आधिकारिक विवरण",
    instavc_myprofile_officialdetails_position: "स्थान",
    instavc_myprofile_officialdetails_email: "ईमेल",
    instavc_myprofile_officialdetails_phoneno: "फोन नंबर",
    instavc_myprofile_officialdetails_branch: "शाखा",
    instavc_myprofile_officialdetails_address: "पता",
    instavc_myprofile_contactinfo: "संपर्क जानकारी",
    instavc_myprofile_contactinformation: "संपर्क जानकारी",
    instavc_myprofile_add: "जोड़ें",
    instavc_myprofile_contactinformation_address: "पता",
    instavc_myprofile_contactinformation_city: "शहर/नगर",
    instavc_myprofile_contactinformation_zip: "ज़िप",
    instavc_myprofile_contactinformation_landmark: "सीमा चिन्ह",
    instavc_myprofile_address: "पता",
    instavc_myprofile_landmark: "सीमा चिन्ह",
    instavc_myprofile_delete: "चेतावनी",
    instavc_myprofile_deletealert: "क्या आप वाकई इसे हटाना चाहते हैं?",
    instavc_myprofile_disagree: "असहमत",
    instavc_myprofile_agree: "सहमत",
    instavc_myprofile_websitelinks: "वेबसाइट की लिंक",
    instavc_myprofile_website_add: "जोड़ें",
    instavc_myprofile_website: "वेबसाइट",
    instavc_myprofile_websiteexample: "https://www.google.com",
    instavc_myprofile_sociallinks: "सामाजिक लिंक",
    instavc_myprofile_sociallinks_add: "जोड़ें",
    instavc_myprofile_sociallink: "सामाजिक लिंक",
    instavc_myprofile_sociallinks_example: "https://www.facebook.com/xxx",
    instavc_myprofile_basicinfo: "मूलभूत जानकारी",
    instavc_myprofile_basicinfo_add: "जोड़ें",
    instavc_myprofile_basicinfo_dob: "जन्म तिथि",
    instavc_myprofile_basicinfo_gender: "लिंग",
    instavc_myprofile_basicinformation: "मूलभूत जानकारी",
    instavc_myprofile_basicinformation_dob: "जन्म तिथि",
    instavc_myprofile_basicinformation_gender: "लिंग",
    instavc_myprofile_basicinformation_deletealert:
      "अलर्ट  n क्या आप सुनिश्चित हैं कि आप इसे हटाना चाहते हैं?",
    instavc_myprofile_basicinformation_disagree: "असहमत",
    instavc_myprofile_basicinformation_agree: "सहमत",
    instavc_myprofile_uploadnewavatar: "नई अवतार डालना",
    instavc_myprofile_cropimage: "चित्र को काटो",
    instavc_myprofile_locale: "लोकेल",
    instavc_myprofile_localesettings: "लोकेल सेटिंग",
    instavc_myprofile_preferredlanguage: "पसंदीदा भाषा :",
    instavc_myprofile_language: "हिन्दी",
    instavc_settings: "समायोजन",
    instavc_settings_changepassword: "पासवर्ड बदलें",
    instavc_settings_changepass: "पासवर्ड बदलें",
    instavc_settings_currentpassword: "वर्तमान पासवर्ड",
    instavc_settings_newpassword: "नया पासवर्ड",
    conf_password: "पासवर्ड की पुष्टि कीजिये",
    instavc_settings_enter_currentpassword: "कृपया वर्तमान पासवर्ड दर्ज करें",
    instavc_settings_enter_newpassword: "कृपया नया पासवर्ड दर्ज करें",
    enter_confpassword: "कृपया पासवर्ड की पुष्टि करें दर्ज करें",
    newpassword_confpassword_should_same:
      "नया पासवर्ड और कन्फर्म पासवर्ड एक ही होना चाहिए",
    curnt_psw_and_new_psw_should_not_same:
      "वर्तमान पासवर्ड और नया पासवर्ड समान नहीं होना चाहिए",
    instavc_settings_help: "मदद",
    instavc_settings_affiliate: "संबद्ध बनें",
    instavc_settings_support: "समर्थन केंद्र",
    instavc_settings_newticket: "एक नया टिकट खोलें",
    instavc_settings_ticketstatus: "टिकट की स्थिति जांचें",
    instavc_settings_troubleshoot: "समस्या निवारण",
    instavc_legacy_dailout: "डायल करें",
    instavc_legacy_stats: "आँकड़े",
    instavc_legacy_dail_in_detail: "डायल-इन विवरण",
    instavc_legacy_h323_endpoint: "H.323 एंड पॉइंट",
    instavc_legacy_sip_endpoint: "एसआईपी एंड पॉइंट",
    instavc_admin_users: "उपयोगकर्ताओं",
    instavc_courses: "पाठ्यक्रम",
    instavc_admin_username: "शिक्षक का नाम",
    instavc_admin_user_accountstatus: "खाते की स्थिति",
    instavc_admin_user_confirmed: "की पुष्टि",
    instavc_admin_user_unconfirmed: "अपुष्ट",
    instavc_admin_user_resetall: "सभी को रीसेट करें",
    instavc_admin_user_sync: "समन्वयन",
    instavc_admin_user_status: "स्थिति",
    instavc_admin_user_phonenumber: "फ़ोन नंबर",
    instavc_admin_user_created: "बनाया था",
    instavc_admin_user_all: "सब",
    instavc_admin_groups: "समूह",
    instavc_admin_addmore: "अधिक जोड़ें",
    instavc_admin_group_peoplelink: "क्वींस, गोलिव, पीपललिंक",
    instavc_admin_select_plan: "प्लान का चयन करें",
    instavc_admin_lastmodified: "अंतिम बार संशोधित",
    instavc_admin_email_verified: "ईमेल सत्यापित हुआ",
    instavc_admin_verified: "सत्यापित",
    instavc_admin_Unverified: "असत्यापित",
    instavc_admin_licenses: "लाइसेंस",
    instavc_admin_addlicense: "लाइसेंस जोड़ें",
    instavc_admin_defaultroom: "डिफ़ॉल्ट कक्ष",
    instavc_admin_hostlicense: "होस्ट आधारित लाइसेंस",
    instavc_admin_roomlicense: "कमरा आधारित लाइसेंस",
    instavc_admin_virtualmcu: "वर्चुअल एमसीयू आधारित लाइसेंस",
    instavc_admin_enterprise: "एंटरप्राइज लाइसेंस",
    instavc_mcuserver: "एमसीयू  सर्वर",
    instavc_mculink: "https://awsmcu.instavc.com",
    instavc_admin_expirydate: "समाप्ति तिथि",
    instavc_admin_settings: "व्यवस्थापक सेटिंग",
    instavc_default_offer: "रेफरल के लिए डिफ़ॉल्ट प्रस्ताव",
    instavc_enter_coupon_code: "कूपन कोड डालें",
    instavc_current_partshare: "वर्तमान भागीदार साझा करें",
    instavc_share_value: "मूल्य साझा करो",
    instavc_affliate_share: "वर्तमान संबद्ध शेयर",
    instavc_enter_share: "शेयर मूल्य दर्ज करें (%)",
    instavc_roomname: "कमरे का नाम",
    instavc_room_ten: "दस",
    instavc_room_twenty: "बीस",
    instavc_room_thirty: "तीस",
    instavc_room_hostbased: "होस्ट आधारित",
    instavc_virtualmcu: "वर्चुअल एमसीयू ",
    instavc_rooms_enterprises: "उद्यम",
    instavc_roomid: "रूम आईडी",
    instavc_roomtype: "उम्र",
    instavc_room_options: "कमरे के विकल्प",
    instavc_commercialtype: "विषयों",
    instavc_free: "नि: शुल्क",
    instavc_poc: "पी ओ सी",
    instavc_commercial: "व्यावसायिक",
    instavc_createdAt: "पर बनाया गया",
    instavc_useraccess: "उपयोगकर्ता की पहुंच",
    instavc_peoplelinkroom: " पीपललिंक रूम",
    instavc_inputlimit: "इनपुट सीमा",
    instavc_participant_limit: "प्रतिभागियों की सीमा",
    instavc_adduser: "उपयोगकर्ता जोड़ें",
    instavc_searchbyname: "नाम से खोजें",
    instavc_manage_plans: "योजनाएं / उत्पाद प्रबंधित करें",
    instavc_new_plans: "नई योजना / उत्पाद",
    instavc_allplan_list: "सभी योजनाओं की सूची",
    instavc_sortby: "इसके अनुसार क्रमबद्ध करें",
    instavc_active: "सक्रिय",
    instavc_inactive: "निष्क्रिय",
    instavc_create_plan: "नई योजना बनाएँ",
    instavc_plan_name: "योजना का नाम",
    instavc_enteramount: "राशि दर्ज करें (न्यूनतम: आईएन आर 100)",
    instavc_select_product: "उत्पाद का चयन करें",
    instavc_host_room: "1 होस्ट / कमरा",
    instavc_multiroom: "मल्टी होस्ट / रूम",
    instavc_legacyrooms: "लिगेसी रूम",
    instavc_number_hosts: "मेजबान की संख्या",
    instavc_number_participants: "प्रतिभागियों की संख्या",
    instavc_number_room: "कमरों की संख्या",
    instavc_subscriptiom_period: "सदस्यता अवधि",
    instavc_sub_yearly: "साल के",
    instavc_sub_monthly: "महीने के",
    instavc_sub_weekly: "साप्ताहिक",
    instavc_setinterval: "सेट अंतराल",
    instavc_type: "प्रकार",
    instavc_subscription: "अंशदान",
    instavc_onetime: "एक बार",
    instavc_description: "विवरण",
    instavc_planid: "प्लान आईडी",
    instavc_orders: "आदेश",
    instavc_orderid: "आदेश आईडी",
    instavc_none: "कोई नहीं",
    instavc_customer: "ग्राहक",
    instavc_build_anually: "निर्माण प्रतिवर्ष",
    instavc_recurring_billing: "आवर्ती बिलिंग",
    instavc_next_due: "अगला कारण",
    instavc_invoice_details: "चालान विवरण",
    instavc_recurring_payment: "आवर्ती भुगतान",
    instavc_todays_sale: "आज की बिक्री",
    instavc_total_order: "कुल आदेश",
    instavc_total_rooms: "कुल कमरा",
    instavc_current_conference: "वर्तमान सम्मेलन",
    instavc_current_user: "मौजूदा उपयोगकर्ता",
    instavc_live_broadcast: "लाइव प्रसारण",
    instavc_loading_chart: "चार्ट लोड हो रहा है",
    instavc_view: "देखना",
    instavc_coupon_info: "कूपन जानकारी",
    instavc_new_coupon: "नया कूपन",
    instavc_create_coupon: "नया कूपन बनाएं",
    instavc_coupon_code: "कूपन कोड",
    instavc_company_code: "कंपनी की कोड",
    instavc_select_plan: "योजनाओं का चयन करें",
    instavc_discount: "छूट",
    instavc_activestatus: "सक्रिय स्थिति",
    instavc_usage: "उपयोग",
    instavc_activeusage: "सक्रिय उपयोग",
    instavc_singleuse: "एकल उपयोग",
    instavc_multiuse: "बहु उपयोग",
    instavc_first_page: "पहला पन्ना",
    instavc_previosu_page: "पिछला पन्ना",
    instavc_next_page: "अगला पन्ना",
    instavc_last_page: "अंतिम पन्ना",
    instavc_plan: "योजना",
    instavc_request_withdrawal: "अनुरोध वापस लेने",
    instavc_withdraw: "निकालना",
    instavc_account: "लेखा",
    instavc_verification: "सत्यापन",
    instavc_withdraw_history: "इतिहास निकालना",
    instavc_add_bank: "निकासी के लिए एक बैंक खाता जोड़ें",
    instavc_bank_description:
      "हम आपकी वित्तीय जानकारी को गोपनीय रखते हुए आपके बैंक खाते की सुरक्षा करते हैं। जब भी हमें इस खाते से निकासी के लिए अनुरोध प्राप्त होगा, हम आपको स्थिति ईमेल कर देंगे। निकासी की विफलताओं और वापसी राशि से बचें, इस खाते का नाम आपके बैंक पर नाम से मेल खाना चाहिए। खाता। आपके बैंक की नीतियों और अवकाश कार्यक्रम के आधार पर स्थानांतरण को पूरा करने में कुछ समय लग सकता है। ",
    instavc_bank_accountnumber: "बैंक खाता संख्या",
    instavc_enter_accountnumber: "अपना खाता नंबर दर्ज करें",
    instavc_account_name: "खाताधारक का नाम",
    instavc_per_bank_account: "बैंक खाते के अनुसार",
    instavc_ifsc: "आई एफ एस सी कोड",
    instavc_bankname: "बैंक का नाम",
    instavc_branchname: "बैंक शाखा का नाम",
    instavc_confirmdetails: "विवरण की पुष्टि करें",
    instavc_pandetails: "कृपया अपने पैन के अनुसार विवरण प्रदान करें",
    instavc_enter_pan: "पैन के अनुसार अपना नाम दर्ज करें",
    instavc_fathername: "पिता का नाम",
    instavc_enter_fathername: "पिता का नाम दर्ज करें",
    instavc_pannumber: "पैन नंबर",
    instavc_panexampe: "जैसे: BNZPM2501G",
    instavc_upload_pan_copy: "पैन कॉपी अपलोड करें",
    instavc_save_details: "विवरण सहेजें",
    instavc_sales: "बिक्री",
    instavc_transactionid: "लेनदेन आईडी",
    instavc_date: "तारीख",
    instavc_amount: "रकम",
    instavc_setaccount_withdraw: "एक वापसी से पहले खाता विवरण सेट करें",
    instavc_first_withdraw:
      "यदि आप पहली बार उपयोगकर्ता निकासी के लिए अनुरोध कर रहे हैं, तो आपको खाता विवरण भरने और अगले टैब में पैन कार्ड विवरण का उपयोग करके अपने खाते को सत्यापित करने की आवश्यकता है। एक बार जब आप सत्यापन के साथ हो जाते हैं, तो आप अनुरोध के लिए आगे बढ़ सकते हैं। आपके उपलब्ध शेष राशि से निकासी। ",
    instavc_accountdetails: "खाता विवरण भरें",
    instavc_available_balance: "उपलब्ध शेष राशि",
    instavc_amount_withdraw: "रकम वापस लेने के लिए",
    instavc_enteramount_withdraw:
      "वह रकम दर्ज करें जिसे आप वापस लेना चाहते हैं",
    instavc_select_payment_mode: "भुगतान मोड का चयन करें",
    instavc_paypal_payment: "पेपैल भुगतान",
    instavc_bank_transaction: "बैंक लेन - देन",
    instavc_paypalfee: "पेपैल शुल्क",
    instavc_totalamount_withdraw: "कुल रकम निकालने के लिए",
    instavc_sendrequest: "अनुरोध भेजा",
    instavc_no_request_withdraw:
      "विदड्रॉल के लिए कोई अनुरोध अभी तक नहीं उठाया गया है!",
    instavc_start_process_withdraw:
      "आप नीचे से वापसी के लिए प्रसंस्करण शुरू कर सकते हैं।",
    instavc_request_withdraw_now: "अब वापस लेने का अनुरोध करें",
    instavc_current_commission: "वर्तमान कमीशन",
    instavc_from: "से",
    instavc_to: "के लिये",
    instavc_today: "आज",
    instavc_last7days: "आखिरी 7 दिन",
    instavc_lastmonth: "इस महीने",
    instavc_paid_customers: "भुगतान किया हुआ ग्राहक",
    instavc_share_referral_link: "दोस्तों के साथ अपना रेफरल लिंक साझा करें",
    instavc_copylink: "प्रतिरूप जोड़ना",
    instavc_minimum_payout: "न्यूनतम भुगतान",
    instavc_referral_signup: "रेफरल साइनअप",
    instavc_referral_clicks: "रेफरल क्लिक्स",
    instavc_paid: "भुगतान किया है",
    instavc_unpaid: "अवैतनिक",
    instavc_totalearned: "कुल कमाई",
    instavc_myreferral: "मेरे रेफ़रल ",
    instavc_viewall: "सभी देखें",
    instavc_mysales: "मेरी बिक्री",
    instavc_sms_mfa: "एसएमएस एमएफए स्थिति",
    instavc_facebook: "फेसबुक",
    instavc_twitter: "ट्विटर",
    instavc_linkedin: "लिंक्डइन",
    instavc_referred_users: "संदर्भित उपयोगकर्ता",
    instavc_created_date: "रचना तिथि",
    instavc_myearnings: "मेरी कमाई",
    instavc_earnings: "कमाई",
    instavc_commission_share: "कमीशन शेयर",
    instavc_commission_percentage: "कमीशन प्रतिशत",
    instavc_coupon_offers: "कूपन / प्रस्ताव",
    instavc_my_referral_account: "मेरा रेफरल खाता",
    instavc_req_withdraw: "अनुरोध वापस लें",
    instavc_authenticating: "इंस्टा वीसी सर्वर को प्रमाणित कर रहा है ...",
    instavc_join_access_media: "शामिल हुए .. मीडिया उपकरणों तक पहुँच ...",
    instavc_publish_success: "सफल प्रकाशन",
    instavc_recieves: "प्राप्त",
    instavc_host_screenshare:
      "आपको स्क्रीन / दस्तावेज़ साझा करने के लिए होस्ट बनने की आवश्यकता है या",
    instavc_request_sharescreen:
      "स्क्रीन / दस्तावेज़ साझा करने के लिए अनुरोध का अनुरोध",
    instavc_note: "ध्यान दें",
    instavc_filesize: "फ़ाइल का आकार 10 एमबी से अधिक नहीं होना चाहिए",
    instavc_become_host:
      "एक होस्ट बनने के लिए वीडियो पर डॉटेड अतिप्रवाह मेनू आइकन पर क्लिक करें",
    instavc_clicklink:
      "क्लिक करें एक होस्ट लिंक बनें, पॉपअप में और होस्ट पासवर्ड दर्ज करें और होस्ट बटन बनें पर क्लिक करें",
    instavc_doc_share: "दस्तावेज़ साझा करें",
    instavc_search_host: "होस्ट की प्रतीक्षा में",
    instavc_wait_for_host: "कृपया इस सत्र के शुरू होने की प्रतीक्षा करें",
    instavc_open_black_dialog: "खुला काला संवाद",
    instavc_open_white_dialog: "खुला सफेद संवाद",
    instavc_dail_detail: "डायल - इन - विवरण",
    instavc_request_access: "पहुँचने का अनुरोध करें",
    instavc_inordder_enable: "सक्षम करने के लिए",
    instavc_host_permission: "आपको होस्ट से एक्सेस की अनुमति चाहिए",
    instavc_please_wait: "कृपया इसके लिए प्रतीक्षा करें ",
    instavc_host_to_permit: "(मेजबान) की अनुमति",
    instavc_alternate_content: "वैकल्पिक सामग्री",
    instavc_meeting_room: "सत्र कक्ष",
    instavc_host_left_conference: "मेज़बान सम्मेलन छोड़ दिया! ",
    instavc_conf_end: "सम्मेलन अपने आप समाप्त हो जाएगा",
    instavc_seconds: "सेकंड",
    instavc_waiting_msg:
      "प्रतीक्षा करने के लिए धन्यवाद। होस्ट के शामिल होने पर हम सत्र शुरू करेंगे",
    instavc_let_hostname:
      "क्या आप मेजबान को यह बताना चाहते हैं कि आप प्रतीक्षा कर रहे हैं?",
    instavc_exitconf: "बाहर निकलें सम्मेलन",
    instavc_host_left: "होस्ट लेफ्ट ...",
    instavc_end_host_msg:
      "मेजबान ने इस सत्र को समाप्त कर दिया है। उपस्थित होने के लिए आपको धन्यवाद।",
    instavc_close_conf:
      "आप घर वापस जा सकते हैं (या) एप्लिकेशन को बंद कर सकते हैं।",
    instavc_gohome: "घर जाओ",
    instavc_hand_raised: "हाथ उठाया",
    instavc_ask: "पूछना",
    instavc_protocal: "मसविदा बनाना",
    instavc_bitrate: "बिटरेट",
    instavc_confirm_details: "अपने विवरण की पुष्टि करें",
    instavc_enter_info_conf:
      "कृपया सम्मेलन शुरू करने से पहले अपनी जानकारी दर्ज करें।",
    instavc_have_acc: "यदि आपके पास पहले से खाता है?",
    instavc_host_access: "होस्ट एक्सेस",
    instavc_host_pass: "मेजबान पासवर्ड दर्ज करें",
    instavc_becomehost: "मेजबान बनें",
    instavc_permit_screenshare: "परमिट स्क्रीन-शेयर",
    instavc_allow_access: "व्हाइटबोर्ड एक्सेस की अनुमति दें ",
    instavc_request_permission: "ने अतिरिक्त अनुमति देने का अनुरोध किया है,",
    instavc_deny: "मना", // "instavc_planid" : "PlanId","की योजना,"
    instavc_customeremail: "ग्राहक ईमेल",
    instavc_orderlink: "आदेश लिंक ",
    instavc_customerid: "ग्राहक आईडी",
    instavc_selectpackage: "पैकेज चुनें",
    instavc_host_package: "होस्ट आधारित पैकेज",
    instavc_virtualbase_mcu: "वर्चुअल एमसीयू आधारित",
    instavc_plans_product: "योजनाओं / उत्पाद",
    instavc_nodata: "कोई डेटा उपलब्ध नहीं है",
    instavc_nodata_msg: "उफ़! अभी आपको दिखाने के लिए कोई डेटा उपलब्ध नहीं है।",
    instavc_basicplan: "मूल योजना",
    instavc_host_participants: "1 मेजबान के साथ 30 प्रतिभागियों",
    instavc_link: "संपर्क",
    instavc_cancel_order: "आदेश रद्द",
    instavc_per: "प्रति",
    instavc_user_email: "उपयोगकर्ता ईमेल",
    instavc_owner: "मालिक",
    instavc_user: "उपयोगकर्ता",
    instavc_default_users: "डिफ़ॉल्ट ऑफ़र",
    instavc_system_settings: "प्रणाली व्यवस्था",
    instavc_expires: "समय-सीमा समाप्त",
    instavc_start_VC: "वीडियो सम्मेलन शुरू करें",
    instavc_start_AC: "ऑडियो सम्मेलन शुरू करें",
    instavc_date_error: "प्रारंभ दिनांक और समय वर्तमान समय से अधिक होना चाहिए",
    instavc_browser_update: "ब्राउज़र अपडेट आवश्यक",
    instavc_browser_note:
      "हमने देखा कि आप ब्राउज़रनाम के ​​पुराने संस्करण का उपयोग कर    रहे हैं जो अब असमर्थित है। ",
    instavc_browser_msg:
      "Instavc.com को ब्राउज़रनाम या किसी अन्य आधुनिक ब्राउज़र के अपडेटेड संस्करण की आवश्यकता है।",
    instavc_browser_upgrade:
      "कृपया बेहतर अनुभव के लिए इनमें से किसी भी नवीनतम संस्करण को अपग्रेड करें।",
    instavc_googlechrome: "गूगल क्रोम",
    instavc_gc_version74: "संस्करण 74",
    instavc_mfirefox: "मोज़िला फ़ायरफ़ॉक्स",
    instavc_mff_version: "संस्करण 66",
    instavc_opera: "ओपेरा",
    instavc_opera_version: "संस्करण 60.0+",
    instavc_microsoftedge: "माइक्रोसॉफ्ट बढ़त",
    instavc_ms_version: " संस्करण 44+",
    instavc_safari: "Apple सफारी",
    instavc_safari_version: "संस्करण 12.1",
    instavc_contact_msg:
      "पहले से ही उन्नत है, लेकिन अभी भी समस्या है? हमसे संपर्क करें",
    instavc_camera_busy: "कैमरा व्यस्त होने लगता है!",
    instavc_close_camera: "कृपया सभी एप्लिकेशन बंद करें और पुनः प्रयास करें।",
    instavc_resolution: "संकल्प समर्थित नहीं!",
    instavc_camera_notsupport: "आपका कैमरा इस संकल्प का समर्थन नहीं करता है।",
    instavc_camera_reconfig:
      "कम रिज़ॉल्यूशन के साथ अपनी सेटिंग्स को फिर से कॉन्फ़िगर करें और फिर से प्रयास करें।",
    instavc_change_resolution: "परिवर्तन संकल्प",
    instavc_confirmation: "पुष्टीकरण",
    instavc_yes: "हाँ",
    instavc_delete_room: "क्या आप वाकई कक्ष को हटाना चाहते हैं?",
    instavc_delete_license: "क्या आप वाकई लाइसेंस हटाना चाहते हैं?",
    instavc_help: "हम यहां आपकी सहायता के लिए उपलब्ध हैं",
    instavc_browse_questions:
      "सबसे अक्सर पूछे जाने वाले प्रश्नों के माध्यम से ब्राउज़ करें।",
    instavc_os: "ऑपरेटिंग सिस्टम",
    instavc_macos: "मैक ओएस एक्स संस्करण:",
    instavc_chrome_version: "क्रोम संस्करण:",
    instavc_private_browsing: "निजी ब्राउज़िंग?",
    instavc_faq_no: "नहीं",
    instavc_display_resolution: "instavc_display_resolution",
    instavc_aspect_ratio: "प्रदर्शन पहलू अनुपात",
    instavc_sys_hasspeakers: "सिस्टम में स्पीकर हैं?",
    instavc_found_speakers: "मिली स्पीकर डिवाइस: 2",
    instavc_speakers1: "स्पीकर 1",
    instavc_speakers2: "स्पीकर 2",
    instavc_sys_have_microphone: "सिस्टम में माइक्रोफोन है?",
    instavc_found_microphone: "मिला माइक्रोफोन उपकरण: 2",
    instavc_microphone1: "माइक्रोफोन 1",
    instavc_microphone2: "माइक्रोफोन 2",
    instavc_has_webcam: "सिस्टम में वेब कैमरा है?",
    instavc_found_speakers1: "संस्थापक स्पीकर डिवाइस: 1",
    instavc_camera1: "कैमरा 1",
    instavc_webcam_permission: "वेबसाइट में वेबकैम की अनुमति है?",
    instavc_microphone_permission: "वेबसाइट में माइक्रोफ़ोन की अनुमति है?",
    instavc_browser_allows:
      "ब्राउज़र इस पृष्ठ पर getUserMedia की अनुमति देता है?",
    instavc_change_output_device: "क्या आप आउटपुट ऑडियो डिवाइस बदल सकते हैं?",
    instavc_change_camera_resolutions:
      "क्या आप नए getUserMedia अनुरोध किए बिना कैमरा रिज़ॉल्यूशन बदल सकते हैं?",
    instavc_browser_support_webrtc:
      "ब्राउज़र वेबआरटीसी (या तो 1.0 या 1.1) का समर्थन करता है?",
    instavc_browser_support_ortc:
      "ब्राउज़र का समर्थन करता है ORTC (WebRTC 1.1)?",
    instavc_initial_setup:
      "कृपया प्रतीक्षा करें, जबकि आपका प्रारंभिक सेटअप संसाधित हो रहा है!",
    instavc_close_browser:
      "इस समय अपने ब्राउज़र को बंद न करें या बैक बटन का उपयोग न करें।",
    instavc_whoops: "ओह!",
    instavc_nonet_msg:
      "कोई इंटरनेट कनेक्शन नहीं मिला। कृपया अपना कनेक्शन जांचें या फिर प्रयास करें।",
    instavc_nosearch: "कोई खोज परिणाम नहीं मिला",
    instavc_noserchmsg: "हम आपकी खोज से मेल खाते कोई भी आइटम नहीं ढूँढ सकते।",
    instavc_nosearch_filter:
      "आप जो खोज रहे हैं उसे खोजने के लिए अपनी खोज या फ़िल्टर को समायोजित करने का प्रयास करें।",
    instavc_gotohoem_page: "होमपेज पर जाये",
    instavc_pageloading: "पृष्ठ लोड हो रहा है ... कृपया प्रतीक्षा करें!",
    instavc_process: "प्रसंस्करण ...",
    instavc_session_timeout: "सत्र मध्यांतर",
    instavc_session_inactivity:
      "निष्क्रियता के कारण आपका सत्र समाप्त हो रहा है।",
    instavc_session_msg: "कृपया साइन इन रहने का चयन करें।",
    instavc_session_reconnect: "रिकनेक्ट",
    instavc_site_notreached: "इस साईट तक नहीं पहुंचा जा सकता है!",
    instavc_site_webaddress: "सुनिश्चित करें कि आपको सही वेब पता मिला है",
    instavc_check_internet: "अपना नेटवर्क जांचें",
    instavc_search_url: "अन्य ब्राउज़र में URL खोजें",
    instavc_goto: "के लिए जाओ",
    instavc_request_for_access: "एक्सेस के लिए अनुरोध",
    instavc_start_collabrate: "व्हाइटबोर्ड में सहयोग शुरू करने के लिए",
    instavc_large_conference_mode:
      'इसका "बड़ा सम्मेलन" मोड, आप तब तक दूसरों से बात नहीं कर सकते और न ही देख सकते हैं जब तक कि मेजबान आपको अनुमति प्रदान न करें ',
    instavc_allow_participants:
      ' इसका "बड़ा सम्मेलन" मोड, आपको प्रतिभागियों को स्वयं बोलने की अनुमति देनी होगी ',
    instavc_buy_premium: "इन सुविधाओं को अनलॉक करने के लिए प्रीमियम खरीदें",
    instavc_alert_tryagain: "कुछ गलत हो गया। कृपया पुन: प्रयास करें",
    instavc_enter_name: "अपना नाम दर्ज करें",
    instavc_confirm: "पुष्टि करें",
    instavc_ok: "ठीक",
    instavc_askquestion: "प्रश्न पूछें...",
    instavc_recieve: "प्राप्त करना",
    instavc_delay: "देरी (सुश्री)",
    instavc_audio_opus: "ऑडियो / रचना",
    instavc_video_vp8: "वीडियो / vp8",
    instavc_browser_not_support_incall:
      "आपका ब्राउज़र कॉल के दौरान रिज़ॉल्यूशन परिवर्तन का समर्थन नहीं करता है!",
    instavc_failed_toPublish: "वीडियो प्रकाशित करने में विफल",
    instavc_publish_fail: "प्रकाशित विफल",
    instavc_video_cant_publish:
      "उपयोगकर्ता की सीमा तक पहुँचने के कारण वीडियो प्रकाशित नहीं किया जा सकता है",
    instavc_failed_joinConference: "सम्मेलन में शामिल होने में विफल",
    instavc_mute_audio:
      "यदि आप दूरस्थ ऑडियो म्यूट किए गए हैं, तो आप म्यूट / अनम्यूट नहीं कर सकते",
    instavc_remote_audio_muted: "रिमोट ऑडियो म्यूट!",
    instavc_enter_conferenceid: "रिमोट अड्यूट म्यूट!",
    instavc_share_screen: "स्क्रीन साझा करना",
    instavc_sharing_your_screen: "अपनी स्क्रीन साझा कर रहा है ...",
    instavc_stop: "रुकें",
    instavc_back: "वापस",
    instavc_choose_plan: "नीचे दी गई सूची में से अपनी योजना चुनें",
    instavc_have_promotionalcode: "प्रमोशनल कोड / पार्टनर कोड है?",
    instavc_contact_pricing: "मूल्य निर्धारण के लिए हमसे संपर्क करें",
    instavc_payment_failed: "भुगतान असफल हुआ",
    instavc_payment_error:
      "दुर्भाग्य से आपके भुगतान को संभालते समय एक त्रुटि हुई।",
    instavc_contact_support:
      "यदि आवश्यक हो तो कृपया हमारी सहायता टीम से संपर्क करें।",
    instavc_tryagain: "पुनः प्रयास करें",
    instavc_payment_success: "भुगतान सफल",
    instavc_thanks_for_payment: "भुगतान करने के लिए आपका धन्यवाद!",
    instavc_payment_processed:
      "आपका भुगतान सफलतापूर्वक संसाधित हो गया है। एक स्वचालित भुगतान रसीद ",
    instavc_mail_sent: "शीघ्र ही आपके पंजीकृत ईमेल पते पर भेजा जाएगा",
    instavc_goto_homepage: "होम पेज पर वापस जाएं",
    instavc_want_toend_call: "कॉल समाप्त करना चाहते हैं?",
    instavc_exit_window:
      "इस विंडो को बंद करने से आपकी कॉल समाप्त हो जाएगी। क्या आप वाकई इस कॉल को समाप्त करना चाहते हैं?",
    instavc_create_room: "जगह बनाना",
    instavc_userlimit: "उपयोगकर्ता सीमा",
    instavc_edit_room: "एडिट रूम",
    instavc_update: "अपडेट करें",
    instavc_manage_license: "लाइसेंस प्रबंधित करें",
    instavc_package: "पैकेज",
    instavc_no_of_rooms: "कमरों की संख्या",
    instavc_no_of_users: "नंबर उपयोगकर्ता",
    instavc_purchasedOn: "पर खरीदा",
    instavc_expiredon: "समाप्ति तिथि",
    instavc_or: "या",
    instavc_otherhost_email:
      "यदि आप किसी भी उपयोगकर्ता को होस्ट बनाना चाहते हैं, तो उसका ईमेल पता दर्ज करें।",
    instavc_set_host_password: "होस्ट पासवर्ड सेट करें",
    instavc_host_password: "होस्ट पासवर्ड",
    instavc_access_room: "इस कक्ष तक और कौन पहुँच सकता है?",
    instavc_select_user_host:
      "उसे / उसे होस्ट बनाने के लिए सूची में से किसी भी उपयोगकर्ता का चयन करें।",
    instavc_prologin: "इंस्टा वीसी प्रो लॉगिन",
    instavc_start: "शुरू",
    instavc_enter_website: "कृपया वेबसाइट का नाम दर्ज करें",
    instavc_enter_valid_email: "कृपया मान्य ईमेल दर्ज करें",
    instavc_enter_valid_phone: "कृपया मान्य फ़ोन नंबर दर्ज करें",
    instavc_field_required: "यह फ़ील्ड आवश्यक है",
    instavc_invitedby: "द्वारा आमंत्रित",
    instavc_storage: "संग्रहण",
    affiliate_approve: "मंजूर की",
    affiliate_pending: "लंबित",
    affiliate_rejected: "अस्वीकृत",
    affiliate_user_status: "उपयोगकर्ता की स्थिति",
    commission_other: "अन्य आयोगों",
    add_commission: "कमीशन जोड़ें",
    delete_commission: "क्या आप कमीशन हटाना चाहते हैं",
    update_commission: "अपडेट कमिशन",
    name: "नाम",
    offer_value: "ऑफर वैल्यू",
    add: "जोड़ें",
    update: "अपडेट करें",
    affiliates: "संबद्ध",
    status: "स्थिति",
    status_change_message: "क्या आप स्थिति बदलना चाहेंगे?",
    approve: "मंजूर",
    reject: "अस्वीकार",
    commissions: "आयोगों",
    withdraw_data: "डेटा वापस लेना",
    withdraw_amount: "निकासी की राशि",
    payment_method: "भुगतान का तरीका",
    payment_fee: "भुगतान शुल्क",
    total_amount_withdraw: "निकासी के लिए कुल राशि",
    total_earnings: "कुल कमाई",
    pending_amount: "रूका हुआ रकम",
    paid_amount: "भुगतान रकम",
    unpaid_amount: "अवैतनिक रकम",
    requested_withdraw: "आवश्यक राशि का आहरण",
    english: "अंग्रेज़ी",
    french: "फ्रेंच",
    portuguese: "पुर्तगाली",
    hindi: "हिन्दी",
    gujarati: "गुजराती",
    kannada: "कन्नड़",
    marathi: "मराठी",
    tamil: "तामिल",
    telugu: "तेलुगू",
    urdu: "उर्दू",
    spanish: "स्पेनिश",
    malyalam: "मलयालम",
    italian: "इतालवी",
    bangla: "बंगला",
    room: "कक्ष",
    create: "सृजन करना",
    repeat: "दोहराएं",
    daily: "रोज",
    repeat_every: "हर दोहराएं",
    repeat_on: "दोहराएं",
    repeat_by: "द्वारा दोहराएं",
    ends: "समाप्त होता है",
    after: "उपरांत",
    occurences: "घटनाओं",
    on: "पर",
    summary: "सारांश",
    repeats: "पुनर्प्रसारण",
    withdraws: "निकाल लेता है",
    every: "हर एक",
    days: "दिन",
    weeks: "सप्ताह",
    onday: "उस दिन",
    years: "वर्षों",
    times: "कई बार",
    until: "जब तक",
    past_meeting_list: "पिछले सत्र की सूची",
    organised_by: "द्वारा आयोजित",
    delete: "हटाएँ",
    join: "शामिल हों",
    to: "सेवा",
    enter_password: "पासवर्ड दर्ज करें",
    submit: "प्रस्तुत",
    enter_passwordmessage: "कृपया पासवर्ड दर्ज करें",
    delete_message: "क्या आप हटाना चाहते हैं",
    meeting_permanent: "सत्र स्थायी रूप से?",
    day: "दिन",
    password_message: "पासवर्ड गलत है",
    timezone: "समय क्षेत्र",
    by: "द्वारा",
    weekdays: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
    allweek: [
      "रविवार",
      "सोमवार",
      "मंगलवार",
      "बुधवार",
      "गुरुवार",
      "शुक्रवार",
      "शनिवार",
    ],
    day_month: "महीने का दिन",
    day_week: "हफ्ते का दिन",
    week: "सप्ताह",
    month: "महीना",
    year: "साल",
    enterpassword: "कृपया अपना नया पासवर्ड दर्ज करें और पासवर्ड की पुष्टि करें",
    passwordmessage: "पासवर्ड और पुष्टि पासवर्ड दोनों समान होना चाहिए",
    passwordupdate:
      "पासवर्ड सफलतापूर्वक अपडेट किया गया, कृपया अपने नए पासवर्ड से लॉगिन करें",
    numeric: ["प्रथम, द्वितीय, तृतीय, चौथाई, पंचम"],
    verify_email: "अपना ई मेल सत्याप",
    confirm_code: "पुष्टि कोड",
    verify_msg: "कृपया कोड के लिए अपना मोबाइल जांचें।",
    verify: "सत्यापित करें",
    not_recieved: "नही मिला?",
    resend_otp: "ओटीपी पुनः भेजें",
    start_browsing: " ब्राउजिंग शुरू करना",
    become_affiliate: "संबद्ध बनें",
    affiliate: "संबद्ध",
    verify_mobile: "अपना मोबाइल सत्यापित करें",
    instavc_allow_DocumentAccess: "परमिट दस्तावेज़ साझा करें",
    instavc_allow_Notes: "परमिट नोट", //common - CameraResolution
    camera_not_access:
      "कैमरा निम्नलिखित कारणों में से एक के कारण सुलभ नहीं है:",
    camera_not_access_reason1:
      "रिज़ॉल्यूशन सेटिंग्स इस डिस्प्ले के अनुकूल नहीं हो सकती हैं। अपनी सेटिंग्स को कम रिज़ॉल्यूशन के साथ कॉन्फ़िगर करें और फिर से प्रयास करें।",
    camera_not_access_reason2:
      "आपका कैमरा विभिन्न एप्लिकेशन द्वारा उपयोग किया जा रहा है, कृपया सभी एप्लिकेशन बंद करें और लिंक पर क्लिक करके फिर से प्रयास करें।", //Containers //content - components - assignQuestionnaire
    asgnQue_Assign_Question: "प्रश्न पूछें",
    asgnQue_assigned_question: "निरुपित प्रश्नावली", //assignQuestList
    quslsit_assig_que_list: "सौंपी गई प्रश्नावली सूची",
    quslsit_question_lists: "प्रश्नावली सूची",
    quslsit_add_new_question: "नई प्रश्नावली जोड़ें",
    quslsit_no_question_assign: "अभी तक कोई प्रश्नावली नहीं सौंपी गई है!",
    quslsit_assign_new_ques:
      "उपरोक्त प्रश्नावली बटन पर क्लिक करने के लिए एक नया प्रश्नावली असाइन करें", //model-assign-Questionnaire
    select_questionnaire: "प्रश्नावली का चयन करें",
    duration: "समयांतराल",
    time_limit: "समय सीमा",
    show_results: "परिणाम दिखाओ",
    save: "सहेजें", //viewAssigned
    content_group: "सामग्री समूह",
    list_assigned_ques: "निर्दिष्ट प्रश्नों की सूची:",
    mins: "मिनट",
    asgQues_answers: "उत्तर",
    asgQues_no_questions: "कोई सवाल नहीं!", //content - components - contentGrade //GradeSetting
    grdSet_GPA_calculation: "प्रतिशत से जीपीए गणना",
    grdSet_GPA_cal_msg:
      "प्रतिशत 100% के लिए है, जो 100 अंकों के अलावा कुछ भी नहीं है। इसलिए प्रतिशत में 25 अंक जीपीए सिस्टम में 1 अंक के बराबर है। जीपीए फॉर्मूले का प्रतिशत आपके प्रतिशत को 100 से विभाजित करता है और 4. से गुणा करता है। यदि आप प्रतिशत 75 है। तब आपका ग्रेड होगा (75/100) * 4 = 3. ",
    grdSet_grade_point: "यदि ग्रेड अंक है", //managegrade
    mngGrd_grades: "ग्रेड",
    mngGrd_modify: "संशोधित",
    mngGrd_save_grades: "सेव ग्रैड्स",
    mngGrd_modify_grades: "संशोधित ग्रेड",
    mngGrd_grade_info: "ग्रेड जानकारी", //content - components - ContentParticipants //components-admnAnsView
    admnAns_answer_list_for_question:
      "नीचे इस सामग्री समूह के सभी प्रश्नावली के उत्तरों की सूची दी गई है।", //components-participants
    prtcpt_certification: "Certifications:",
    prtcpt_other_content_group: "अन्य सामग्री समूहों में",
    prtcpt_sales: "बिक्री",
    prtcpt_marketing: "विपणन",
    prtcpt_human_resource: "मानव संसाधन", //manageparticipants
    mngPrtcpt_add_participants: "प्रतिभागियों को जोड़ें",
    mngPrtcpt_participants_list: "प्रतिभागियों की सूची",
    mngPrtcpt_import_participants: "आयात प्रतिभागी",
    mngPrtcpt_download_sample: "डाउनलोड नमूना",
    mngPrtcpt_no_participants_added: "अभी तक कोई प्रतिभागी नहीं जोड़ा गया है!",
    mngPrtcpt_add_new_participant:
      "एक नया प्रतिभागी जोड़ें, ऊपर दिए गए जोड़ें प्रतिभागी बटन पर क्लिक करने के लिए", //modal-add-participants
    addPrtcpt_select_participants: "प्रतिभागियों का चयन करें",
    addPrtcpt_model_add_participants: "प्रतिभागियों को जोड़ें", //partipantGradeView
    prtcptGrde_participant_grade: "प्रतिभागी ग्रेड विवरण",
    prtcptGrde_grade_participants_list: "प्रतिभागी सूची", //content - components - ContentQuestionnaire //managequestionnaire
    mngQuesnr_create_questionnaire: "प्रश्नावली बनाएँ",
    questionnaire_list: "प्रश्नावली सूची", //managequestions
    mngQues_question_details: "प्रश्नावली विवरण",
    mngQues_no_question_created: "अभी तक कोई प्रश्न नहीं बनाया गया है!",
    mngQues_create_new_question:
      "एक नया प्रश्न बनाएँ, उपरोक्त प्रश्न बटन बनाने के लिए क्लिक करें", //modal-create-quest-group
    mdlGrp_questionnaire_name: "प्रश्नावली का नाम",
    mdlGrp_update: "अपडेट करें",
    mdlGrp_create: "सृजन करना", //modal-create-questions
    mdlCrtQues_question_type: "प्रश्न प्रकार",
    mdlCrtQues_sel_question_type: "प्रश्न प्रकार चुनें",
    mdlCrtQues_single_sel_multiple_choice: "सिंगल सेलेक्ट मल्टीपल चॉइस",
    mdlCrtQues_multiselect_multiple_choice: "बहु का चयन बहुविकल्पी",
    mdlCrtQues_ture_false: "सही /गलत",
    mdlCrtQues_enter_answer_choice:
      "उत्तर पसंद दर्ज करें, और जो उत्तर सही है उसे चिह्नित करें",
    mdlCrtQues_add_another_choice: "+ एक और विकल्प जोड़ें", //viewQuestionnaire
    viewQues_add_questions: "प्रश्न जोड़ें",
    viewQues_no_question_created: "अभी तक कोई प्रश्न नहीं बनाया गया है!",
    viewQues_create_new_question:
      "एक नया प्रश्न बनाएँ, उपरोक्त प्रश्न बटन बनाने के लिए क्लिक करें", //content - components - createContent //createcontent
    crteContent_create_new_content: "नई सामग्री बनाएँ",
    crteContent_update_content: "अपडेट सामग्री",
    crteContent_save_content: "सामग्री सहेजें",
    crteContent_content_list: "सामग्री सूची",
    edit_content: "सामग्री संपादित करें",
    crteContent_create_content: "सामग्री बनाएं",
    crteContent_create_your_content_like:
      "छवियों, वीडियो फ़ाइलों, ऑडियो फ़ाइलों और दस्तावेज़ों जैसे मीडिया को जोड़कर अपनी सामग्री बनाएं।",
    crteContent_upload_document: "दस्तावेज़ अपलोड करें",
    crteContent_upload_media: "मीडिया अपलोड करें",
    crteContent_document: "दस्तावेज़",
    crteContent_media_files: "मीडिया फ़ाइलें", //view-content
    viewCon_content_view: "सामग्री देखें",
    viewCon_content_list: "सामग्री सूची",
    viewCon_View_content: "सामग्री देखें",
    viewCon_enable: "सक्षम करें:",
    viewCon_document: "दस्तावेज़",
    viewCon_media_files: "मीडिया फ़ाइलें", //content - components - contentRow
    conRow_by: "द्वारा: ", //content - components - managecontent
    create_new_content: "सामग्री बनाएँ",
    mngCon_all: "सब",
    mngCon_content_list: "सामग्री सूची",
    mngCon_no_content_created: "अभी तक कोई सामग्री नहीं बनाई गई है!",
    mngCon_create_new_content:
      "एक नई सामग्री बनाएँ, उपरोक्त सामग्री बटन बनाने के लिए क्लिक करें", //content - components - model-access-right
    mdlAccRight_share_access: "अन्य प्रशिक्षकों के साथ साझा करें",
    mdlAccRight_type_id_add: "ईमेल आईडी टाइप करें और जोड़ें",
    mdlAccRight_no_instructor_added: "अभी तक कोई प्रशिक्षक नहीं जोड़ा गया है!",
    mdlAccRight_add_people_from_addressbok:
      "अपनी पता पुस्तिका से लोगों को जोड़ें, या ईमेल पते को टाइप करके।",
    mdlAccRight_contacts: "संपर्क",
    mdlAccRight_add_contacts:
      "अपनी पता पुस्तिका के संपर्कों से सामग्री समूह में संपर्क जोड़ें",
    mdlAccRight_no_contacts_added: "अभी तक कोई संपर्क नहीं जोड़ा गया है!", //content - components - model-confirm-delete
    mdlConfDel_confirmation: "पुष्टि",
    mdlConfDel_are_you_sure_delete: "क्या आप वाकई इसे हटाना चाहते हैं",
    mdlConfDel_delete: "हटाएँ", //content - components - model-create-content-group
    mdlCrtConGrp_alert_enter_group_title: "कृपया समूह शीर्षक दर्ज करें",
    mdlCrtConGrp_alert_enter_group_description: "कृपया समूह विवरण दर्ज करें",
    mdlCrtConGrp_group_name: "समूह का नाम", //content - components - model-upload-doc
    mdlUpldoc_alert_enter_title_doc: "कृपया दस्तावेज़ का शीर्षक दर्ज करें",
    mdlUpldoc_upload_document: "दस्तावेज़ अपलोड करें",
    mdlUpldoc_document_title: "दस्तावेज़ का शीर्षक",
    mdlUpldoc_upload_doc_from_system:
      "अपने सिस्टम से दस्तावेज़ अपलोड करें, यह .pdf, एक्सेल, वर्ड दस्तावेज़ का समर्थन करता है।",
    mdlUpldoc_upload_doc: "दस्तावेज़ अपलोड करें",
    mdlUpldoc_added_doc: "जोड़े गए दस्तावेज़", //content - components - model-upload-media
    mdlUplMedia_alert_enter_title_media: "कृपया मीडिया का शीर्षक दर्ज करें",
    mdlUplMedia_alert_enter_title_url: "कृपया शीर्षक और URL दर्ज करें",
    mdlUplMedia_alert_enter_youtube_vimeo_url:
      "कृपया मान्य और URL दर्ज करें (Youtube / Vimeo)",
    mdlUplMedia_upload_media: "मीडिया अपलोड करें",
    mdlUplMedia_upload_url: "URL अपलोड करें",
    mdlUplMedia_Upload_media_system:
      "अपने सिस्टम से उच्च रिज़ॉल्यूशन फ़ाइलें अपलोड करें, यह .jpg, .png, .jpeg, .mp3, .mp4 का समर्थन करता है",
    mdlUplMedia_add_media_url:
      "मीडिया संलग्न करने के लिए मीडिया URL पता जोड़ें",
    mdlUplMedia_upload_media_url: "अपलोड मीडिया यूआरएल",
    mdlUplMedia_upload_youtube_url: "नोट: यूट्यूब URL अपलोड करें",
    mdlUplMedia_Add_media_file: "मीडिया फ़ाइलें जोड़ी गईं", //content - managecontent - index // "mngContent_content" : "सामग्री",
    mngContent_participants: "प्रतिभागियों",
    mngContent_grade_settings: "ग्रेड सेटिंग्स", //content - index
    content_all_content_group: "सभी सामग्री समूह",
    create_new_group: "समूह बनाएँ",
    content_no_group_created: "अभी तक कोई समूह नहीं बनाया गया है!",
    content_create_new_group:
      "ऊपर समूह बनाएं बटन बनाने के लिए एक नया समूह बनाएं", //ContentShare - contentList
    conList_all_group: "सब समूह ",
    conList_content_list: "सामग्री सूची",
    conList_no_content_created: "अभी तक कोई सामग्री नहीं बनाई गई है!", //contentShare - grouplist
    grpList_all_content_group: "सभी सामग्री समूह",
    grpList_no_group_created: "अभी तक कोई समूह नहीं बनाया गया है!", //ContentShare - questionStepper
    queStepper_cant_skip: "आप एक ऐसा कदम नहीं छोड़ सकते जो वैकल्पिक नहीं है।",
    queStepper_back: "वापस",
    queStepper_next: "आगे",
    queStepper_skip: "छोड़ें",
    queStepper_finish: "समाप्त",
    queStepper_submit_next: "सबमिट करें और अगला", //contentshare - showContent
    conList_content_list: "सामग्री सूची",
    showCont_document: "दस्तावेज़",
    showCont_previous: "पिछला",
    showCont_next: "आगे",
    showCont_have_completed_topic: "मैंने इस विषय में विषय पूरे कर लिए हैं", //contentShare - showMedia
    showMedia_page: "पृष्ठ",

    showMedia_of: "का",
    showMedia_previous: "पिछला", //contentShare - showquestions
    showQues_min_left: "मिनट शेष",
    showQues_completed_test: "आपने इस प्रश्नावली में परीक्षण पूरा कर लिया है।",
    showQues_go_back_content_group: "सामग्री समूह पर वापस जाएं", //contentShare - viewUserScore
    viewUserScore_view_score: "स्कोर देखें",
    viewUserScore_total_marks: "कुल मार्क:",
    viewUserScore_scored_marks: "स्कोर किया मार्क",
    viewUserScore_GPA_score: "आपका जीपीए स्कोर:",
    viewUserScore_below_list_of_answer:
      "नीचे इस सामग्री समूह के सभी प्रश्नावली के उत्तरों की सूची दी गई है।",
    viewUserScore_answered: "उत्तर दिए गए",
    viewUserScore_correct_answer: "सही उत्तर", //schedule - components //ConfirmCancelInvite
    confCancle_confirmation: "पुष्टि",
    confCancle_are_you_sure: "क्या आपको यकीन है?",
    confCancle_delete_user: "उपभोक्ता मिटायें", //confirmscheduledelete
    confSche_are_you_sure_delete: "क्या आप वाकई इस शेड्यूल को हटाना चाहते हैं?",
    confSche_no: "नहीं", //PastMeetingitem // "pastMtnItem_rn" : "आर एन", // "pastMtnItem_webinar_list" : "वेबिनार सूची", // "pastMtnItem_list_webinar" : "नीचे वेबिनार की सूची दी गई है।" // "pastMtnItem_today" : "आज", // "pastMtnItem_webinar_title_falls" : "वेबिनार टाइटल फॉल्स हियर" // "pastMtnItem_view" : देखना // "pastMtnItem_upcoming" : "आगामी", //SchedulesView //"scheView_edit_content" :  "सामग्री संपादित करें",
    // "pastMtnItem_room_name" : "कमरे का नाम: ",
    scheView_scheduled_by: "अनुसूचित द्वारा:",
    scheView_delete: "हटाएँ",
    scheView_download_calander: "कैलेंडर डाउनलोड करें",
    scheView_invite_participants: "प्रतिभागियों को आमंत्रित करें",

    scheView_start_conference: "प्रारंभ सम्मेलन",
    scheView_event_details: "घटना की जानकारी",
    scheView_room_name: "कमरे का नाम",
    scheView_minutes: "मिनट",
    scheView_conference_password: "कॉन्फ्रेंस पासवर्ड",
    scheView_settings: "समायोजन",
    scheView_webinar_event: "वेबिनार इवेंट",
    scheView_list_webinar:
      "इस वेबिनार की घटना को instavc.com/webinar पर सूचीबद्ध करें, और पंजीकरण स्वीकार करें।",
    scheView_guest_login_anonymous: "अतिथि अनाम के रूप में लॉग इन कर सकते हैं",
    scheView_allow_invities:
      "सम्मेलन में शामिल होने के लिए केवल निमंत्रण की अनुमति दें",

    scheView_enable_webinar_chat: "वेबिनार चैट सक्षम करें",
    scheView_enable_hand_rise: "वेबिनार में हाथ उठाएं सक्षम करें",
    scheView_list_of_people_invited: "नीचे आमंत्रित लोगों की सूची है",
    scheView_alert_err_to_join: "त्रुटि में शामिल होने के लिए", //WebinarDetails
    webnrDtls_upcoming_webinar_room: "नीचे इस कमरे के लिए आगामी वेबिनार हैं।", // Webinar 1 // Webinar 2 // Webinar 3
    webnrDtls_webinar_details: "वेबिनार सूची",
    webnrDtls_webinar_title: "वेबिनार शीर्षक",
    webnrDtls_webinar_title_falls: "वेबिनार टाइटल यहाँ गिरता है",
    webnrDtls_get_more_joining: "इस वेबिनार में शामिल होकर अधिक प्राप्त करें। ",
    webnrDtls_join_webinar: "वेबिनार में शामिल हों", //webinarList
    webnrList_webinar_list: "वेबिनार सूची",
    webnrList_below_list_of_webinar: "नीचे वेबिनार की सूची है।",
    webnrList_today: "आज",
    webnrList_webinar_title_falls: "वेबिनार टाइटल फॉल्स हियर",
    webnrList_view: "देखना",
    webnrList_upcoming: "आगामी", //schedule - //AddressBook
    addBook_address_book: "पता पुस्तिका",
    addBook_contact: "संपर्क",
    addBook_add_contact_to_meeting:
      "सत्र में संपर्क जोड़ें, अपनी पता पुस्तिका संपर्कों से", //MeetingList
    meetingList_past_meetings: "पिछले सत्र",
    meetingList_past_meetings_list: "पिछले सत्रों की सूची",
    meetingList_room_name: "कमरे का नाम: ",
    meetingList_view_content: "सामग्री देखें",
    meetingList_recording: "रिकॉर्डिंग",
    meetingList_view: "देखना", //scheduleInvite

    scheInvt_err_invalid_id: "अमान्य ईमेल आईडी",
    scheInvt_invite_participants: "प्रतिभागियों को आमंत्रित करें",
    scheInvt_address_book: "पता पुस्तिका",
    scheInvt_invite_people_to_meeting:
      "लोगों को इस सत्र में आमंत्रित करें। अपनी पता पुस्तिका से या ईमेल पता लिखकर लोगों को जोड़ें।",
    scheInvt_start: "शुरू होता है @",
    scheInvt_below_list_of_answer:
      "नीचे इस सामग्री समूह के सभी प्रश्नावली के उत्तरों की सूची दी गई है।",
    scheInvt_host: "मेज़बान:",
    scheInvt_minutes: "मिनट", //Webinar 1
    scheInvt_add: "जोड़ें",
    scheInvt_no_participants_added: "कोई प्रतिभागी नहीं जोड़ा गया",
    scheInvt_add_ppl_to_meetings:
      "इस सत्र में लोगों को अपनी पता पुस्तिका से प्रतिभागियों के रूप में जोड़ें, या उन्हें खोज द्वारा जोड़ें।",
    scheInvt_send_invitation: "निमंत्रण भेजना",
    scheInvt_send_passcodes: "अलग-अलग मेल में पासकोड भेजें।", //Invitation - component - invitationbody
    invitBody_invite_only_upto: "आप केवल 10 लोगों को आमंत्रित कर सकते हैं",
    invitBody_invite_ppl_meeting_email_add:
      "लोगों को इस सत्र में आमंत्रित करें, अपनी पता पुस्तिका से लोगों को जोड़ें, या ईमेल पते से जोड़ें।",
    invitBody_copy: "कॉपी",
    invitBody_enter_emailid: "ईमेल आईडी दर्ज करें",
    invitBody_close: "बंद करे",
    invitBody_send_invitation: "निमंत्रण भेजना", //documentShare //index,js
    docShare_doc_sharing: "दस्तावेज़ साझा करना",
    docShare_upload_doc_system_pdf:
      "अपने सिस्टम से दस्तावेज़ अपलोड करें, यह .pdf, एक्सेल, वर्ड दस्तावेज़ का समर्थन करता है।",
    docShare_upload_doc: "दस्तावेज़ अपलोड करें",
    docShare_no_doc: "कोई दस्तावेज नहीं",
    docShare_no_doc_in_list: "अभी तक सूची में कोई दस्तावेज़ नहीं जोड़े गए हैं।",
    docShare_add_doc: "जोड़े गए दस्तावेज़",
    docShare_alert_title_doc: "कृपया दस्तावेज़ का शीर्षक दर्ज करें",
    docShare_alert_something_went_wrong:
      "कुछ गलत हो गया। कृपया पुन: प्रयास करें", //components - PermitDocShare
    permitDocShr_permit_doc_share_access: "परमिट डॉक्यूमेंट शेयर एक्सेस",
    permitDocShr_req_permission_doc_share:
      "दस्तावेज़ साझा तक पहुँचने की अनुमति का अनुरोध किया है।",
    permitDocShr_deny: "मना",
    permitDocShr_allow: "अनुमति", //components - RequestDocShare
    reqDocShr_req_doc_share_access: "अनुरोध दस्तावेज़ साझा पहुंच",
    reqDocShr_access_permission_host:
      "दस्तावेज़ साझाकरण को सक्षम करने के लिए, आपको होस्ट से एक्सेस की अनुमति चाहिए।",
    reqDocShr_plz_wait: "कृपया इसके लिए प्रतीक्षा करें",
    reqDocShr_permission_start_doc_share:
      "(होस्ट) दस्तावेज़ साझाकरण शुरू करने की अनुमति।",
    reqDocShr_doc_share: "दस्तावेज़ साझा करें!", //components - ShowDocument View
    showDocViewback: "वापस",
    showDocViewdoc_title_name: "दस्तावेज़ का शीर्षक नाम",
    showDocViewnext: "आगे",
    showDocViewprevious: "पिछला", //Broadcast - //boradcastScreenShare
    borcstScreen_alert_unsupported:
      "असमर्थित प्ले ऑर्डर का अनुरोध किया गया। समर्थित प्रारूप webrtc और hls हैं। playOrder = webrtc, hls जैसे कुछ का उपयोग करें",
    borcstScreen_alert_no_stream_spec:
      "कोई स्ट्रीम निर्दिष्ट नहीं की गई। कृपया url में id = {STREAM_ID} जोड़ें",
    borcstScreen_Plz_enable_js:
      "इस वीडियो को देखने के लिए कृपया जावास्क्रिप्ट सक्षम करें, और एक वेब ब्राउज़र पर अपग्रेड करने पर विचार करें जो",
    borcstScreen_support_HTML5: "HTML5 वीडियो का समर्थन करता है",
    borcstScreen_steam_play_when_live:
      "जब यह लाइव होगा तब वीडियो स्ट्रीम चलेगा", //broadcast
    broadcast_alert_unsupported:
      "असमर्थित प्ले ऑर्डर का अनुरोध किया गया। समर्थित प्रारूप webrtc और hls हैं। playOrder = webrtc, hls जैसे कुछ का उपयोग करें",
    broadcast_alert_no_stream_spec:
      "कोई स्ट्रीम निर्दिष्ट नहीं की गई। कृपया url में id = {STREAM_ID} जोड़ें",
    broadcast_enter_your_name: "अपना नाम दर्ज करें",
    broadcast_enter_your_email: "अपना ईमेल दर्ज करें",
    broadcast_user_details: "उपयोगकर्ता की जानकारी",
    broadcast_submit_next: "प्रस्तुत",
    broadcast_Plz_enable_js:
      "इस वीडियो को देखने के लिए कृपया जावास्क्रिप्ट सक्षम करें, और एक वेब ब्राउज़र पर अपग्रेड करने पर विचार करें जो",
    broadcast_support_HTML5: "HTML5 वीडियो का समर्थन करता है",
    broadcast_steam_play_when_live: "लाइव होने पर वीडियो स्टीम बजाएगा",

    //broadcast
    broadcast_alert_unsupported:
      "असमर्थित प्ले ऑर्डर का अनुरोध किया गया। समर्थित प्रारूप webrtc और hls हैं। playOrder = webrtc, hls जैसे कुछ का उपयोग करें",
    broadcast_alert_no_stream_spec:
      "कोई स्ट्रीम निर्दिष्ट नहीं की गई। कृपया url में id = {STREAM_ID} जोड़ें",
    broadcast_enter_your_name: "अपना नाम दर्ज करें",
    broadcast_enter_your_email: "अपना ईमेल दर्ज करें",
    broadcast_user_details: "उपयोगकर्ता की जानकारी",
    broadcast_submit_next: "प्रस्तुत",
    broadcast_Plz_enable_js:
      "इस वीडियो को देखने के लिए कृपया जावास्क्रिप्ट सक्षम करें, और एक वेब ब्राउज़र पर अपग्रेड करने पर विचार करें जो",
    broadcast_support_HTML5: "HTML5 वीडियो का समर्थन करता है",
    broadcast_steam_play_when_live: "लाइव होने पर वीडियो स्टीम बजाएगा",
    //broadcastConference
    brdcstConf_whiteboard: "व्हाइटबोर्ड",
    brdcstConf_screen_share: "स्क्रीन शेयर",
    // "brdcstConf_participants" : "प्रतिभागियों",
    brdcstConf_broadcast: "प्रसारण",
    brdcstConf_right: "सही",
    //broadcast - component
    //broadcasterParicipants
    brdcstPart_broadcast_list: "ब्रॉडकास्टर सूची",
    //Containers - calender
    //index
    calender_scheduled_calendar: "शेड्यूल कैलेंडर",
    calender_select_all: "सभी का चयन करे",
    calender_calender: "पंचांग",
    calender_daily: "रोज",
    calender_weekly: "साप्ताहिक",
    calender_month: "महीना",
    calender_today: "आज",
    //Dashboard - componenet
    //MeetingReminder
    meetReminder_scheduled_confirm: "अनुसूची की पुष्टि",
    meetReminder_meeting_has_been_scheduled:
      "इस समय निम्नलिखित सत्र निर्धारित किया गया है",
    meetReminder_start_meeting: "इस सत्र की शुरुआत करें",
    meetReminder_join_meeting: "इस सत्र में शामिल हों",
    meetReminder_quick_start_another_meeting: "त्वरित प्रारंभ एक और सत्र",
    //MyMeetingItem
    myMeetItem_start: "शुरू",
    myMeetItem_for: "के लिये",
    myMeetItem_minutes: "मिनट",
    myMeetItem_host: "मेज़बान: ",
    //MyMeeting
    myMeet_my_meetings: "मेरे सत्र",
    myMeet_search_my_meetings: "मेरे सत्र खोजें",
    //NoScheduledMeeting
    noScheMeet_no_meeting_scheduled: "कोई सत्र निर्धारित नहीं",
    noScheMeet_no_upcoming_meetings:
      "आपका अभी तक कोई आगामी सत्र निर्धारित नहीं है। आप एक नया शेड्यूल बना सकते हैं या तुरंत अपना कॉन्फ़्रेंस शुरू कर सकते हैं।",
    noScheMeet_create_schedule: "शेड्यूल बनाएं",
    noScheMeet_quick_start: "जल्दी शुरू",
    noScheMeet_or: "या",
    //RoomSettings
    roomSet_alert_select_license: "कृपया लाइसेंस चुनें",
    roomSet_manage_licenses: "लाइसेंस प्रबंधित करें",
    roomSet_package: "पैकेज",
    roomSet_no_of_rooms: "कमरों की संख्या",
    roomSet_no_of_user: "उपयोगकर्ताओं की संख्या",
    roomSet_purchased_on: "पर खरीदा",
    roomSet_expired_on: "समाप्ति तिथि",
    roomSet_create_room: "जगह बनाना",
    //conference - component
    //AddSipDevice
    addSipDev_add_sip_details: "एसआईपी विवरण जोड़ें",
    addSipDev_sip_address: "सिप पता:",
    addSipDev_connect: "जुडिये",
    addSipDev_enter_sip_address: "एसआईपी पता दर्ज करें",
    //ConfNotification
    confNotf_notification: "सूचना",
    confNotf_user_name: "उपयोगकर्ता नाम",
    confNotf_want_to_join: "इस सत्र कक्ष में शामिल होना चाहता है।",
    confNotf_allow: "अनुमति",
    confNotf_deny: "मना",
    confNotf_ask_question: "एक सवाल पूछा।",
    confNotf_send_msg_lobby: "लॉबी से एक संदेश भेजा।",
    //Loddy
    lobby_participants_loddy: "प्रतिभागियों की लॉबी में",
    lobby_pramote_all: "सभी को बढ़ावा दें",
    lobby_user_name: "उपयोगकर्ता नाम",
    //RemoveUserDialog
    removeUserDlg_manage_user_selecting:
      "इनमें से कोई भी विकल्प चुनकर इस उपयोगकर्ता को प्रबंधित करें:",
    removeUserDlg_user_name: "उपयोगकर्ता नाम",
    removeUserDlg_block_participant: "ब्लॉक प्रतिभागी",
    removeUserDlg_send_to_lobby: "लॉबी को भेजें",
    removeUserDlg_remote_participant: "प्रतिभागी निकालें",
    removeUserDlg_close: "बंद करे",
    //participantsList
    PartList_participants_in_lobby: "प्रतिभागियों की लॉबी में",
    PartList_alert_something_went_wrong:
      "कुछ गलत हो गया। कृपया पुन: प्रयास करें",
    PartList_in_webinar: "वेबिनार में",
    PartList_promote_all: "सभी को बढ़ावा दें",
    //participants2020	Retry
    //WaitingRoom
    waitingRoom_waiting_room: "प्रतीक्षालय",
    waitingRoom_plz_wait_host_allow:
      "कृपया प्रतीक्षा करें जब तक कि मेजबान आपको सम्मेलन में शामिल होने की अनुमति न दे।",
    waitingRoom_chat: "चैट",
    waitingRoom_mins: "मिनट",
    waitingRoom_no_msg_yet: "संदेश नहीं, फिर भी!",
    waitingRoom_no_msg_from_host: "मेजबान से कोई संदेश नहीं।",
    //userRemoved
    userRemoved_you_removed_by_host:
      "आपको मेजबान द्वारा प्रतिभागियों की सूची से हटा दिया गया है",
    //invitationSlide
    invitSlide_invite: "आमंत्रित करें",
    invitSlide_add_email: "ईमेल जोड़ें",
    invitSlide_add: "जोड़ें",
    invitSlide_broadcast_list: "ब्रॉडकास्ट लिंक",
    invitSlide_invite_people_to_meeting:
      "लोगों को इस सत्र में आमंत्रित करें। लोगों को उनका ईमेल पता लिखकर जोड़ें और आमंत्रण भेजने के लिए सूची में जोड़ें।",
    invitSlide_err_invalid_id: "अमान्य ईमेल आईडी",
    //participantsChat
    particiChat_no_chat_msg: "अभी तक कोई चैट संदेश नहीं है!",
    particiChat_start_conversation:
      "यहां संदेश देखने के लिए वार्तालाप प्रारंभ करें।",
    //components - lobbyparticipants
    lobbyPartici_no_participants: "कोई प्रतिभागी नहीं",
    lobbyPartici_no_participants_lobby: "लॉबी में कोई प्रतिभागी नहीं हैं।",
    //conference
    //simulcast
    simulcast_alert_decline_access: "होस्ट ने पहुंच को अस्वीकार कर दिया",
    simulcast_invalid_url: "अवैध यूआरएल",
    simulcast_no_host_available:
      "इस समय कोई होस्ट उपलब्ध नहीं है, कृपया स्क्रीन साझा करने के लिए होस्ट बनें",
    //simulcastVAD & // Conference.js
    conference_access_to_participants: "प्रतिभागियों तक पहुंच",
    conference_screen_share: "स्क्रीन शेयर",
    conference_chat: "चैट",
    conference_lock_all: "सभी को बंद कर दो",
    conference_lock_conf: "ताला सम्मेलन",
    conference_become_host: "मेजबान बनें",
    conference_you_are_host: "आप मेजबान हैं",
    conference_share: "साझा करें",
    conference_document_share: "दस्तावेज़ साझा करें",
    conference_content_share: "सामग्री साझा करें",
    conference_more: "अधिक...",
    conference_become_host: "मेजबान बनें",
    conference_alert_no_host_aval_screen:
      "इस समय कोई होस्ट उपलब्ध नहीं है, कृपया स्क्रीन साझा करने के लिए होस्ट बनें",
    conference_alert_no_host_aval_doc:
      "इस समय कोई होस्ट उपलब्ध नहीं है, कृपया दस्तावेज़ को साझा करने के लिए होस्ट बनें",
    conference_alert_err_sip_device: "Sip डिवाइस कनेक्ट करते समय त्रुटि",
    conference_alert_host_decline_access: "होस्ट ने पहुंच को अस्वीकार कर दिया",
    conference_alert_invalid_url: "अवैध यूआरएल",
    conference_unmute_mic_start_talk:
      "अपने माइक्रोफोन को बात शुरू करने के लिए अनम्यूट करें",
    // tools
    confTools_new_whiteboard: "आपका नया व्हाइटबोर्ड यहां आता है",
    confTools_video_sync: "आपका वीडियो सिंक",
    confTools_microphone: "माइक्रोफ़ोन",
    confTools_type_text_here: "अपना पाठ लिखें ...",
    whiteboard: "व्हाइटबोर्ड",
    //meetingRecording
    meetRec_video_rec_meeting_name: "सत्र के नाम की वीडियो रिकॉर्डिंग",
    meetRec_page_view: "पृष्ठ का दृश्य:",
    //meetingRecording- recordinglistview
    recListView_title_name_rec: "रिकॉर्डिंग का शीर्षक नाम",
    recListView_name_user: "उपयोगकर्ता का नाम",
    // /////////////////////////////////////////////////////////////////////
    //Src
    //component - common - BrowserUpgrade
    brwUpg_req_fun_not_avail:
      "आपके ब्राउज़र में आवश्यक कार्यक्षमता उपलब्ध नहीं है",
    brwUpg_meeting_req_fun_sup:
      "इस सत्र सेवा के लिए आवश्यक है कि आपके ब्राउज़र द्वारा समर्थित कार्यात्मक नहीं।",
    brwUpg_plz_upgrade:
      "कृपया अपग्रेड करें, एक अलग ब्राउज़र में स्विच करें या अपनी सेटिंग्स जांचें। समर्थित ब्राउज़र:",
    //"    Samsung Internet
    //component - common - header - header.js
    header_content: "सामग्री",
    header_loading: "लोड हो रहा है...",
    //containers/admin/plans/components/createPlan.js
    crtePln_plz_enter_name: "कृपया योजना का नाम दर्ज करें",
    crtePln_plz_amount_Plan: "कृपया योजना की राशि दर्ज करें",
    crtePln_plz_enter_des: "कृपया विवरण दर्ज करें",
    crtePln_Plz_sel_product: "कृपया उत्पाद का चयन करें",
    crtePln_plz_sel_no_host: "कृपया मेजबानों की संख्या का चयन करें",
    crtePln_plz_enter_no_participants: "कृपया प्रतिभागियों की संख्या दर्ज करें",
    crtePln_plz_enter_roomno: "कृपया कमरों की संख्या दर्ज करें",
    crtePln_select_period: "कृपया अवधि चुनें",
    crtePln_sel_interval: "कृपया अंतराल का चयन करें",
    crtePln_update_succ: "अद्यतन सफलतापूर्ण हो गया",
    crtePln_err_creating_plan: "योजना बनाने में त्रुटि",
    //containers/broadcast/components/BroadcastHandRaise.js
    brdcRaise_alert_question_50_char:
      "आपके प्रश्न में न्यूनतम 50 वर्ण होने चाहिए",
    //containers/conference/components/components
    cofCom_no_part_lobby: "लॉबी में कोई प्रतिभागी नहीं है।",
    //containers/conference/components/ConfirmUserDetails.js
    confmUser_plz_provide_name_email: "कृपया अपना नाम और ईमेल प्रदान करें",
    confmUser_notes: "टिप्पणियाँ",
    //containers/conference/ConferenceSetup.js
    confSetup_telepresence: "टेलीप्रेजेंस",
    confSetup_alert_not_generate_meetingID:
      "सत्र आईडी जनरेट करने में सक्षम नहीं, कुछ समय बाद प्रयास करें",
    confSetup_auth_part_can_join: "केवल अधिकृत प्रतिभागी शामिल हो सकते हैं!",
    confSetup_invalid_link: "अमान्य लिंक",
    confSetup_meeting_notyet_started:
      "यह सत्र अभी शुरू नहीं हुआ है। कृपया बाद में शामिल हों!. यदि आप एक होस्ट हैं, तो कृपया इंस्टावीसी में लॉग इन करें और मीटिंग शुरू करें",
    confSetup_meeting_locked_byhost: "यह सत्र होस्ट द्वारा लॉक किया गया है",
    confSetup_meeting_notyet_started_wait_host:
      "यह सत्र अभी शुरू नहीं हुआ है। कृपया सत्र शुरू करने के लिए मेजबान की प्रतीक्षा करें!",
    //containers/conference/components/NewChat.js",
    newChat_panel_chat: "पैनल चार्ट",
    //containers/conference/libs/InstaVC.js
    instaVc_server_busy:
      "सर्वर व्यस्त है! दूसरे सर्वर को जोड़ने का प्रयास कर रहा है ...",
    //"    load-message",
    instaVc_server_busy_reload_tojoin:
      "सर्वर व्यस्त है! सम्मेलन में शामिल होने के लिए पुनः लोड करें",
    instaVc_broadcast_scr_failed: "ब्रॉडकास्ट स्क्रीन फेल",
    instaVc_broadcast_failed: "प्रसारण विफल",
    instaVc_waiting_for_host: "होस्ट वीडियो की प्रतीक्षा में",
    //containers/content/components/contentQuestionnaire/modal-create-quest-group.js
    modlCreate_plz_enter_title: "कृपया शीर्षक दर्ज करें",
    modlCreate_poll: "पोल",
    //containers/content/components/contentQuestionnaire/modal-create-poll-question.js
    mdlCretPoll_plz_enter_quest: "कृपया प्रश्न दर्ज करें",
    poll_submitted: "मतदान सफलतापूर्वक सबमिट किया गया।",
    mdlCretPoll_option_should_not_same: "विकल्प समान नहीं होने चाहिए",
    mdlCretPoll_plz_enter_option: "कृपया विकल्प दर्ज करें",
    mdlCretPoll_plz_select_type_option: "कृपया विकल्पों के प्रकार का चयन करें",
    alert_server_error: "आंतरिक सर्वर त्रुटि, कृपया पुनः प्रयास करें",
    mdlCretPoll_update_ques: "मतदान प्रश्न अपडेट करें",
    mdlCretPoll_create_ques: "प्रश्न बनाएं",
    mdlCretPoll_enter_que_here: "अपना प्रश्न यहाँ दर्ज करें",
    mdlCretPoll_end: "समाप्त",
    //containers/content/components/contentQuestionnaire/viewQuestionnaire.js
    delete_successfully: "सफलतापूर्वक मिटाया गया",
    //containers/content/components/hozContentNavBlock.js / managecontent-index.js
    // "mngContent_mngContent_content" : "सामग्री",
    // "mngContent_mngContent_participants" : "प्रतिभागियों",
    mngContent_mngContent_fav_prog_lang:
      "क्या आप पसंदीदा प्रोग्रामिंग भाषा है?",
    mngContent_mngContent_pollings: "मतदान",
    //containers/contentShare/showQuestions.js
    showQue_obtained_marks: "प्राप्त मार्क्स:",
    //containers/contentShare/viewUserScore.js
    viewUser_your_grade: "आपकी श्रेणी:",
    //containers/packages/Package.js
    package_one_host: "मैं मेजबान और",
    //"package_participants" : "प्रतिभागियों",
    // SOHO
    //"    SMB 300
    package_concurrentUser_room2: "20 समवर्ती उपयोगकर्ता - 2 कमरे",
    package_concurrentUser_room5: "30 समवर्ती उपयोगकर्ता - 5 कमरे",
    package_concurrentUser_room20: "100 समवर्ती उपयोगकर्ता - 20 कमरे",
    package_concurrentUser_room30: "200 समवर्ती उपयोगकर्ता - 30 कमरे",
    package_concurrentUser_room50: "500 समवर्ती उपयोगकर्ता - 50 कमरे",
    //containers/schedule/components/PastMeetingItem.js
    pastMeeting_rn: "आर एन",
    pastMeeting_chat_history_deleted: "चैट इतिहास सफलतापूर्वक हटा दिया गया",
    pastMeeting_past_meeting_dtls: "पिछली बैठक का विवरण",
    pastMeeting_duration: "समयांतराल:",
    pastMeeting_download_parti_atten: "प्रतिभागी और प्रतिभागी डाउनलोड करें",
    pastMeeting_download_webinar: "वेबिनार डाउनलोड करें",
    // "pastMeeting_participants" : "प्रतिभागियों",
    pastMeeting_attendees: "सहभागी",
    pastMeeting_chat_history: "बातचीत का लेखा जोखा",
    pastMeeting_recordings: "रिकॉर्डिंग",
    pastMeeting_webinar_user: "वेबिनार उपयोगकर्ता",
    pastMeeting_webinar_chat: "वेबिनार चैट",
    pastMeeting_no_participants_in_meeting: "इस सत्र में कोई प्रतिभागी नहीं!",
    pastMeeting_no_parti_attended_meeting:
      "इस सत्र में कोई भी प्रतिभागी शामिल नहीं हुआ।",
    pastMeeting_guest_list: "मेहमानों की सूची",
    pastMeeting_no_guest_in_meeting: "इस सत्र में कोई अतिथि नहीं!",
    "pastMeeting_no_guests_were_invited ":
      "इस सत्र में आमंत्रित या भाग लेने वाले कोई अतिथि नहीं थे।",
    pastMeeting_meeting_chat_history: "सत्र चैट इतिहास",
    pastMeeting_delete_all: "सभी हटा दो",
    pastMeeting_no_chat_msg_inmeeting: "इस सत्र में कोई चैट संदेश नहीं!",
    pastMeeting_no_conver_during_meeting:
      "सत्र के दौरान चैट में कोई बातचीत नहीं हुई।",
    pastMeeting_no_user_inwebinar: "इस वेबिनार में कोई उपयोगकर्ता नहीं!",
    pastMeeting_no_user_attand_webinar:
      "इस वेबिनार में शामिल होने वाले कोई उपयोगकर्ता नहीं थे।",
    pastMeeting_webinar_chat_history: "वेबिनार चैट इतिहास",
    pastMeeting_no_chat_msg_inwebinar: "इस वेबिनार में कोई चैट संदेश नहीं!",
    pastMeeting_no_conver_during_webinar:
      "वेबिनार के दौरान चैट में कोई बातचीत नहीं हुई।",
    pastMeeting_del_chat_history: "चैट इतिहास हटाएं",
    pastMeeting_delete_all_chat_history:
      "क्या आप निश्चित हैं, आप सभी चैट इतिहास को स्थायी रूप से हटाना चाहते हैं?",
    pastMeeting_delete: "हटाएँ",
    //containers/schedule/components/Schedules.js
    schedul_webinar_description: "वेबिनार विवरण",
    schedul_upload_custom_banner:
      "अपने वेबिनार कार्यक्रम के लिए एक कस्टम बैनर अपलोड करें।",
    schedul_setting: "समायोजन",
    //containers/schedule/components/SchedulesView.js
    schedulView_time: "समय",
    schedulView_edit: "संपादित करें",
    schedulView_enable_training_mode: "प्रशिक्षण मोड सक्षम करें",
    schedulView_audio_conference: "ऑडियो सम्मेलन",
    schedulView_enable_mix_video: "डिफ़ॉल्ट रूप से मिक्स वीडियो सक्षम करें",
    //class components
    //content - components - hozContentNavBlock
    // "hozConNav_content" : "सामग्री",
    //scheduleMeeting
    scheMeet_room_reserved_from: "कमरा आरक्षित से",
    scheMeet_meeting_name: "सत्र के नाम के साथ",
    //dashboard - component -Contact
    contact_alert_already_in_call:
      "आप अन्य उपयोगकर्ता को कॉल नहीं कर सकते, जब आप पहले से ही कॉल कर रहे हैं",
    contact_alert_user_offline: "उपयोगकर्ता ऑफ़लाइन",
    //dashboard - dashboard.js
    dashboard_alert_cannot_start:
      "आप सम्मेलन शुरू नहीं कर सकते, जब आप अन्य कॉल में होते हैं",
    dashboard_alert_cannot_join:
      "आप सम्मेलन में शामिल नहीं हो सकते, जब आप अन्य कॉल में होते हैं",
    dashboard_quick_start_conf: "क्विक स्टार्ट कॉन्फ्रेंस",
    dashboard_maintenance_msg:
      "कृपया ध्यान दें कि हम रूटीन के कारण 22 अप्रैल 2020 को रात 8.30 बजे से रात 8.30 बजे तक सर्वर डाउनटाइम का अनुभव करेंगे।",
    //coBrowsing
    "coBrows_host_share-video":
      "कृपया प्रतीक्षा करें! मेजबान एक वीडियो साझा करने वाला है",
    //Additionalcamera
    addCam_add_device: "डिवाइस जोडे",
    // genral same lang
    answer_list: "उत्तर सूची",
    answer: "उत्तर",
    answered: "उत्तर दिए गए",
    correct_answer: "सही उत्तर",
    please_try_again: "कृपया पुन: प्रयास करें",
    question: "सवाल",
    cancel: "रद्द करना",
    questionnaire: "प्रश्नावली",
    content: "सामग्री",
    address_book: "पता पुस्तिका",
    view: "देखना",
    rn: "आर एन",
    // new langs
    plz_enter_marks: "कृपया प्रश्न के अंक दर्ज करें",
    plz_sel_crtans: "कृपया सही उत्तर चुनें",
    truefalse_choice: "सच / गलत विकल्प",
    questionnarie: "प्रश्नावली",
    content_title: "सामग्री शीर्षक",
    media_title: "मीडिया शीर्षक",
    add_url_add: "URL पता जोड़ें ...",
    val_shuld_grtr_from_val: "मान से बड़ा होना चाहिए",
    val_shuld_grtr_grade: "मूल्य ग्रेड से अधिक होना चाहिए",
    to_val: "मान के लिए",
    enable_hand_raise: "एक वेबिनार में हाथ उठाएं / प्रश्न पूछें सक्षम करें",
    enable_waiting_room: "वेटिंग रूम सक्षम करें",
    allow_only_invite:
      "सम्मेलन में शामिल होने के लिए केवल आमंत्रितों की अनुमति दें",
    guest_login_anonymous: "अतिथि अनाम के रूप में लॉगिन कर सकते हैं",
    give_name_webinar: "अपने वेबिनार को एक नाम दें",
    Webinar: "वेबिनार",
    video_syn: "वीडियो सिंक",
    notepad: "नोटपैड",
    enable_handraise: "एक वेबिनार में हाथ उठाएं सक्षम करें",
    pastMeeting_notes: "टिप्पणियाँ",
    //new one venkatesh
    polls_list: "पोल लिस्ट",
    no_poll_assign: "अभी तक कोई पोल नहीं सौंपा गया है!",
    poll_view: "पोल व्यू",
    // new Prudhvi
    filter_block: "फ़िल्टर ब्लॉक",
    file_size: "फाइल का आकार",
    select_room: "कृपया एक कमरा चुनें",
    provide_event_name: "कृपया एक घटना का नाम प्रदान करें",
    end_time_greater_start_time: "अंत समय प्रारंभ समय से अधिक होना चाहिए!",
    invite_people_meeting: "लोगों को इस सत्र में आमंत्रित करें",
    download_ical: "डाउनलोड करें",
    download: "डाउनलोड",
    delete_meeting: "इस सत्र को हटाएं",
    room: "कमरा",
    new_event: "नयी घटना",
    end_repeat: "एंड रिपीट",
    invite_users_timezone:
      "निम्नलिखित समय के साथ उपयोगकर्ताओं को आमंत्रित करें",
    update_event: "अपडेट इवेंट",
    create_event: "कार्यक्रम बनाएँ",
    wrong_password: "गलत पासवर्ड",
    college: "कॉलेज",
    university: "विश्वविद्यालय",
    country: "देश",
    time_period: "समय सीमा:",
    currently_working_here: "वर्तमान में यहां काम कर रहे हैं",
    from: "प्रेषक:",
    to: "सेवा:",
    graduated: "स्नातक की उपाधि प्राप्त",
    enter_description: "अपना विवरण यहां दर्ज करें ...",
    concentration: "एकाग्रता",
    school: "स्कूल",
    poll_question: "मतदान प्रश्न",
    create_poll_ques: "पोल प्रश्न बनाएं",
    options: "विकल्प",
    no_ques_assigned_yet: "अभी तक कोई प्रश्न नहीं सौंपा गया है!",
    create_new_ques_click_create_ques:
      "एक नया प्रश्न बनाएँ, उपरोक्त प्रश्न बटन पर क्लिक करने के लिए",
    enter_room_name: "कृपया कमरे का नाम दर्ज करें",
    billed_annually: "* सालाना बिल किया",
    subscribe_now: "अभी ग्राहक बनें",
    group: "समूह",
    sample_webinar: "नमूना वेबिनार",
    webinar_affiliate: "सहयोगी के बारे में वेबिनार",
    webinar_one: "वेबिनार वन",
    workspace: "कार्यस्थान",
    company: "कंपनी",
    add_another: "एक और जोड़ें",

    instavc_meetinglist_cancelchanges: "परिवर्तन रद्द करें",
    instavc_package_buynowbutton: "अभी खरीदें",
    instavc_package_fullfeatures_smb: "पूर्ण विशेषताएं",
    instavc_package_billinginfo: "बिलिंग जानकारी",
    instavc_package_billinginfo_name: "नाम",
    instavc_package_billinginfo_orginazation: "Organization",
    instavc_package_biilinginfo_gstin: "जी एस टिन",
    Save: "सहेजें",
    instavc_package_billinginfo_edit: "संपादित करें",
    instavc_package_billingdetails: "बिलिंग विवरण",
    instavc_package_billingdetails_firstname: "पहला नाम",
    instavc_package_billingdetails_lastname: "अंतिम नाम",
    instavc_package_billingdetails_address: "पता",
    instavc_package_billingdetails_zip: "पिन",
    instavc_package_shippinginfo: "शिपिंग सूचना",
    instavc_package_shippinginfo_edit: "संपादित करें",
    instavc_package_shippingdetails: "परिवहन विवरण",
    instavc_package_shippingdetails_firstname: "पहला नाम",
    instavc_package_shippingdetails_lastname: "अंतिम नाम",
    instavc_package_shippingdetails_address: "पता",
    instavc_package_shippingdetails_zip: "पिन",
    instavc_package_cartsummary: "गाड़ी का संक्षिप्त विवरण",
    instavc_package_hostbase: "होस्ट आधारित लाइसेंस (लाइसेंस नाम)",
    marks: "निशान",
    asgQues_5_Marks: "(५ मार्क्स)",
    webnrDtls_webinar_list: "वेबिनार सूची",
    assignment: "असाइनमेंट",
    assignments: "कार्य",
    create_new_poll: "असाइन करना शुरू करने के लिए एक नया मतदान प्रश्न बनाएं।",
    plz_title_url: "पट्टिका दर्ज शीर्षक और यूआरएल",
    votes: "वोट",
    enter_content_title: "कृपया सामग्री का शीर्षक दर्ज करें",
    failed_result: "असफल परिणाम",
    removed_successfully: "सफलतापूर्वक निकाला गया",
    enter_duration: "कृपया अवधि दर्ज करें",
    select_questionnarie: "कृपया प्रश्नावली का चयन करें",
    no_assignments: "नो असाइनमेंट",
    create_new_assignment:
      "ऊपर असाइनमेंट बटन पर क्लिक करने के लिए एक नया असाइनमेंट बनाएँ,",
    create_assignment: "क्रिएशन बनाएँ",
    assignments_list: "असाइनमेंट लिस्ट",
    assignment_description: "असाइनमेंट विवरण",
    assignment_name: "असाइनमेंट नाम",
    update_assignment: "अपडेट असाइनमेंट",
    add_new_assignment: "नया असाइनमेंट जोड़ें",
    assignment_list: "असाइनमेंट सूची",
    assign_assignments: "असाइनमेंट असाइन करें",
    assigned_assignments_list: "निरुपित असाइनमेंट लिस्ट",
    assignment_answer: "असाइनमेंट उत्तर",
    no_assig_submitted: "अभी तक कोई असाइनमेंट प्रस्तुत नहीं किया गया है।",
    no_assig_submitted_participants:
      "अभी तक किसी भी प्रतिभागियों से कोई असाइनमेंट नहीं जमा किया गया है।",
    view_assignment: "देखें असाइनमेंट",
    assigned_participants: "असाइन किए गए प्रतिभागी",
    select_assignment: "चयन चुनें",
    fill_your_assignment: "अपना असाइनमेंट भरें",
    submit_assignment: "असाइनमेंट जमा करें",
    assignment_details: "असाइनमेंट विवरण",
    assignment_submit_success: "असाइनमेंट सफलतापूर्वक सबमिट किया गया",
    assignment_saved_success: "असाइनमेंट सफलतापूर्वक सहेजा गया",
    how_to_get_started: "शुरुआत कैसे करें।",
    create_new_room: "नया कमरा बनाएँ",
    create_room_add_participants:
      "एक नया कमरा बनाएं और प्रतिभागियों को कमरे में जोड़ें।",
    repeats_every: "हर दोहराता है",
    now: "अभी",
    Plz_enter_title_meeting: "कृपया सत्र का शीर्षक दर्ज करें",
    no_start_time: "नो स्टार्ट टाइम फाउंड",
    no_end_time: "नो एंड टाइम फाउंड",
    item_id_not_found: "आइटम आईडी नहीं मिली",
    msg_title_not_found: "संदेश शीर्षक नहीं मिला",
    plz_join_conf_clicking_link:
      "कृपया निम्नलिखित लिंक पर क्लिक करके सम्मेलन में शामिल हों",
    hi_there: "नमस्ते",
    room_permanently: "कमरा स्थायी रूप से?",
    sure_want_to_delete_participants:
      "क्या आप वाकई इस प्रतिभागी को हटाना चाहते हैं?",
    delete_participant: "प्रतिभागी हटाएं",
    add_email: "ईमेल जोड़ें",
    add_participants_to_the_room:
      "नीचे दिए गए इनपुट बॉक्स में अपना ईमेल पता टाइप करके प्रतिभागियों को इस कमरे में जोड़ें।",
    no_of_users: "उपयोगकर्ताओं की संख्या",
    edit_the_name:
      "आप नाम और इस कमरे के उपयोगकर्ताओं की संख्या को संपादित कर सकते हैं।",
    delete_room: "डिलीट रूम",
    are_you_sure_delete: "क्या आप पक्का इसे हटाना चाहते हैं",
    delete_this_room: "इस कक्ष को हटाएं",
    delete_room_will_parmanently:
      "हटाएं पर क्लिक करने से, यह कमरा स्थायी रूप से हटा दिया जाएगा।",
    enable_storage: "संग्रहण सक्षम करें",
    enable_recordings: "रिकॉर्डिंग सक्षम करें",
    enable_SIP: "एसआईपी सक्षम करें",
    addons: "ऐड-ऑन",
    expires_on: "पर समय सीमा समाप्त",
    purchased_on: "पर खरीदा",
    more_storage: "अधिक भंडार",
    total_storage: "कुल भंडार",
    storage_occupied: "भंडारण अधिकृत",
    added: "जोड़ा गया",
    open_graphs: "खुले रेखांकन",
    participant_controls: "प्रतिभागी नियंत्रण",
    "dashboard_controls ": "डैशबोर्ड नियंत्रण",
    start_meeting: "एक सत्र शुरू करें",
    join_a_meeting: "एक सत्र में शामिल हों",
    meeting_settings: "मीटिंग सेटिंग",
    videos_to_get_started: "वीडियो शुरू करने के लिए",
    if_you_are_host:
      "यदि आप एक मेजबान हैं, तो सत्र शुरू करने के लिए नीचे दिए गए बटन पर क्लिक करें",
    guest_link: "अतिथि लिंक",
    pay_now: "अब भुगतान करें",
    promo_code_apply_here: "एक प्रोमो कोड है? यहाँ लागू करें",
    per_month: "प्रति माह",
    billed_for: "बिल के लिए",
    gst_applicable:
      "सरकारी मानदंडों के अनुपालन के अनुसार, भारत में ग्राहकों के लिए अतिरिक्त 18% जीएसटी लागू होगा।",
    select_country_code: "देश कोड चुनें",
    country_code: "देश कोड",
    enter_email_id: "ईमेल आईडी दर्ज करें ...",
    downLoad_chat: "डाउनलॉड चैट",
    allow_guest_control_their:
      "अतिथि को उनके वीडियो / ऑडियो को नियंत्रित करने की अनुमति दें",
    below_list_people_invited: "नीचे आमंत्रित लोगों की सूची है",
    verification_code: "पुष्टि संख्या",
    open_link_enter_verify_code:
      "नीचे दिया गया यूआरएल लिंक खोलें, और एकीकरण के लिए अपना सत्यापन कोड दर्ज करें",
    social_media_integration: "सोशल मीडिया एकीकरण",
    integrate_social_media_platform:
      "आप सोशल मीडिया प्लेटफार्मों को एकीकृत कर सकते हैं, एक बटन पर क्लिक करके, आपको सत्यापन कोड मिलेगा, इसे एकीकरण के लिए उपयोग करें।",
    plz_enter_val_email: "कृपया वैध ईमेल दर्ज़ करें",
    record: "रिकॉर्ड",
    in_conference: "सम्मेलन में",
    password_if_any: "पासवर्ड (यदि कोई हो)",
    stop_send: "बंद करो और भेजो",
    broadcast_not_enabled_meeting: "इस सत्र के लिए प्रसारण सक्षम नहीं है",
    facebook_url: "फेसबुक युआरएल",
    enter_facebook_url: "फेसबुक आरटीएमबी युआरएल दर्ज करें ",
    add_facebook_url: "फेसबुक आरटीएमबी युआरएल जोड़ें",
    youtube_url: "यूट्यूब यूआरएल",
    enter_youtube_url: "यूट्यूब आरटीएमपी यूआरएल दर्ज करें",
    add_youtube_url: "यूट्यूब आरटीएमपी यूआरएल जोड़ें",
    register: "रजिस्टर करें",
    time_of_program: "कार्यक्रम का समय",
    date_of_program: "कार्यक्रम की तिथि",
    name_program_interested: "कार्यक्रम के इच्छुक का नाम",
    email_id: "ईमेल आईडी",
    dob: "जन्म की तारीख",
    applicant_address: "आवेदक का पता",
    qualification: "योग्यता",
    designation: "पद",
    org_name_address: "संगठन का नाम और पता",
    fullname_participant: "प्रतिभागी का पूरा नाम",
    registration_form: "पंजीकरण फॉर्म",
    thanks_submitting_data: "अपना डेटा जमा करने के लिए धन्यवाद",
    manage_content: "सामग्री प्रबंधित करें",
    API_settings: "एपीआई सेटिंग्स",
    schedule_API: "शेड्यूल एपीआई",
    image_upload_success: "छवि सफलतापूर्वक अपलोड की गई",
    less_than_10MB: "कृपया दस एमबी से कम फ़ाइल अपलोड करें",
    at_time_of_event: "घटना के समय",
    min_5: "५ मिनट पहले",
    min_10: "१० मिनट पहले",
    min_15: "१५  मिनट पहले",
    min_30: "३० मिनट पहले",
    hrs_1: "१ घंटे पहले",
    hrs_2: "२ घंटे पहले",
    day_1: "१ दिन पहले",
    day_2: "२ दिन पहले",
    jan: "जनवरी",
    feb: "फरवरी",
    mar: "मार्च",
    apr: "अप्रैल",
    may: "मई",
    jun: "जून",
    jul: "जुलाई",
    aug: "अगस्त",
    sep: "सितंबर",
    oct: "अक्टूबर",
    nov: "नवंबर",
    dec: "दिसंबर",
    mon: "सोम",
    tue: "मंगल",
    wed: "बुध",
    thu: "गुरु",
    fri: "शुक्र",
    sat: "शनि",
    sun: "रवि",
    all_day: "पूरे दिन",
    starts_ddmmyyyy: "शुरू होता है (dd / mm / yyyy)",
    ends_ddmmyyyy: "समाप्त होता है (dd / mm / yyyy)",
    ddmmyyyy: "(dd / mm / yyyy)",
    by_dayweek: "दिन/सप्ताह द्वारा",
    never: "कभी नहीँ",
    on_date: "तारीख पर",
    alert: "चेतावनी",
    multi_factor_auth: "मल्टी फैक्टर ऑथेंटिकेशन (एमएफए) सक्षम करें",
    advanced_settings: "एडवांस सेटिंग",
    verify_Otp: "सत्यापित करें",
    resend_Otp: "ओटीपी पुनः भेजें",
    otp_sent_mobile: "अपने मोबाइल नंबर पर भेजा गया ओटीपी दर्ज करें",
    update_mobile: "अपडेट मोबाइल",
    verify_mobile: "मोबाइल सत्यापित करें",
    mob_verfi_pending: "आपका मोबाइल सत्यापन लंबित है।",
    mobile_number: "मोबाइल नंबर",
    enter_Otp: "ओटीपी दर्ज करें",
    enter_mob_no: "कृपया मोबाइल नंबर दर्ज करें",
    sure_want_to_delete_rec:
      "क्या आप सुनिश्चित हैं कि रिकॉर्डिंग हटाना चाहते हैं",
    delete_recording: "रिकॉर्डिंग हटाएं",
    invalid_credentials: "अवैध प्रत्यय पत्र",
    join_conf_by_clicking_link:
      "कृपया निम्नलिखित लिंक पर क्लिक करके सम्मेलन में शामिल हों",
    hi_there: "नमस्ते,",
    valid_room_name: "कृपया मान्य कक्ष नाम दर्ज करें",
    internal_server_error: "आंतरिक सर्वर त्रुटि, कृपया पुनः प्रयास करें ",
    room_limit_exceed: "रूम लिमिट पार हो गई",
    cant_start_meeting_already_goingon:
      "आप एक सत्र शुरू नहीं कर सकते, क्योंकि एक सत्र पहले से ही चल रहा है।",

    //new
    social_integration: "सामाजिक अखण्डता",
    advanced: "उन्नत",
    add_youtube: "यूट्यूब जोड़ें",
    plugins: "प्लगइन्स",
    subtitles: "उपशीर्षक",
    view_local: "स्थानीय देखें",
    hide_local: "स्थानीय छिपाएँ",
    switch_conf_mode: "कॉन्फ़्रेंस मोड पर जाएँ",
    switch_pres_mode: "प्रस्तुतकर्ता मोड में स्विच करें",
    conference_locked: "सम्मेलन बंद",
    conference_unlocked: "सम्मेलन खुला",
    sharing_tools: "उपकरण साझा करना",
    record: "अभिलेख",
    recording: "रिकॉर्डिंग",
    plz_wait_host_shr_video:
      "कृपया प्रतीक्षा करें! होस्ट एक वीडियो साझा करने वाला है",
    supported_sources_include: "समर्थित स्रोतों में शामिल हैं",

    team_plugins: "टीम प्लगइन्स",
    open: "खुला हुआ",
    click: "क्लिक करें",
    more_app: "और ऐप",
    upload_custom_app: "कस्टम ऐप अपलोड करें",
    download_team_plugin: "टीम प्लगिन डाउनलोड करें",
    install_mng_app_microsoft_team:
      "Microsoft टीम में ऐप कैसे इंस्टॉल और प्रबंधित करें",
    microsoft_step1: "स्टेप 1: Microsoft टीमें खोलें",
    microsoft_step1_para1:
      "आरंभ करने के लिए, पहले आपको इस पृष्ठ के शीर्ष पर उपलब्ध अपने सिस्टम में टीम प्लगइन डाउनलोड करना होगा। फिर अपनी Microsoft टीम खोलें और चुनें",
    microsoft_step1_para2: " टीम ऐप्स देखने के लिए साइड नेविगेशन के विकल्प।",
    microsoft_step2: "स्टेप 2: अधिक एप्लिकेशन पर जाएं",
    microsoft_step2_para1:
      "यहां आप कुछ ऐप्स के साथ-साथ More Apps नाम का बटन भी पा सकते हैं। पर क्लिक करें",
    microsoft_step2_para2:
      "कस्टम अपलोड विकल्प और अन्य स्टोर विकल्पों के लिए आगे की जाँच करने के लिए।",
    microsoft_step3: "स्टेप 3: ऐप अपलोड करें",
    microsoft_step3_para1: "एक बार जब आप स्टोर खोलते हैं, तो आप एक पा सकते हैं",
    microsoft_step3_para2:
      " बाएं नेविगेशन में विकल्प। इस पर क्लिक करें और अपने डाउनलोड किए गए प्लगइन ऐप को यहां अपलोड करें।",
    microsoft_step4: "स्टेप 4: स्टोरेज से InstaVC ऐप को चुनें",
    microsoft_step4_para1:
      "जब विंडो संकेत देती है, तो अपने सिस्टम से InstaVC प्लगइन ऐप चुनें जो (चरण 1) में डाउनलोड किया गया था और क्लिक करें",
    microsoft_step5: "स्टेप 5: Microsoft टीमों में अपलोड किया गया ऐप",
    microsoft_step5_para1:
      "फ़ाइल अपलोड करने के बाद, यह Microsoft टीम ऐप्स सूची में अपलोड हो जाती है। इसके बाद आप ऐप को देखने और इसे टीमों में जोड़ने के लिए क्लिक कर सकते हैं।",
    microsoft_step6: "स्टेप 6: InstaVC ऐप खोलें",
    microsoft_step6_para1:
      "एक बार जब आप InstaVC ऐप पर क्लिक करते हैं, तो अब आप एक बटन के साथ प्लगइन ऐप का पूरा विवरण देख सकते हैं ",
    microsoft_step6_para2:
      "बटन इस एप्लिकेशन को Microsoft टीम में जोड़ने के लिए।",
    microsoft_step7: "स्टेप 7: Microsoft टीमों में InstaVC जोड़ा गया",
    microsoft_step7_para1:
      "अब आपके ऐप को आसान और अनुकूलन योग्य उपयोग के लिए बाईं ओर नेविगेशन पर Microsoft टीमों में जोड़ा जाएगा।",
    ddyymm: "DD/MM/YYYY",
    fill_details_for_webinar: "कृपया वेबिनार के लिए अपना पंजीकरण विवरण भरें",
    microsoft_teams: "माइक्रोसॉफ्ट टीम्स",
    microsoft_outlook: "माइक्रोसॉफ्ट आउटलुक",
    select_the_plan: "कृपया योजना का चयन करें",
    enter_company_code: "कृपया कंपनी कोड दर्ज करें",
    enter_code: "कृपया कोड दर्ज करें",
    enter_valid_coupon_code: "कृपया मान्य कूपन कोड दर्ज करें",
    coupon_alreadt_taken: "यह कूपन कोड पहले से ही लिया गया है",
    error_updating_plan: "अद्यतन योजना में त्रुटि",
    unit: "इकाई",
    referrals: "रेफ़रल",
    sel_coupon: "कृपया कूपन चुनें",
    share_val_0_99: "शेयर मान 0 से 99 के बीच होना चाहिए",
    enter_share_val: "कृपया शेयर मूल्य दर्ज करें",
    valid_commission_per: "कृपया मान्य कमीशन प्रतिशत दर्ज करें",
    enter_commission_per: "कृपया आयोग का प्रतिशत दर्ज करें",
    enter_commission_name: "कृपया आयोग का नाम दर्ज करें",
    sync_successfully: "यूज़र्स सिंक सक्सेसफुल",
    room_deleted_suc: "रूम सक्सेसफुल हटा दिया गया",
    lic_deleted_suc: "लाइसेंस सफलतापूर्वक हटा दिया गया",
    female: "महिला",
    male: "नर",
    insta_conference: "इंस्टा सम्मेलन",
    quick_meeting_by: "त्वरित सत्र द्वारा",
    in_lobby: "लॉबी में",
    switch_to_broadcast: "स्विच टू ब्रॉडकास्ट",
    Broadcasters_5: "ब्रॉडकास्टर्स (5)",
    Participants_5: "प्रतिभागी (5)",
    search_participants: "खोज प्रतिभागी",
    host_controls: "मेजबान नियंत्रण",
    deleteroom: "डिलीट रूम",
    pm: "पी एम",
    am: "ए एम",
    email_exist_inroom: "इस कमरे में पहले से मौजूद ईमेल",
    type_a_message: "एक संदेश लिखें...",
    please_enter_user_limit: "कृपया उपयोगकर्ता सीमा दर्ज करें",
    user_limit_exceeded: "उपयोगकर्ता सीमा पार हो गई है",
    sel_country_code: "कृपया देश कोड चुनें",
    available_storage: "उपलब्ध भंडार",
    enter_phone_number: "फोन नंबर दर्ज",
    startdate_less_enddate: "कृपया अंतिम तिथि से कम प्रारंभ तिथि चुनें",
    havent_add_data: "आपने अभी तक कोई डेटा नहीं जोड़ा है, कृपया डेटा जोड़ें।",
    professional_skills: "व्यावसायिक कौशल",
    enter_prof_skills: "पेशेवर कौशल दर्ज करें",
    Present_Invitations: "वर्तमान निमंत्रण",
    sending: "भेजना...",
    sent: "भेज दिया",
    invite_10ppl_only: "आप केवल 10 लोगों को आमंत्रित कर सकते हैं",
    join_meeting: "सत्र में शामिल हों",
    enter_doc_title: "दस्तावेज़ शीर्षक दर्ज करें",
    meeting_name: "सत्र का नाम",
    select_the_weeks: "कृपया सप्ताह का चयन करें",
    grade: "ग्रेड",
    conference_ID: "सम्मेलन आईडी ...",
    dont_find_room_meetingid:
      "हमें ऐसा कोई कमरा नहीं मिला, जो इस सत्र आईडी से जुड़ा हो",
    wireless_share: "वायरलेस शेयर",
    video_layout: "वीडियो लेआउट",
    speaker_screen: "स्पीकर स्क्रीन",
    presentation_screen: "प्रस्तुति स्क्रीन",
    multiple_display: "मल्टीपल डिस्प्ले",
    hellow: "हैलो",
    enter_passcode: "पासकोड दर्ज करें",
    another_meeting_stillon:
      "एक और सत्र अभी चल रहा है, आप इस सत्र को अभी शुरू नहीं कर सकते हैं",
    SIP_device: "एस आई पी डिवाइस",
    instavc_whiteBoard: "इंस्टावीसी व्हाइटबार्ड",
    speaker: "वक्ता",
    instavc_notepad: "इंस्टावीसी नोटपैड",
    promote_in: "में बढ़ावा",
    guest: "अतिथि",
    breakout_rooms: "ब्रेकआउट रूम",
    stop_broadcast: "स्टॉप ब्रॉडकास्ट",
    noise_suppress: "शोर का अवरोध",
    echo_cancel: "गूंज रद्दीकरण:",
    enter_name_here: "यहाँ नाम दर्ज करें",
    Viewer: "दर्शक",
    SIP_user: "एस आई पी उपयोगकर्ता",
    remove_participants: "प्रतिभागियों को निकालें",
    disable_audio_video: "दूरस्थ ऑडियो और वीडियो अक्षम करें",
    disable_audio: "ऑडियो अक्षम करें",
    enable_audio: "ऑडियो सक्षम करें",
    disable_video: "वीडियो अक्षम करें",
    enable_video: "वीडियो सक्षम करें",
    audio_video: "ऑडियो & वीडियो",
    audio_only: "सिर्फ़ ध्वनि",
    video_only: "वीडियो केवल",
    outlook_addins: "आउटलुक ऐड-इन्स",
    install_microsoft:
      "माइक्रोसॉफ्ट आउटलुक में ऐड-इन्स को कैसे स्थापित करें और प्रबंधित करें",
    outlook_step1: "चरण 1: कॉपी लिंक और आउटलुक खोलें",
    first_copy_link: "पहले लिंक को कॉपी करें",
    add_plugin_oulook: "अपने दृष्टिकोण में प्लगइन जोड़ने के लिए यहां से।",
    outlook_step2: "चरण 2: ऐड-इन्स प्राप्त करें",
    outlook_step2_para:
      "अब ओपन आउटलुक और होम टैब के तहत आप एक विकल्प पा सकते हैं ऐड-इन्स। ऐड-इन्स और अन्य कस्टम देखने के लिए इस पर क्लिक करें।",
    outlook_step3: "चरण 3: मेरा ऐड-इन्स",
    outlook_step3_para:
      "अब आप बाएँ नेविगेशन के साथ ऐड-इन्स पेज देख सकते हैं। अपने ऐड-इन्स को प्रबंधित करने के लिए मेरे ऐड-इन्स पर जाएँ।",
    outlook_step4: "चरण 4: कस्टम ऐड-इन्स जोड़ें",
    outlook_step4_para:
      "यहां आप मेरे ऐड-इन्स पेज में कस्टम ऐड-इन के तहत एक ड्रॉपडाउन कस्टम ऐड-इन पा सकते हैं। ड्रॉप डाउन से URL से ऐड चुनें।",
    outlook_step5: "चरण 5: यूआरएल से निजी ऐड-इन जोड़ें",
    outlook_step5_para:
      "अब आप यूआरएल से निजी एड-इन जोड़ने के लिए एक पॉप अप देख सकते हैं। अब आप इनपुट चरण में (चरण 1) में कॉपी किए गए लिंक को पेस्ट करें और ओके पर क्लिक करें, जो ऐड-इन को आउटलुक में स्थापित करता है।",
    outlook_step6: "चरण 6: मेरे ऐड-इन्स में इंस्टावीसी जोड़ा गया",
    outlook_step6_para:
      "जोड़ने के बाद, आप अपने मेरे ऐड-इन्स सूची में ऐड की जाँच कर सकते हैं। यहाँ से आप अपने ऐड-इन्स को और प्रबंधित कर सकते हैं,",
    outlook_step7: "चरण 7: आउटलुक को बंद करें और फिर से खोलें",
    outlook_step7_para:
      "स्थापित करने के बाद, सुनिश्चित करें कि आपने एक बार पूरा आउटलुक बंद कर दिया है और ऐड-इन को देखने के लिए फिर से खुला है।",
    outlook_step8: "चरण 8: नई वस्तुओं पर जाएं",
    outlook_step8_para:
      "आउटलुक खोलने के बाद, अब आप नई मीटिंग्स में जा सकते हैं; इंस्टावीसी को आउटलुक में ऐड में देखने के लिए मीटिंग करना;",
    outlook_step9: "चरण 9: ओपन इंस्टावीसी मीटिंग",
    outlook_step9_para:
      "जब आप मीटिंग खोलते हैं, तो आप मीटिंग टैब के तहत टॉप बार में इंस्टावीसी मीटिंग ऐड-इन सक्षम के साथ एक कंपोज़ मेल विंडो के साथ खोले जाएंगे।",
    outlook_step10: "चरण 10: अनुसूची बनाएँ",
    outlook_step10_para:
      "कंपोज़ मेल लेआउट से, एक नया शेड्यूल बनाने के लिए इंस्टावीसी मीटिंग्स पर क्लिक करें। आपको पहली बार इंस्टावीसी मीटिंग लॉग इन के साथ खोला जाएगा यदि यह पहली बार है। पहले से लॉग इन करने वाले उपयोगकर्ताओं के लिए, उन्हें निर्देशित किया जाएगा। कमरे की सूची और एक कार्यक्रम बना सकते हैं। ",
    outlook_step11: "चरण 11: इंस्टा मीटिंग खोलें",
    outlook_step11_para:
      "आप बाईं ओर एक शेड्यूल बना सकते हैं और किसी विशेष कमरे में मीटिंग शेड्यूल करने के लिए दाईं ओर एक कमरे का चयन कर सकते हैं। एक बार शेड्यूल बनाने के बाद, आप स्टार्ट मीटिंग बटन को देख सकते हैं। यहाँ से आप क्लिक कर सकते हैं और मीटिंग शुरू कर सकते हैं। । ",
    outlook_step12: "चरण 12: कैलेंडर में अनुसूची देखें",
    outlook_step12_para:
      "जब आप शेड्यूल बना लेते हैं, तो अगली बार जब आप कैलेंडर खोलते हैं, तो आप कैलेंडर में भी अपना शेड्यूल देख सकते हैं।",
    outlook_step13: "चरण 13: कार्यक्रम बनाया गया",
    outlook_step13_para:
      "एक बार जब आप एक शेड्यूल बनाते हैं, तो आप दाईं ओर एक स्टार्ट मीटिंग बटन के साथ बना हुआ मेल देख सकते हैं।",
    sel_declaration: "कृपया घोषणा का चयन करें",
    enter_company_code: "कृपया कंपनी कोड दर्ज करें",
    invalid_company_code: "अमान्य कंपनी कोड",
    affiliate_acc: "आपका संबद्ध खाता अनुमोदन लंबित है।",
    aff_acc_approved: "आपका संबद्ध खाता स्वीकृत है।",
    aff_acc_rej: "आपका संबद्ध खाता अस्वीकार कर दिया गया है।",
    aff_TC: "संबद्ध नियम और शर्तें",
    ref_par_agreement: "रेफरल पार्टनर अग्रीमेंट",
    aff_partner_agreement:
      'यह पार्टनर एग्रीमेंट, जिसमें यह कवर पेज और संलग्न व्यापार शर्तें (सामूहिक रूप से, यह "एग्रीमेंट") शामिल है, पीपुलिंक यूनिफाइड कम्युनिकेशंस प्राइवेट लिमिटेड (पीपुललिंक के रूप में संदर्भित) और "पार्टनर" या "आप" के बीच में बनाया और दर्ज किया गया है। "। "पार्टनर" या "आप" का अर्थ है व्यक्ति या कंपनी (कंपनी का नाम और अन्य जानकारी सहित) में प्रस्तुत प्रपत्र में विस्तृत। एक बार जब आप पूरा कर लेंगे तो समझौता बाध्यकारी हो जाएगा और इस समझौते की आपकी स्वीकृति को इंगित करने के लिए रेफरल पार्टनर प्रोग्राम फॉर्म ("फॉर्म") सबमिट करें। पीपुललिंक और पार्टनर को कभी-कभी "पार्टी" के रूप में संदर्भित किया जाता है, और साथ में "पार्टीज़" के रूप में।',
    background: "पृष्ठभूमि",
    aff_market_advertise:
      'पीपुललिंक इंस्टावीसी यूनिफाइड कम्युनिकेशन सर्विसेज और सॉल्यूशंस प्रदान करता है। पार्टनर इस समझौते के अनुसार, पीपुललिंक उत्पादों और संभावित पीपुललिंक ग्राहकों ("रेफ़रल") को अपनी वेबसाइट (एस) और अन्य मार्केटिंग चैनलों के माध्यम से बढ़ावा देने, बाजार और विज्ञापन देने की इच्छा रखता है। ',
    agreement: "अनुबंध",
    aff_parties_agree: "दल इस प्रकार सहमत हैं:",
    heading1: "कार्यक्रम समिति",
    heading2: "त्वरित संदर्भ, प्रतिबद्धताएं।",
    heading3: "अवधि और समापन।",
    heading4: "सामान्य",
    the_program: "कार्यक्रम। ",
    to_participate_program_partner:
      'प्रोग्राम पार्टनर में भाग लेने के लिए पीपुललिंक या इससे जुड़ी वेबसाइटों ("साइट") पर पाए जाने वाले प्रोग्राम में भाग लेने के लिए ऑनलाइन आवेदन पूरा करना होगा और इस समझौते को दर्ज करना होगा। पीपुललिंक अपने विवेकाधिकार पर किसी भी आवेदन को स्वीकार या अस्वीकार कर सकता है। ',
    aff_str11: "कानूनी समझौते।",
    aff_str12: "पदोन्नति, रेफरल गतिविधियाँ:",
    aff_str13: "निषिद्ध गतिविधियाँ।",
    aff_str14: "पीपुललिंक मार्क्स का स्वीकार्य उपयोग",
    aff_str15: "उत्तरदायित्वों।",
    aff_str16: "ग्राहक संबंध।",
    aff_str11_para:
      "कार्यक्रम में अपनी भागीदारी और पीपुललिंक के साझेदार के रूप में कार्य करने के दौरान, साथी इस समझौते और कार्यक्रम, दिशानिर्देश, और किसी अन्य अनुरोध और नियमों के बारे में सहमति और सहमति देता है, जो समय-समय पर पीपुललिंक द्वारा निर्धारित किए जाते हैं, उचित विवेक, कार्यक्रम में पीपुल्सलिंक उत्पादों, समाधानों और सेवा को रेफरल को बढ़ावा देने के लिए भागीदार की जारी भागीदारी के संबंध में। इस समझौते के तहत अपनी सभी गतिविधियों में, और इस तरह की विशिष्ट गतिविधियां जो पार्टनरलिंक के प्रचार को बढ़ावा देने से संबंधित हैं, पार्टनर लोगलिंक और के साथ सहयोग करेंगे। अच्छे विश्वास में कार्य करें। इस अनुबंध में प्रवेश करने से, साथी पीपुललिंक की सेवा की शर्तों में निर्धारित नियमों और नियमों को और अधिक पहचानता है और स्वीकार करता है, ",
    aff_str12_para:
      "भागीदार लाइसेंस प्राप्त मार्क और मार्केटिंग सामग्री का उपयोग करके विभिन्न मार्केटिंग चैनलों में पीपुलिंक प्रोडक्ट्स एंड सॉल्यूशंस के निरंतर, सक्रिय प्रचार में संलग्न होने के लिए सहमत है, और इस समझौते की शर्तों के अनुपालन में ऐसा करते हैं।",
    aff_str13_para:
      'पार्टनर मार्केटिंग मटीरियल्स को ऐसी सामग्री के साथ नहीं जोड़ने के लिए सहमत होता है जो किसी भी तरह से गैरकानूनी हो, या जो अन्यथा हानिकारक, धमकी, बदनामी, अश्लील, अपमानजनक, यौन रूप से स्पष्ट, हिंसक, भेदभावपूर्ण, या अन्यथा पीपुलिंक के एकमात्र विवेक में आपत्तिजनक हो। पार्टनर पीपुलिंक सेवाओं और समाधानों को बढ़ावा देने के लिए कई असंबंधित प्राप्तकर्ताओं ("स्पैमिंग") को अवांछित इलेक्ट्रॉनिक संदेश नहीं भेजने के लिए सहमत है, या अन्यथा इस समझौते के तहत विचार की गई गतिविधियों के संबंध में कानून द्वारा निषिद्ध सामूहिक इलेक्ट्रॉनिक संचार के किसी अन्य रूप में संलग्न करने के लिए। ',
    aff_str14_para1:
      "भागीदार स्पष्ट रूप से लाइसेंस प्राप्त मार्क्स का उपयोग करने और विपणन सामग्री बनाने में सभी शर्तों का पालन करने के लिए सहमत है।",
    aff_str14_para2:
      "दिशानिर्देशों और अन्यथा के माध्यम से, पीपुलिंक मार्केटिंग सामग्री बनाने और पीपुलिंक सेवा को बढ़ावा देने में लाइसेंस प्राप्त चिह्नों के भागीदार के अनुमेय उपयोग के रूप में समय-समय पर विनिर्देशों और अन्य निर्देश प्रदान करेगा। साथी ऐसे सभी विनिर्देशों और निर्देशों का पालन करने के लिए सहमत है।",
    aff_str14_para3:
      "भागीदार यह सुनिश्चित करेगा कि उसके विपणन सामग्रियों पर प्रदर्शित होने वाले सभी लाइसेंस प्राप्त मार्क दिशानिर्देशों में पीपुलिंक द्वारा अनुमोदित रूप में हैं या अन्यथा, किसी भी पीपुलिंक मार्क्स को संशोधित नहीं करेंगे या अन्यथा पीपुलिंक द्वारा प्रदान किए गए उचित निर्देशों के विपरीत अन्य मार्केटिंग सामग्री को संशोधित करेंगे, और आगे भी करेंगे। मार्केटिंग सामग्री के रूप, सामग्री और प्रदर्शन के रूप में पीपुलिंक से उचित निर्देशों का पालन करें। किसी भी कारण से इस समझौते को समाप्त करने पर, या पीपुलिंक के लिखित अनुरोध पर, यहां दिया गया लाइसेंस समाप्त हो जाएगा और साथी तुरंत अपनी गतिविधियों को समाप्त कर देगा। यह अनुबंध।",
    aff_str15_para:
      "इस अनुबंध के तहत अभिनय में अपने संचालन के लिए भागीदार पूरी तरह से जिम्मेदार होगा, जिसमें बिना किसी सीमा के, साझेदार के संचालन और सामग्रियों की वैधता शामिल है, जो इस समझौते के संबंध में बनाई और उपयोग की जाती है। एक दावे के अलावा, यह आरोप लगाते हुए कि पीपुलिंक मार्क किसी तीसरे पक्ष का उल्लंघन करता है। ट्रेडमार्क अधिकार, पीपुलिंक भागीदार की मार्केटिंग सामग्री के विकास, संचालन या सामग्री के लिए ज़िम्मेदार नहीं है और भागीदार किसी भी दावे, कार्यों, कार्रवाई के कारणों, क्षति या व्यय (अटॉर्नी शुल्क सहित) के खिलाफ हानिरहित, बचाव, क्षतिपूर्ति और पकड़ के लिए सहमत है। साझेदार की मार्केटिंग सामग्री का विकास, संचालन, सामग्री और रखरखाव। ",
    aff_str16_para:
      "टर्म के दौरान और बाद में,पीपुललिंक सेवा के संबंध में पीपुलिंक और रेफरल के बीच साझेदार के माध्यम से बनाए गए सभी संबंधों का अनन्य स्वामी होगा, जिसमें पीपुलिंक सेवा के उपयोग के लिए पीपुलिंक के साथ अनुबंध करने वाले किसी भी और सभी जानकारी की पहचान करना शामिल है। शर्तें, गोपनीयता नीति, और पीपुलिंक सेवा के लिए पीपुलिंक के नियम और प्रक्रियाएं इन रेफ़रल पर लागू होंगी और पीपुलिंक द्वारा पूर्व सूचना के बिना पार्टनर को बदला जा सकता है, और पार्टनर शर्तों के तहत पीपुलिंक के साथ अपने संबंधों की प्रकृति को बताने के लिए सहमत होता है। ",
    aff_str20_para1:
      "पार्टनर द्वारा पीपुलिंक में संदर्भित किया गया है और जो नीचे धारा 3 (बी) में वर्णित प्रक्रिया के अनुसार साइन-अप प्रक्रिया को पूरा करते हैं,",
    aff_str20_para2:
      "जिनके पास पीपुललिंक का पीपुललिंक सेवा के संबंध में कोई रिकॉर्ड नहीं है, या जो नहीं हैं, उस समय पीपुललिंक द्वारा पार्टनरलिंक, किसी भी अनुबंध संबंधी संबंधों में या पीपुललिंक सेवा के संबंध में पीपुललिंक के साथ चल रही बातचीत के संबंध में;",
    aff_str20_para3:
      "जो शर्तों को स्वीकार करते हैं और प्राप्त करते हैं, रेफरल के स्वयं के विवेक पर और साथी से कोई मौद्रिक या अन्य प्रोत्साहन प्राप्त किए बिना, पीपुललिंक वेबसाइटों या अन्यथा (मैंवी) पर सूचीबद्ध किसी भी निम्नलिखित पीपुललिंक सेवा योजना के बंडल के कम से कम वार्षिक सदस्यता को अस्वीकार नहीं किया जाता है। पीपुललिंक द्वारा, और पीपुललिंक सेवा प्राप्त करने के लिए कम से कम एक भुगतान (वार्षिक प्रीपे) या तीन भुगतान (वार्षिक अवधि, मासिक बिलिंग) करें। ",
    aff_str21: "रेफरल प्रक्रिया।",
    aff_str22: "कमीशन। जिम्मेदारियां।",
    aff_str221: "सन्दर्भ शुल्क।",
    aff_str222: "एक रेफरल से चल रही बिक्री",
    aff_str223: "संबद्ध शुल्क।",
    aff_str23: "बिक्री / कमीशन रिपोर्ट।",
    aff_str21_para:
      "पार्टनरलिंक के लिए पीपुललिंक द्वारा उपलब्ध कराए गए ऑनलाइन यूआरएल के माध्यम से प्रत्येक रेफरल को पीपुललिंक को पार्टनर द्वारा संदर्भित किया जाएगा, लोगफ्रिंक सभी रेफरल को बिक्री प्रक्रिया के लिए जिम्मेदार होगा, पार्टिस के अधीन रेफरल को बिक्री प्रक्रिया को बढ़ावा देने के लिए अच्छा-विश्वास सहयोग जारी रहा। ",
    aff_str22_para:
      "पीपुललिंक, रेफरल से सीधे पीपुललिंक सेवा के लिए रेफरल से सभी शुल्क एकत्र करेगा।",
    aff_str22_para1:
      "एक रेफरल पर एक योग्य रेफरल बनने पर, पीपुललिंक भागीदार रेफरल फीस का भुगतान सूचीबद्ध सूची के आधार पर बकाया में करेगा",
    aff_str22_para12:
      "(किसी भी छूट को छोड़कर) योग्य रेफरल द्वारा देय। इस तरह के रेफरल शुल्क देय हो जाएंगे और भुगतान सेवा शुरू होने की तारीख से लगभग (<जोड़ना) नब्बे (90) दिनों के भीतर भुगतान किया जाता है, भुगतान दायित्वों को प्राप्त किया जाता है।",
    aff_str22_para2:
      "- पार्टनर को एक योग्य रेफरल से अतिरिक्त बिक्री के लिए रेफरल फीस प्राप्त होगी जो रेफरल शुरू होने की तारीख के पहले 90 दिनों के भीतर होती है।",
    aff_str22_para3:
      "भागीदार सभी करों, कर्तव्यों, सरकारी शुल्कों और रेफरल शुल्क पर लगाए गए शुल्कों जैसे अन्य के भुगतान के लिए जिम्मेदार होगा, और साथी पीपुललिंक से किसी भी तरह के दावों से संबंधित या उससे संबंधित किसी भी दावे के खिलाफ, बिना किसी क्षति के, क्षतिपूर्ति, बचाव और पकड़ बनाए रखेगा। रेफरल शुल्क का भुगतान। ",
    aff_str23_para:
      "पीपुललिंक अपने ऑनलाइन डैशबोर्ड रिपोर्ट में पार्टनर को बिक्री की गतिविधियों और उसके आयोगों को रेफ़रल से प्राप्त योग्यताधारी रेफ़रल के लिए सारांशित करने के लिए प्रदान करेगा। पीपुललिंक रेफ़रल और क्वालिफाइड रेफ़रल के बारे में नाम या अन्य व्यक्तिगत जानकारी प्रकट नहीं करेगा।",
    aff_str31: "प्रारंभिक अवधि।",
    aff_str32: "नवीकरण अवधि।",
    aff_str33: "अर्ली टर्मिनेशन .आउट कॉज़।",
    aff_str34: "कारण के लिए।",
    aff_str35: "समाप्ति का प्रभाव।",
    aff_str31_para:
      'यह अनुबंध प्रभावी तिथि के रूप में प्रभावी हो जाएगा और तब तक (12) महीनों तक जारी रहेगा ("प्रारंभिक अवधि"), जब तक कि पीपुललिंक कार्यक्रम में भाग लेने के लिए भागीदार के आवेदन को अस्वीकार नहीं करता है,',
    aff_str32_para:
      'प्रारंभिक अवधि की समाप्ति के बाद, यह अनुबंध बारह (12) महीने (प्रत्येक, "नवीनीकरण अवधि") के अतिरिक्त लगातार शर्तों के लिए स्वचालित रूप से नवीनीकृत किया जाएगा, जब तक कि कोई पार्टी दूसरे पक्ष को कम से कम तीस में समाप्ति की लिखित सूचना नहीं देती है। प्रारंभिक अवधि या किसी भी नवीकरण अवधि के अंत से पहले 30) दिन। ',
    aff_str33_para:
      "पीपुललिंक को किसी भी समय या किसी भी कारण से इस समझौते को समाप्त करने का अधिकार होगा, पार्टनर को पांच (5) दिन पूर्व लिखित सूचना देकर।",
    aff_str34_para:
      "या तो पार्टी किसी भी समय इस समझौते को समाप्त कर सकती है, इस समझौते को भौतिक रूप से भंग करने वाले दूसरे पक्ष को लिखित नोटिस पर प्रभावी रूप से, बशर्ते कि इस समझौते को समाप्त करने से पहले समाप्त करने वाली पार्टी ऐसी सामग्री उल्लंघन और तीस (30) की लिखित सूचना प्रदान करेगी। ब्रीचिंग पार्टी के लिए इस तरह के ब्रीच को ठीक करने का दिन। ",
    aff_str35_para:
      "इस अनुबंध की समाप्ति की तारीख से इस समझौते के तहत भागीदार के अधिकार समाप्त हो जाएंगे, और साथी इस समझौते के तहत किसी भी रेफरल शुल्क या किसी अन्य भुगतान प्राप्त करने का हकदार नहीं होगा, इसके अलावा कमीशन या भुगतान अर्जित या इसके समाप्त होने से पहले अर्जित किए गए। करार। ",
    aff_str41: "असाइनमेंट।",
    aff_str42: "बौद्धिक संपदा अधिकार।",
    aff_str43: "कोई त्याग नहीं।",
    aff_str44: "सीमित वारंटी।",
    aff_str45: "वारंटी का अस्वीकरण।",
    aff_str46: "दायित्व की सीमा।",
    aff_str47: "स्वतंत्र ठेकेदारों।",
    aff_str48: "क्षतिपूर्ति करना।",
    aff_str49: "अप्रत्याशित घटना।",
    aff_str410: "संपूर्ण समझौता; संवेदनशीलता।",
    aff_str411: "प्रतिपक्ष; नोटिस;",
    aff_str412: "शासी कानून; क्षेत्राधिकार; विवाद समाधान।",
    aff_str41_para:
      "पीपुललिंक किसी भी समय इस समझौते को सौंप सकता है। साथी इस समझौते को पीपुल्सलिंक की पूर्व लिखित सहमति के बिना असाइन या हस्तांतरित नहीं कर सकता है, ऐसी सहमति को अनुचित रूप से रोक नहीं सकता है।",
    aff_str42_para:
      "सभी बौद्धिक संपदा अधिकार (जैसे कि ट्रेडमार्क, व्यापार नाम, लोगो, पेटेंट, कॉपीराइट, डोमेन नाम और व्युत्पन्न अधिकार) तक सीमित नहीं हैं। और पीपुललिंक और उसकी अनुषंगी कंपनियों की अनन्य संपत्ति बनी रहेगी। लाइसेंस्ड मार्क्स का उपयोग करने का साझीदार का अधिकार पीपुल्सलिंक के विवेक पर है और इस समझौते, दिशानिर्देशों और सभी लागू कानूनों और विनियमों के साथ भागीदार के अनुपालन के अधीन है। सहमत (क) किसी भी तरीके से किसी भी पीपुललिंक आईपी अधिकारों का उपयोग नहीं करते हैं इस समझौते को भंग करने की संभावना है, (ख) किसी भी पीपुललिंक आईपी अधिकार से लड़ने या बिगाड़ने के लिए कुछ भी नहीं करते हैं; (ग) किसी भी बौद्धिक संपदा अधिकार नहीं बनाते हैं या प्राप्त करते हैं (जैसे लेकिन ट्रेडमार्क, व्यापार नाम, लोगो, पेटेंट, कॉपीराइट, डोमेन नाम और व्युत्पन्न अधिकार) तक सीमित नहीं है जो कि किसी भी पीपुललिंक आईपी अधिकार के समान हैं; (डी) तुरंत नोटी fy किसी भी पीपुललिंक आईपी अधिकारों के किसी भी अनधिकृत उपयोग के पीपुललिंक, जिसमें साथी को वास्तविक ज्ञान है; और (कोई भी) हमेशा दिशानिर्देशों के अनुपालन में लाइसेंस प्राप्त मार्क्स और किसी भी अन्य पीपुललिंक मार्क्स का उपयोग करें। पीपुललिंक पार्टनर द्वारा प्रस्तुत किसी भी मार्केटिंग सामग्री की समय-समय पर समीक्षा कर सकती है, और पार्टनर द्वारा प्रस्तुत किसी भी मार्केटिंग सामग्री को हटाने और / या संशोधन करने का आदेश देने का अनन्य अधिकार और विवेक होगा। ",
    aff_str43_para:
      "इस समझौते के किसी भी प्रावधान के दूसरे पक्ष के सख्त प्रदर्शन को लागू करने में पार्टी की विफलता, इस तरह के प्रावधान या इस समझौते के किसी अन्य प्रावधान को लागू करने के पहले पार्टी के अधिकार की छूट का गठन नहीं करेगी।",
    aff_str44_para:
      "दोनों पक्षों ने वारंट किया कि कार्यकाल के दौरान वे सभी लागू कानूनों, विनियमों, व्यवहार संहिता, साथ ही साथ इस समझौते, शर्तों, गोपनीयता नीति और दिशानिर्देशों का पालन करेंगे। कार्यकाल के दौरान और किसी भी कारण से इसकी समाप्ति के बाद। , पार्टनर स्पष्ट रूप से ऐसा कुछ भी नहीं करने की उम्मीद करता है, जो संभावित रूप से पीपुललिंक के व्यवसाय, हितों या प्रतिष्ठा को नुकसान पहुंचा सकता है और पीपुललिंक, उसके प्रतिनिधियों या पीपुललिंक सेवा के संबंध में कोई भी अपमानजनक टिप्पणी करने, प्रकाशित करने या बनाने या प्रकाशित करने की अनुमति नहीं देगा। ",
    aff_str45_para:
      "पिछली उपधारा (e) के तहत पीपुललिंककी एक्सप्रेस वारंटी के अलावा, पीपुललिंक किसी भी प्रकार की कोई अन्य वारंटी, एक्सप्रेस या निहित, नहीं देता है और पीपुललिंक किसी भी वारंटी और शर्तों को स्पष्ट रूप से अस्वीकार करता है, जिसमें शामिल हैं, लेकिन व्यापारी योग्यता, किसी भी फिटनेस के लिए सीमित वारंटी के लिए सीमित नहीं है। विशेष उद्देश्य, उपलब्धता, सुरक्षा, शीर्षक, और / या इस समझौते के विषय के गैर-उल्लंघन। ",
    aff_str46_para:
      "न तो पीपुललिंक और न ही कोई अधिकारी, कर्मचारी, निर्देशक या पीपुललिंक का कोई अन्य प्रतिनिधि इस अनुबंध या अनुबंध, पूर्व-अनुबंध, यातना या अन्यथा के लिए इस अनुबंध या इसके समापन के संबंध में भागीदार के प्रति या किसी तीसरे पक्ष के प्रति उत्तरदायी होगा। i) किसी भी आर्थिक नुकसान (राजस्व, लाभ, अनुबंध, व्यवसाय या प्रत्याशित बचत की हानि सहित) या (ii) सद्भावना या प्रतिष्ठा का कोई नुकसान। ऐसे नुकसान में बिना किसी विशेष, अप्रत्यक्ष, आकस्मिक, सांविधिक, दंडात्मक या परिणामी शामिल हैं। नुकसान या क्षति के साथ-साथ संचालन में रुकावट के कारण होने वाली कोई भी क्षति या क्षति। किसी भी अन्य परिस्थितियों या समझ के बावजूद पार्टियों के बीच कोई संबंध नहीं, इस समझौते के तहत भागीदार के लिए पीपुल्स लिंक की पूरी देयता INR से अधिक नहीं होगी (भारतीय रुपये एक हजार केवल) और इस समझौते के तहत साझेदार द्वारा किए गए किसी भी प्रकार के नुकसान के लिए सभी दावे, और इस समझौते में प्रवेश करने से साथी की सीमाओं को पहचानता है n पीपुललिंक का दायित्व। ",
    aff_str47_para:
      "यहां की पार्टियां स्वतंत्र ठेकेदार के रूप में अपनी ओर से कार्य करती हैं। इस समझौते में कुछ भी इस समझौते में तय किए गए संबंधों से परे पार्टियों के बीच कोई भी संयुक्त उद्यम, एजेंसी, मताधिकार, बिक्री प्रतिनिधि, रोजगार या कोई अन्य संबंध नहीं बनाएगा और साथी है पीपुललिंक की ओर से अभिनय करने के लिए स्पष्ट रूप से शुरुआत की गई। इस समझौते के तहत लाइसेंस प्राप्त मार्क्स के साथी का प्रदर्शन, साझेदार द्वारा प्रस्तुत की गई अन्य सामग्री, या पार्टनर और तीसरे पक्ष के बीच संपर्क, यहां वर्णित संबंधों को गलत ढंग से प्रस्तुत नहीं करेगा। ",
    aff_str48_para:
      'पार्टनर पीपुललिंक और उसकी सहायक कंपनियों, सहयोगी, अधिकारियों और कर्मचारियों ("लोगलिंक की क्षतिपूर्ति की गई पार्टियाँ ") की निंदा, बचाव और पकड़ करेगा (किसी भी लागत, देनदारियों, नुकसान और खर्चों के खिलाफ), जो कि उचित वकीलों की फीस तक सीमित नहीं हैं किसी भी तीसरे पक्ष द्वारा किसी भी पार्टी, क्षतिपूर्ति, कार्यवाही, मांग या कार्यवाही के लिए लाया गया, जो निम्नांकित में से किसी से उत्पन्न होने वाली क्षतिपूर्ति वाली पार्टियों के विरुद्ध है: (i) साथी द्वारा समझौते का उल्लंघन; (ii) साथी या उसके कर्मचारियों, एजेंटों या ठेकेदारों की लापरवाही, घोर लापरवाही या इच्छाधारी दुराचार; या (iii) भागीदार या उसके कर्मचारियों, एजेंटों, ठेकेदारों द्वारा विफलता या संदर्भित कानून और विनियमों के अनुपालन के लिए आमंत्रित किया जाता है। ',
    aff_str49_para:
      'ए पार्टी को अपने किसी भी दायित्व को निभाने के लिए बाध्य नहीं किया जाएगा यदि उसे बल की स्थिति से ऐसा करने से रोका जाए। "फोर्स मेज्योर" घटनाओं में भगवान के कृत्यों, सरकार के कृत्यों, प्रकृति के कार्यों, हड़तालों या दंगों के साथ-साथ पीपललिंक आपूर्तिकर्ताओं या वस्तुओं, सामग्रियों या सॉफ्टवेयरों में दोषों के अनुचित प्रदर्शन सहित पार्टियों के उचित नियंत्रण से परे की घटनाओं को शामिल किया जाएगा। तीसरे पक्ष। यदि बल की स्थिति तीस से अधिक (30) दिनों तक रहती है, तो पार्टी अन्य पार्टी को लिखित नोटिस पर इस समझौते को समाप्त कर सकती है। ',
    aff_str410_para:
      "यह समझौता, विषय वस्तु और पक्षकारों के संबंधित दायित्वों और प्रतिबद्धताओं के संबंध में पार्टियों के बीच पूरे समझौते का प्रतिनिधित्व करता है। पार्टियों के बीच कोई अन्य दस्तावेज या मौखिक या लिखित समझौते इस समझौते में किए गए समझौतों पर किसी भी तरह से प्रतिबिंबित नहीं करते हैं। और इस समझौते को दोनों पक्षों द्वारा निष्पादित एक लेखन को छोड़कर संशोधित नहीं किया जा सकता है। जब भी संभव हो, इस समझौते के प्रत्येक प्रावधान की व्याख्या इस तरह से की जाएगी कि लागू कानून के तहत प्रभावी और मान्य हो, लेकिन यदि इस समझौते का कोई प्रावधान है इस तरह के प्रावधान या इस समझौते के शेष प्रावधानों को अमान्य किए बिना, इस तरह के प्रावधान केवल इस तरह के निषेध या अमान्यता की सीमा तक अप्रभावी होंगे, जो इस तरह के निषेध या अमान्यता की सीमा तक अप्रभावी होंगे। ",
    aff_str411_para:
      "इस समझौते को समकक्षों में हस्ताक्षरित किया जा सकता है और इस तरह के समकक्ष मान्य होंगे और पार्टियों पर उसी तरह से बाध्यकारी होंगे जैसे कि मूल हस्ताक्षर का आदान-प्रदान किया गया था।",
    aff_str412_para:
      "यह समझौता हैदराबाद, तेलंगाना, भारत के क्षेत्राधिकार के कानूनों द्वारा नियंत्रित किया जाएगा, कानून के टकराव के किसी भी सिद्धांत को प्रभावी किए बिना। क्षेत्राधिकार केवल हैदराबाद, तेलंगाना, भारत के जिला न्यायालयों में ही होगा। एकमात्र और अनन्य क्षेत्राधिकार। और इस समझौते से उत्पन्न होने वाले किसी भी मुकदमे के लिए स्थान हैदराबाद, तेलंगाना, भारत में स्थित एक उपयुक्त जिला या राज्य न्यायालय होगा, और पार्टियां इसे बढ़ाने के लिए सहमत नहीं होती हैं, और इसके लिए स्थल या मंच की सुविधा के आधार पर कोई आपत्ति या बचाव नहीं करती हैं। इस समझौते के तहत या उससे संबंधित किसी भी कानूनी कार्रवाई की शुरुआत करने से पहले, एक पक्ष दूसरे पक्ष को एक विवाद की लिखित सूचना प्रदान करेगा और पक्षकार सक्रिय रूप से और अच्छे विश्वास के साथ तीस (30) के भीतर इस तरह के विवाद के त्वरित समाधान के लिए बातचीत करेंगे। इस तरह के नोटिस की प्राप्ति के व्यावसायिक दिन। ",
    aff_str40: "समझौते का संशोधन।",
    aff_str40_para:
      "पीपललिंक समय-समय पर इस समझौते को साइट पर परिवर्तन (www.peoplelinkvc.com/affiliatestermsofservice पर) पोस्ट करके या ईमेल के माध्यम से पार्टनर को सूचित करके अपने उचित विवेक से संशोधित कर सकती है। यदि भागीदार ऐसी किसी भी परिवर्तन के लिए वस्तु। , भागीदार इस समझौते को कारण के लिए समाप्त कर सकता है। इस समझौते में परिवर्तन की सूचना प्राप्त होने के बाद कार्यक्रम में भागीदार की निरंतर भागीदारी इस समझौते की बाध्यकारी स्वीकृति का संशोधन करेगी। ",
    qualified_ref: "योग्य रेफरल",
    mean_referrals: "मीन रेफ़रल",
    apply: "लागू",
    company_code_validate: "कृपया मान्य करने के लिए कंपनी कोड दर्ज करें",
    golive_company_code: "गोलाइ कंपनी कोड",
    accept_TC: "मैं उपरोक्त नियमों और शर्तों को स्वीकार करता हूं",
    by_sub_referral:
      "रेफरल पार्टनर एप्लिकेशन सबमिट करके, पार्टनर इस समझौते को पढ़ता, समझता और स्वीकार करता है और इस अनुबंध को स्वीकार करता है,",
    term: "शर्तें",
    found_at: "पर मिला",
    our_privacy_policy: "और हमारी गोपनीयता नीति",
    privacy_policy: "गोपनीयता नीति",
    months: "महीने",
    as_applicable: "जैसा लागू हो।",
    "screen-sharing": "स्क्रीन साझेदारी",
    whiteboard_access: "व्हाइटबोर्ड का उपयोग",
    Document_access: "दस्तावेज़ का उपयोग",
    share_the_screen: "स्क्रीन साझा करें!",
    to_collaborate: "सहयोग देना!",
    share_document: "दस्तावेज़ साझा करें!",

    exit_or_end: "बाहर निकलें या सत्र समाप्त करें?",
    exit_from_meeting: "सत्र से बाहर निकलें?",
    are_sure_exit_meeting_everyone:
      "क्या आप वाकई सत्र से बाहर निकलना चाहते हैं? आप या तो सभी के लिए मीटिंग समाप्त कर सकते हैं या आप सत्र से बाहर निकल सकते हैं।",
    are_sure_exit_meeting: "क्या आप वाकई सत्र से बाहर निकलना चाहते हैं?",
    exit_meeting: "सत्र से बाहर निकलें",
    end_for_all: "सभी के लिए सत्र समाप्त करें",
    end_meeting: "सत्र समाप्त करें",
    will_let_alone_exit: "आपको अकेले बाहर निकलने या सत्र छोड़ने देगा।",
    will_end_for_everyone:
      "सम्मेलन में सभी के लिए सत्र समाप्त करेगा (सभी प्रतिभागी और उपस्थित).",
    user_already_exists: "उपयोगकर्ता पहले से मौजूद हैं",
    already_user_avail: "सम्मेलन में पहले से ही कुछ उपयोगकर्ता उपलब्ध हैं।",
    if_like_continue: "यदि आप जारी रखना चाहते हैं तो पर क्लिक करें",
    force_start_meetinh: "बल एक और सत्र प्रारंभ करें",
    otherwise_click: "अन्यथा क्लिक करें ",
    to_go_back: "वापस जाने के लिए। ",

    //New by Keerthi - 17th Sep 2020
    lang_settings: "भाषा सेटिंग्स",
    lang_info: "एप्लिकेशन का उपयोग करने के लिए अपनी पसंदीदा भाषा चुनें।",
    select_language: "भाषा चुने",
    settings_languages: "बोली",

    rec_plugin: "Recording Plugin",
    rec_heading1:
      "How to install and manage InstaVC Screen-Video Recorder with the plugin",
    rec_step1: "Step 1: Copy & open Link in Chrome",
    rec_step1_para: "First copy the link ",
    rec_step1_para_br:
      "from here and open it in chrome to add the plugin to your browser. Click on ",
    rec_step1_para_bold: "Add to Chrome",
    rec_step1_para_ct: "to add this extension.",

    rec_step2: "Step 2: Pop Up for Permission",
    rec_step2_para_br:
      "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
    rec_step2_para_bold: "Add Extension",
    rec_step2_para_ct: "to proceed.",

    rec_step3: "Step 3: Extension Added to Chrome",
    rec_step3_para:
      "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

    rec_step4: "Step 4: Pin the plugin on the toolbar",
    rec_step4_para_br:
      "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
    rec_step4_para_bold: "InstaVC Screen-Recording",
    rec_step4_para_ct: "and click on the pin icon to add.",

    rec_step5: "Step 5: Extension/Plugin Pinned to Toolbar",
    rec_step5_para:
      "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access.",

    rec_step6: "Step 6: InstVC Recorder Setup",
    rec_step6_para_br:
      "Once you have installed the plugin and the next time when you open it, you can now see the ",
    rec_step6_para_bold: "InstaVC Recorder Setup",
    rec_step6_para_ct:
      "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
    rec_step6_para_bold1: "Next",
    rec_step6_para_ct1: "to continue.",

    rec_step7: "Step 7: Additional Permissions",
    rec_step7_para_br:
      "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
    rec_step7_para_bold: "Allow",
    rec_step7_para_ct: "to continue.",

    rec_step8: "Step 8: Permissions Allowed",
    rec_step8_para:
      "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

    rec_heading2: "Desktop Screen-Recording Plugin",

    rec_step9: "Step 9: Desktop Screen-Recording",
    rec_step9_para_br:
      "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
    rec_step9_para_bold: "Desktop Screen Recording",
    rec_step9_para_ct: "and click on the",
    rec_step9_para_bold1: "Record",
    rec_step9_para_ct1: "button to start.",

    rec_step9a: "Step 9(a): Share your Screen Popup",
    rec_step9a_para_br:
      "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
    rec_step9a_para_bold: "Share",
    rec_step9a_para_ct:
      "button and go to that screen which you want to start recording.",

    rec_step9b: "Step 9(b): Desktop Screen Recording Started",
    rec_step9b_para_br:
      "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
    rec_step9b_para_bold: "Stop Sharing",
    rec_step9b_para_ct: "or",
    rec_step9b_para_bold1: "Hide",
    rec_step9b_para_ct1:
      ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

    rec_step9c: "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
    rec_step9c_para_br:
      "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
    rec_step9c_para_bold: "Restart, Pause",
    rec_step9c_para_ct: "and",
    rec_step9c_para_bold1: "Stop",
    rec_step9c_para_ct1: "buttons. You can click any of those accordingly.",

    rec_step9d: "Step 9(d):Recent Recording View",
    rec_step9d_para_br:
      "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
    rec_step9d_para_bold: "Download",
    rec_step9d_para_ct:
      "option in the top and the recording details in the right column.",

    rec_heading3: "Browser Tab Screen-Recording Plugin",

    rec_step10: "Step 10: Browser Tab Screen-Recording",
    rec_step10_para_br: "When we want to select ",
    rec_step10_para_bold: "Browser Tab",
    rec_step10_para_ct:
      "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
    rec_step10_para_bold1: "Record",
    rec_step10_para_ct1: "button to start recording.",

    rec_step10a: "Step 10(a): Browser Tab is being Recorded",
    rec_step10a_para:
      "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",

    rec_step10b: "Step 10(b): Record another tab",
    rec_step10b_para_br:
      "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
    rec_step10b_para_bold: "Record This Tab",
    rec_step10b_para_ct:
      "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

    rec_step10c: "Step 10(C): Stop and View recording",
    rec_step10c_para_br:
      "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
    rec_step10c_para_bold: "Download",
    rec_step10c_para_ct:
      "Option at the top and the recording details in the right column.",

    rec_heading4: "Webcam Recording",

    rec_step11: "Step 11: Start Webcam Screen Recording",
    rec_step11_para_br:
      "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
    rec_step11_para_bold: "Record",
    rec_step11_para_ct: "button to start with.",

    rec_step11a: "Step 11(a): Webcam opens Self Video and starts Recording",
    rec_step11a_para_br:
      "The recording opens a web page with yourself video with",
    rec_step11a_para_bold: "Pause",
    rec_step11a_para_ct: "and",
    rec_step11a_para_bold1: "Stop",
    rec_step11a_para_ct1: "recording options at the bottom.",

    rec_step11b: "Step 11(b): View Webcam Recorded Video",
    rec_step11b_para:
      "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",

    rec_heading5: "Top Menus in Recording Plugin",

    rec_step12: "Step 12: Navigation Menus",
    rec_step12_para_br:
      "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
    rec_step12_para_bold: "Hamburger Menu",
    rec_step12_para_ct: "Click on it to open.",

    rec_step12a: "Step 12(a): Open Hamburger Menu",
    rec_step12a_para_br: "On click of",
    rec_step12a_para_bold: "Hamburger Menu",
    rec_step12a_para_ct: ", you can find 2 tabs named",
    rec_step12a_para_bold1: "My Recordings",
    rec_step12a_para_ct1: "and",
    rec_step12a_para_bold2: "Options",
    rec_step12a_para_ct2:
      "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
    rec_step12a_para_bold3: "My Recordings",
    rec_step12a_para_ct3: "to see the videos you have recorded till date.",

    rec_step12b: "Step 12(b): Access My Recordings",
    rec_step12b_para_br: "There is another way of accessing",
    rec_step12b_para_bold: "My Recordings",
    rec_step12b_para_ct:
      ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",

    rec_step12c: "Step 12(c): My Recordings",
    rec_step12c_para:
      "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

    rec_step12d: "Step 12(d): Delete All recordings",
    rec_step12d_para_br:
      "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
    rec_step12d_para_bold: "Delete All",
    rec_step12d_para_ct:
      "option to easily delete all recordings with a single click.",

    rec_step12e: "Step 12(e): Side Navigation",
    rec_step12e_para_br:
      "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
    rec_step12e_para_bold: "Options",
    rec_step12e_para_ct: "page",

    rec_heading6: "Plugin Options",

    rec_step13: "Step 13: Plugin Options",
    rec_step13_para_br:
      "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
    rec_step13_para_bold: "Options",
    rec_step13_para_ct: "to see the options that are enabled for you.",

    rec_step13a: "Step 13(a): Recorder Options",
    rec_step13a_para:
      "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

    rec_step13b: "Step 13(b): Recorder Options",
    rec_step13b_para:
      "Recorder Options contain various other options like Recording Settings and advanced.",

    rec_heading7: "Plugin Notifications",

    rec_step14: "Step 14: Plugin Notifications",
    rec_step14_para:
      "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

    rec_step14a: "Step 14(a): Open Notifications",
    rec_step14a_para:
      "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

    rec_heading8: "Recording Settings",

    rec_step15: "Step 15: Settings",
    rec_step15_para_br:
      "Then comes the last navigation menu on the top right corner named",
    rec_step15_para_bold: "Settings",
    rec_step15_para_ct:
      "where you can open and manage the recording settings accordingly.",

    rec_step15a: "Step 15(a): Advanced Settings Options",
    rec_step15a_para:
      "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

    crteContent_upload_medialist: "Uploaded Media List",
    content_upld_desc_txt:
      "The files you upload here will be available to users who view content.",
    content_browse_txt: "Browse Files to Upload",
    content_upld_types:
      "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

    video_qlty: "वीडियो गुणवत्ता",
    audio_qlty: "ऑडियो गुणवत्ता",
    cntnt_shrng: "सामग्री साझा करना",
    fdb_poor: "गरीब",
    fdb_good: "अच्छा",
    fdb_avg: "औसत",
    fdb_excellent: "अति उत्कृष्ट",
    share_feedback: "अपना फ़ीडबैक साझा करें",
    ovrl_rating: "समग्र रेटिंग",
    fdb_cmnts: "आपकी टिप्पणियों की बहुत सराहना की जाती है",
    no_thnks: "जी नहीं, धन्यवाद",
    upload_size_max_15mb: "आप अधिकतम आकार सीमा 15MB अपलोड कर सकते हैं",

    pastMeeting_feedback: "प्रतिपुष्टि",
    pastMeeting_comments: "टिप्पणियाँ",

    microsoft_webplugin: "Microsoft आउटलुक वेब प्लगइन",
    microsoft_installable: "Microsoft आउटलुक इंस्टॉल करने योग्य प्लगिन",
    outlook_installable: "आउटलुक इंस्टॉल करने योग्य",
    customization_installer: "अनुकूलन इंस्टॉलर का उपयोग कैसे करें",
    plugin_step1: "चरण 1: फ़ाइल डाउनलोड करने के लिए लिंक पर क्लिक करें",
    click_link_download: "लिंक से डाउनलोड फ़ाइल पर क्लिक करें",
    first_click_link: "सबसे पहले नीचे दिए गए लिंक पर क्लिक करें",
    to_download_file:
      "अपने सिस्टम में फ़ाइल डाउनलोड करने के लिए। फिर इंस्टॉलेशन शुरू करने के लिए डाउनलोड की गई फ़ाइल खोलें और क्लिक करें",
    install_txt: "इंस्टॉल",
    plugin_step2: "चरण 2: अनुकूलन स्थापित किया गया",
    plugin_step2_para:
      "Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
    plugin_step3: "चरण 3: आउटलुक खोलें और मीटिंग्स पर जाएं",
    plugin_step3_para:
      "स्थापना के बाद, माइक्रोसॉफ्ट आउटलुक खोलें और एक सत्र में जाएं।",
    plugin_step3_para1: "नया ईमेल > सत्र पर जाएं",
    plugin_step4: "चरण 4: ओपन सेशन",
    plugin_step4_para:
      "एक बार सत्र विंडो को उपरोक्त टैब की सूची पर एक खुली चाल मिल जाती है और फिर आप टैब पर क्लिक कर सकते हैं",
    plugin_step4_para1: "लोगलिंक",
    plugin_step5: "Step5: अनुसूची सम्मेलन",
    plugin_step5_para: "Peoplelink के तहत आपके पास उप टैब नाम है",
    plugin_step5_para1: "अनुसूची सम्मेलन।",
    plugin_step5_para2:
      "उस पर क्लिक करें और आप विंडो के दाईं ओर अनुसूची विकल्प देख सकते हैं। यहाँ आप inVC अनुसूचियों का प्रबंधन कर सकते हैं।",
    plugin_step6: "Step6: अनुसूचियों को प्रबंधित या अनुकूलित करें",
    plugin_step6_para:
      "यहां आप कमरे, समय की सूची के आधार पर शेड्यूल को प्रबंधित या अनुकूलित कर सकते हैं और यहां से एक नया शेड्यूल बना सकते हैं जो आपको ब्राउज़र पर वापस ले जाता है और वापस आउटलुक में लाता है।",
    plugin_step6_para1:
      "एक बार जब आप शेड्यूल के साथ ठीक हो जाते हैं तो आप क्लिक कर सकते हैं",
    plugin_step6_para2: "लिंक को प्राप्त करो",
    plugin_step7: "लिंक जनरेट किया गया",
    plugin_step7_para:
      "फिर यहाँ मेल में उत्पन्न और रचित लिंक मिलता है जिसे आप ऑनलाइन साझा करने के लिए भी उपयोग कर सकते हैं या आगे बढ़ सकते हैं।",

    instavc_schedulemeeting_namesplchar:
      "No special characters allowed except @ # $ % ^ & * _ - ?",

    sessions: "सत्र",
    schedule_session: "अनुसूची सत्र",
    join_session: "सत्र में शामिल हों",
    no_of_sessions_attended_by_teacher:
      "शिक्षकों द्वारा उपस्थित सत्रों की संख्या",
    no_of_sessions_attended_by_student:
      "छात्रों द्वारा भाग लेने वाले सत्रों की संख्या",
    teacher_attendance: "शिक्षकों की उपस्थिति",
    students_attendance: "छात्रों की उपस्थिति",
    virtual_classroom:
      "एक अद्वितीय अनुभव के साथ ऑनलाइन वर्चुअल क्लासरूम प्लेटफॉर्म",
    today_sessions: "आज के सत्र",
    no_sessions: "कोई सत्र नहीं...",
    session_quote:
      "बुनियादी और उन्नत मीटिंग सुविधाओं के साथ सत्र पासवर्ड निर्माण को सक्षम करने या डायनामिक मीटिंग आईडी सक्षम करने जैसे विकल्पों के साथ एक नया सत्र शेड्यूल करें।",
    session_title: "सत्र शीर्षक",
    create_session_name: "सत्र का नाम बनाएं",
    session_password: "सत्र पासवर्ड",
    meeting_password: "सत्र पासवर्ड बनाएं",
    selectClass: "कक्षा का चयन करें",
    selectSubject: "विषय चुनें",
    select_time: "समय चुनें",
    select_meeting_date_time: "सत्र दिनांक और समय चुनें",
    select_slot: "स्लॉट का चयन करें",
    select_numberof_participant_seats: "प्रतिभागी सीटों की संख्या चुनें",
    advanced_options: "उन्नत विकल्प",
    custom_registration_url: "कस्टम पंजीकरण यूआरएल",
    custom_feedback_url: "कस्टम फ़ीडबैक URL",
    allow_guest_control: "मेहमानों को नियंत्रित करने दें",
    meeting_details: "सत्र विवरण",
    meeting_title: "सत्र शीर्षक",
    meeting_type: "सत्र प्रकार",
    seats: "सीटों",
    meeting_Password: "सत्र पासवर्ड",
    meeting_only_url: "केवल सत्र URL:",
    join_meeting_quote:
      "प्रतिभागियों को आमंत्रित किए बिना या सत्र में शामिल हों",
    copy_invitation: "कॉपी आमंत्रण",
    invite_users_list: "आमंत्रित करें - उपयोगकर्ता सूची",
    update_meeting: "सत्र अपडेट करें",
    custom: "रीति",
    frequency: "आवृत्ति",
    occurences_end: "घटना समाप्त",
    occurences: "पुनरावृत्तियां",
    hr: "मानव संसाधन",
    every_day: "हर दिन",
    hours: "घंटे",
    hour: "घंटा",
    errorTxt_slots: "आपको कस्टम समय भरना होगा - घंटे या मिनट",
    participantSeats: "प्रतिभागी सीटें",
    participant_seat: "प्रतिभागी सीट",
    subjects: "विषयों",
    visible: "दृश्यमान",
    hidden: "छुपे हुए",
    create_topic: "विषय बनाएं",
    edit_topic: "विषय संपादित करें",
    topicName: "विषय का नाम",
    topicDescripiton: "विषय विवरण",
    public: "जनता",
    classDescription: "कक्षा विवरण",
    editNewClass: "नई कक्षा संपादित करें",
    topics: "विषय",
    topicView: "विषय दृश्य",
    no_of_sessions_conducted: "आयोजित सत्रों की संख्या",
    no_of_students_attended_session:
      "आपके सत्र में भाग लेने वाले छात्रों की संख्या",
    yourAssignments: "आपके असाइनमेंट",
    attendance: "उपस्थिति",
    recent_topics: "हाल के विषय",
    no_subjects: "अभी तक कोई विषय नहीं बनाया गया है!",
    no_subjects_create:
      "ऊपर दिए गए क्रिएट सब्जेक्ट बटन पर क्लिक करके एक नया सब्जेक्ट बनाएं",
    no_topics: "अभी तक कोई विषय नहीं बनाया गया है!",
    no_topics_create:
      "ऊपर दिए गए क्रिएट टॉपिक बटन पर क्लिक करके एक टॉपिक बनाएं",
    assgnlist_noassignments: "अभी तक कोई असाइनमेंट नहीं सौंपा गया है!",
    assgnlist_assign_new_assign:
      "उपरोक्त असाइनमेंट बटन पर क्लिक करने के लिए एक नया असाइनमेंट असाइन करें",
    start_date_time: "प्रारंभ दिनांक और समय",
    end_date_time: "समाप्ति तिथि और समय",
    join_conference_quote:
      "सत्र में शामिल होने के लिए, नीचे दिए गए इनपुट बॉक्स में सत्र आईडी प्रदान करें",
    edit_student: "छात्र संपादित करें",
    editTeacher: "शिक्षक संपादित करें",
    subject_name: "विषय नाम",
    subject_description: "विषय विवरण",
    select_type: "प्रकार चुनें",
    others: "अन्य",
    Institute_name: "संस्थान का नाम",
    first_name_contact: "संपर्क का पहला नाम",
    last_name_contact: "संपर्क का अंतिम नाम",
    institute_type: "संस्थान का प्रकार",
    institute_name: "संस्था का नाम",
    contact_number: "संपर्क संख्या",
    signup_as_institute: "संस्थान के रूप में साइन अप करें",
    signup_as_student: "छात्र के रूप में साइन अप करें",
    state: "राज्य",
    city: "शहर",
    institute_name_error: "संस्थान का नाम केवल अक्षर होना चाहिए",
    institute_type_error: "संस्थान के प्रकार का चयन किया जाना चाहिए",
    address_error: "पता विशेष वर्ण स्वीकार कर सकता है",
    student: "विद्यार्थी",
    institute: "संस्था",
    signUpas: "के रूप में साइन अप करें",
    submitted: "प्रस्तुत",
    notSubmitted: "जमा नहीं किया",
    review: "समीक्षा",
    inReview: "रिव्यू में",
    questionTitle: "प्रश्न शीर्षक",
    questionDescription: "प्रश्न विवरण",
    questionnaireTitle: "प्रश्न शीर्षक",
    started: "शुरू कर दिया है",
    testName: "परीक्षण का नाम",
    timeTaken: "समय लिया",
    showAnswers: "उत्तर दिखाइए",
    downloadCertificate: "प्रमाणपत्र डाउनलोड करें",
    startTime: "समय शुरू",
    endTime: "अंतिम समय",
    assignmentTitle: "असाइनमेंट शीर्षक",
    editor: "संपादक",
    save_submit: "सहेजें और सबमिट करें",
    assigned_students: "असाइन किए गए छात्र",
    total_marks: "कुल मार्क",
    not_yet_Submitted: "अभी तक सबमिट नहीं किया गया",
    completed: "पूरा हुआ",
    due_date: "नियत तारीख",
    marks_obtained: "प्राप्तांक",
    assign_marks: "अंक निर्दिष्ट करें",
    home_inclass_copyright: "© 2022 InstaVC Inc. All Rights Reserved.",
    // "© 2022 InstaVC Inc सर्वाधिकार सुरक्षित | द्वारा संचालित People Unified Communication Pvt. Ltd.",
    back_to_classes: "कक्षाओं में वापस",
    className: "कक्षा का नाम",
    attendanceReports: "उपस्थिति रिपोर्ट",
    present: "वर्तमान",
    absent: "अनुपस्थित",
    ratio: "अनुपात",
    sessionsAttended: "सत्र में भाग लिया",
    totalSessions: "कुल सत्र",
    filters: "फिल्टर",
    teacher: "शिक्षक",
    userType: "उपयोगकर्ता का प्रकार",
    class: "कक्षा",
    clear: "स्पष्ट",
    sessionsConducted: "आयोजित सत्र",
    Topic: "विषय",
    uploadMediaSizeLimit: "15 एमबी तक आकार सीमा के साथ।",
    assessments: "आकलन",
    assessment: "मूल्यांकन",
    totalStudents: "कुल छात्र",
    totalAssignments: "कुल असाइनमेंट",
    assignmentsCompleted: "कार्य पूर्ण",
    assignmentsPending: "असाइनमेंट लंबित",
    score: "स्कोर",
    submittedDate: "सबमिट करने की तिथि",
    dueDateOfSubmission: "जमा करने की नियत तिथि",
    clearSelections: "चयन साफ़ करें",
    noschedule_meetings: "आपका कोई आगामी सत्र नहीं है.",
    nopast_meetings: "आपका कोई पिछला सत्र नहीं है",
    id: "पहचान",
    export: "निर्यात",
    import: "आयात",
    sample_excel: "नमूना एक्सेल",
    subject_access: "विषय पहुंच",
    submitted_date_time: "जमा करने की तिथि/समय",
    passed: "बीतने के",
    failed: "अनुत्तीर्ण होना",
    average_score: "औसत अंक",
    total_reviewed: "कुल समीक्षित",
    pending_review: "लंबित समीक्षा",
    total_students_finished: "कुल छात्र समाप्त",
    total_students_passed: "कुल छात्र उत्तीर्ण",
    total_students_failed: "कुल छात्र असफल",
    total_students_absent: "कुल अनुपस्थित छात्र",
    time_exceed: "समय सीमा पार हो गई",
    time_exceed_assgn_msg: "इस असाइनमेंट को जमा करने की समय सीमा पार हो गई है",
    time_exceed_quess_msg: "इस प्रश्नपत्र को जमा करने की समय सीमा पार हो गई है",
    class_code: "कक्षा का नाम",
    subject_code: "विषय कोड",
    updateQuestion: "अद्यतन प्रश्न",
    create_new_passwd: "नया पासवर्ड बनाएं",
    please_enter_topic_name: "कृपया विषय का नाम दर्ज करें",
    please_enter_topic_description: "कृपया विषय विवरण दर्ज करें",
    plz_select_questionary: "कृपया प्रश्नवाचक चुनें।",
    plz_select_duration_checkbox: "कृपया अवधि चेकबॉक्स चुनें।",
    Plz_select_assignment: "कृपया असाइनमेंट का चयन करें।",
    plz_select_valid_date_time: "कृपया मान्य दिनांक समय चुनें।",
    Plz_enter_valid_marks: "कृपया मान्य अंक दर्ज करें।",
    Plz_enter_subject_title: "कृपया विषय शीर्षक दर्ज करें।",
    class_code:"कक्षा का कोड",
    Plz_enter_class_name: "कृपया कक्षा का नाम दर्ज करें",
    Plz_enter_subject_description: "कृपया विषय विवरण दर्ज करें।",
    Plz_enter_subject_type: "कृपया विषय प्रकार दर्ज करें।",
    Plz_enter_subject_code: "कृपया विषय कोड दर्ज करें।",
    Plz_enter_valid_subject_code: "कृपया मान्य विषय कोड दर्ज करें",
    Plz_enter_class_code: "कृपया कक्षा कोड दर्ज करें।",
    Plz_enter_valid_class_code: "कृपया मान्य वर्ग कोड दर्ज करें",
    plz_enter: "कृपया दर्ज करें",
    Plz_enter_valid: "कृपया मान्य दर्ज करें",
    Plz_enter_title: "कृपया शीर्षक दर्ज करें।",
    Plz_enter_description: "कृपया विवरण दर्ज करें।",
    Plz_select_class: "कृपया कक्षा का चयन करें",
    Plz_select_subject: "कृपया विषय का चयन करें।",
    enroll: "नामांकन",
    actions: "कार्रवाई",
    something_went_wrong: "कुछ गलत हो गया।",
    data_is_not_selected: "डेटा चयनित नहीं है",
    data_added_successfully: "डेटा सफलतापूर्वक जोड़ा गया",
    plz_enter_question: "कृपया प्रश्न दर्ज करें",
    plz_enter_marks: "कृपया अंक दर्ज करें",
    Plz_select_type: "कृपया प्रकार चुनें",
    opt_should_have_minimum: "विकल्पों में कम से कम 2 . होना चाहिए",
    opt_should_not_empty: "विकल्प खाली नहीं होने चाहिए",
    opt_should_not_duplicate: "विकल्प डुप्लिकेट नहीं होने चाहिए",
    plz_select_the_answer: "कृपया उत्तर का चयन करें",
    question_updated_successfully: "प्रश्न सफलतापूर्वक अपडेट किया गया",
    question_created_successfully: "प्रश्न सफलतापूर्वक बनाया गया",
    marks_less_than_total_marks: "दर्ज किए गए अंक कुल अंकों से कम होने चाहिए",
    marks_not_negative: "अंक नकारात्मक नहीं होने चाहिए",
    assgn_successfully_verifed:
      "असाइनमेंट सहेजें सफलतापूर्वक सत्यापित किया गया।",
    assgn_save_submited_succes:
      "असाइनमेंट सहेजें और सफलतापूर्वक सबमिट किया गया",
    assgn_save_succes: "असाइनमेंट सफलतापूर्वक सहेजें",
    Plz_enter_valid_content: "कृपया मान्य सामग्री दर्ज करें।",
    Assgn_updated_success: "असाइनमेंट सफलतापूर्वक अपडेट किया गया",
    Assgn_created_success: "असाइनमेंट सफलतापूर्वक बनाया गया",
    Assgn_assigned_success: "असाइनमेंट सफलतापूर्वक असाइन किया गया",
    Assgn_disabled_success: "असाइनमेंट सफलतापूर्वक अक्षम किया गया।",
    Assgn_enabled_success: "असाइनमेंट सफलतापूर्वक सक्षम किया गया।",
    Assgn_deleted_success: "असाइनमेंट सफलतापूर्वक हटा दिया गया।",
    Quest_creat_success: "प्रश्नावली सफलतापूर्वक बनाई गई",
    Quest_updated_success: "प्रश्नावली सफलतापूर्वक अपडेट की गई",
    Poll_created_success: "पोल सफलतापूर्वक बनाया गया",
    Poll_updated_success: "मतदान सफलतापूर्वक अपडेट किया गया",
    opt_minimum: "विकल्पों में कम से कम 2 विकल्प होने चाहिए",
    Poll_deleted_success: "मतदान सफलतापूर्वक हटाया गया",
    Poll_enabled_success: "मतदान सफलतापूर्वक सक्षम किया गया",
    Poll_disabled_success: "मतदान सफलतापूर्वक अक्षम किया गया",
    Quest_deleted_success: "प्रश्न सफलतापूर्वक हटाया गया",
    Invit_send_success: "आमंत्रण सफलतापूर्वक भेजा गया",
    teacher_deleted_success: "शिक्षक को सफलतापूर्वक हटाया गया",
    error_some_thing_went_wrong: "त्रुटि, कुछ गलत हो गया।",
    user_updated_success: "उपयोगकर्ता स्थिति सफलतापूर्वक अपडेट की गई",
    teacher_updated_success: "शिक्षक सफलतापूर्वक अपडेट किया गया",
    student_remove_success: "छात्र सफलतापूर्वक निकालें",
    teachers_created_success: "शिक्षक सफलतापूर्वक बनाए गए",
    error_occured_try_again: "एक त्रुटि हुई, पुन: प्रयास करें!",
    please_select_less: "कृपया 15MB फ़ाइल आकार से कम का चयन करें।",
    submit_success: "सफलतापूर्वक जमा",
    grad_updat_success: "ग्रेड अपडेट सफलतापूर्वक",
    Quest_delet_succes: "प्रश्नावली सफलतापूर्वक हटाई गई",
    Quest_disab_succes: "प्रश्नावली को सफलतापूर्वक अक्षम किया गया",
    Quest_enabled_succes: "प्रश्नावली सफलतापूर्वक सक्षम की गई",
    student_add_succes: "छात्र सफलतापूर्वक जोड़ा गया",
    plz_select_atleast_std: "कृपया कम से कम 1 विद्यार्थी का चयन करें",
    fail_add_some_student: "कुछ छात्रों को जोड़ने में विफल",
    std_add_succes: "छात्र सफलतापूर्वक जोड़े गए",
    sub_updat_succes: "विषय सफलतापूर्वक अपडेट किया गया",
    sub_creat_succes: "विषय सफलतापूर्वक बनाया गया",
    sub_dlt_succes: "विषय सफलतापूर्वक हटा दिया गया",
    sub_enabl_succes: "विषय सफलतापूर्वक सक्षम किया गया",
    sub_disab_succes: "विषय सफलतापूर्वक अक्षम किया गया",
    tchr_add_success: "शिक्षक सफलतापूर्वक जोड़ा गया",
    plz_slc_atlst_tchr: "कृपया कम से कम 1 शिक्षक का चयन करें",
    tchr_remo_success: "शिक्षक सफलतापूर्वक निकालें",
    plz_etr_valid_duration: "कृपया मान्य अवधि दर्ज करें",
    topic_updat_success: "विषय सफलतापूर्वक अपडेट किया गया",
    class_dlt_success: "कक्षा सफलतापूर्वक हटाई गई",
    class_upt_succes: "कक्षा सफलतापूर्वक अपडेट की गई",
    class_creat_succes: "कक्षा सफलतापूर्वक बनाई गई",
    plz_select_quest: "कृपया प्रश्नावली का चयन करें",
    first_add_data: "डेटा जोड़ने के लिए प्लस बटन पर क्लिक करें",
    certfct_generat_success: "प्रमाणपत्र सफलतापूर्वक उत्पन्न हुआ",
    plz_select_min_seats: "कृपया न्यूनतम 2 सीट चुनें",
    plz_enter_mtng_name: "कृपया सत्र का नाम दर्ज करें",
    fail_to_updt_mtng_try_again: "सत्र अपडेट करने में विफल! पुनः प्रयास करें",
    fail_update_scdle: "शेड्यूल अपडेट करने में विफल",
    std_delet_success: "विद्यार्थी को सफलतापूर्वक हटाया गया",
    std_updat_succes: "छात्र सफलतापूर्वक अपडेट किया गया",
    std_creat_succes: "छात्र सफलतापूर्वक बनाया गया",
    fail_create_some_std: "कुछ छात्र बनाने में विफल",
    std_creat_success: "छात्र सफलतापूर्वक बनाए गए",
    tchr_creat_succes: "शिक्षक सफलतापूर्वक बनाया गया",
    fail_crt_some_user: "कुछ उपयोगकर्ता बनाने में विफल",
    fail_create_mtg_try_again: "सत्र बनाने में विफल! पुनः प्रयास करें",
    fail_create_schedu: "शेड्यूल बनाने में विफल",
    plz_enter_metng_title: "कृपया सत्र शीर्षक दर्ज करें",
    invalid_phn_nmb: "अवैध फोन नंबर",
    plz_enter_phn_num: "कृपया एक फ़ोन नंबर दर्ज करें",
    topic_crt_succes: "विषय सफलतापूर्वक बनाया गया",
    topic_enabled_succes: "विषय सफलतापूर्वक सक्षम किया गया",
    topic_disabl_success: "विषय सफलतापूर्वक अक्षम किया गया",
    topic_delet_success: "विषय सफलतापूर्वक हटाया गया",
    Media_delet_success: "मीडिया सफलतापूर्वक हटा दिया गया",
    plz_enter_title_upload_doc:
      "कृपया पहले शीर्षक दर्ज करें और दस्तावेज़ अपलोड करें",
    doc_add_succes: "दस्तावेज़ सफलतापूर्वक जोड़ा गया",
    plz_fst_ent_title_and_media:
      "कृपया पहले शीर्षक दर्ज करें और मीडिया फ़ाइल दर्ज करें",
    media_add_success: "मीडिया सफलतापूर्वक जोड़ा गया",
    plz_first_title_and_URL:
      "कृपया पहले शीर्षक दर्ज करें और मीडिया URL दर्ज करें",
    plz_etr_valid_url: "कृपया मान्य URL दर्ज करें",
    generate: "उत्पन्न",
    issue_cert: "प्रमाण पत्र जारी करें",
    total_score: "कुल स्कोर",
    created_by: "के द्वारा बनाई गई",
    certificate: "प्रमाणपत्र",
    not_completed: "पूरा नहीं हुआ",
    view_cert: "प्रमाणपत्र देखें",
    issue_certificate: "प्रमाण पत्र जारी करें",
    title: "शीर्षक",
    issue_date: "जारी दिनांक",
    note_edit_and_delete_txt:
      "नोट: संपादित करें और हटाएं बटन परीक्षण से 10 मिनट पहले छिपाए जाएंगे",
    verify_email_msg: "पुष्टि कोड के लिए कृपया अपना ईमेल देखें",
    start_time_greater_currnt_time:
      "प्रारंभ समय वर्तमान समय से 10 मिनट से अधिक होना चाहिए",
    copi_to_clipboard: "क्लिपबोर्ड पर नकल!",
    host_msg: "मेज़बान",
    date_time: "दिनांक समय",
    invities: "आमंत्रित",
    no_chat_history_avai: "कोई चैट इतिहास उपलब्ध नहीं है।",
    no_feedbacks_avai: "कोई प्रतिक्रिया उपलब्ध नहीं",
    no_invities_list_avai: "कोई आमंत्रित सूची उपलब्ध नहीं है",
    no_conference_note_avai: "कोई सम्मेलन नोट उपलब्ध नहीं हैं।",
    total_notes: "कुल नोट्स ( 15 )",
    view_log_history: "लॉग इतिहास देखें",
    total_duration: "कुल अवधि :",
    min: "मिनट",
    total_time_spent: "कुल समय बिताया:",
    entry: "प्रवेश",
    exit: "बाहर जाएं",
    time_spent: "समय बिताया",
    no_conference_recording_avai: "कोई कॉन्फ़्रेंस रिकॉर्डिंग उपलब्ध नहीं है",
    no_meetings: "कोई सत्र नहीं!",
    this_brow_dont_support_video_tag:
      "यह ब्राउज़र वीडियो-टैग का समर्थन नहीं करता",
    no_participants_list_avai: "प्रतिभागियों की कोई सूची उपलब्ध नहीं है।",
    total_number_session: "सत्रों की कुल संख्या",
    start_date: "आरंभ करने की तिथि:",
    join_mtg_provide_id_below_input:
      "सत्र में शामिल होने के लिए, नीचे दिए गए इनपुट बॉक्स में सत्र आईडी प्रदान करें।",
    You_enter_inva_meet: "आपने एक अमान्य सत्र आईडी दर्ज किया है।",
    no_ques_creat_yet: "अभी तक कोई प्रश्नावली नहीं बनाई गई है!",
    creat_quest_click_creat:
      "प्रश्नावली बनाएँ बटन पर क्लिक करके प्रश्नावली बनाएँ।",
    only_invit_can_join: "केवल आमंत्रित लोग ही शामिल हो सकते हैं",
    invc_login_mandato: "inVC लॉगिन अनिवार्य",
    training_mode: "प्रशिक्षण मोड",
    audio_only_mode: "केवल ऑडियो मोड",
    mute_parti_upon_entry: "प्रवेश पर प्रतिभागियों को म्यूट करें",
    join_before_host: "मेजबान से पहले शामिल हों",
    enable_breakout_session: "ब्रेकआउट सत्र सक्षम करें",
    anonymous_access: "बेनामी एक्सेस",
    send_invite: "आमंत्रण भेजो",
    add_part_email_address_mobil_msg:
      " एकाधिक प्रविष्टियों के लिए एंटर दबाकर प्रतिभागियों को उनका ईमेल पता या मोबाइल नंबर जोड़कर जोड़ें।",
    add_email_mobile: "ईमेल / मोबाइल नंबर जोड़ें",
    make_sure_the_msg:
      "1 - सुनिश्चित करें कि मोबाइल नंबर देश कोड के साथ होना चाहिए (उदा: +91-99XXXXXXXX)",
    email_id_note: "2 - ईमेल आईडी लोअरकेस होनी चाहिए (उदा: username@xxx.com)",
    meet_before_schedul_time:
      "आप निर्धारित समय से पहले इस सत्र में शामिल नहीं हो सकते।",
    go_to_dashboard: "डैशबोर्ड पर जाएं",
    if_you_are_host_msg:
      "यदि आप एक होस्ट हैं तो कृपया अपने डैशबोर्ड से एक और त्वरित सत्र प्रारंभ करें",
    this_meet_expir_on: "यह सत्र समाप्त हो गया है",
    this_meet_link__expired: "यह सत्र लिंक समाप्त हो गया है",
    this_meet_schedul_for: "इस सत्र के लिए निर्धारित किया गया है",
    meet_min_before_schedule_time:
      "आप निर्धारित समय से 5 मिनट पहले इस सत्र में शामिल हो सकते हैं।",
    this_assign_start_yet: "इस असाइनमेंट का समय अभी शुरू नहीं हुआ है...",
    time_not_yet_start: "समय अभी शुरू नहीं हुआ है",
    field_once_generat_cannot_edit:
      "कृपया सभी फ़ील्ड जांचें कि एक बार जेनरेट होने के बाद संपादित नहीं किया जा सकता",
    certificate_title: "प्रमाणपत्र शीर्षक",
    invalid_meet_code: "अमान्य सत्र कोड",
    meeting_id_below_input_box:
      "सत्र में शामिल होने और स्क्रीन साझा करने के लिए, नीचे दिए गए इनपुट बॉक्स में सत्र आईडी प्रदान करें।",
    meeting_configuration: "सत्र विन्यास",
    room_participant_limit_exceed: "कक्ष प्रतिभागी सीमा पार हो गई है।",
    only_audio_call_auto_mute_enabl: "केवल ऑडियो कॉल और ऑटो म्यूट सक्षम",
    you_audio_video_mute: "आपका ऑडियो और वीडियो म्यूट कर दिया गया है!",
    only_audio_call: "केवल ऑडियो कॉल",
    your_video_mute: "आपका वीडियो म्यूट कर दिया गया है!",
    your_name: "तुम्हारा नाम",
    ok_you_r_ready: "ठीक है, आप तैयार हैं",
    room_empty_meeting_wait_until_host_join:
      "कमरा खाली है! आप सत्र शुरू करने के लिए लॉग इन कर सकते हैं या होस्ट के शामिल होने तक प्रतीक्षा कर सकते हैं",
    room_lock_hang_until_somebody_lets:
      "कमरा बंद है - तब तक रुको जब तक कोई आपको अंदर न आने दे ...",
    your_audio_is_muted: "आपका ऑडियो म्यूट कर दिया गया है!",
    view_assignment: "मार्क्स की अनुमति नहीं है",
    assigned_assignment: "असाइन किया गया असाइनमेंट",
    attempte_assignment_written_anything:
      "आपने असाइनमेंट का प्रयास किया है लेकिन उसमें कुछ भी नहीं लिखा है।",
    Marks_not_alloted: "अंक आवंटित नहीं",
    view_questionnaire: "प्रश्नावली देखें",
    assign_questionnaire_list: "प्रश्नावली सूची असाइन करें",
    assign_assignment: "असाइनमेंट सूची असाइन करें",
    type: "प्रकार",
    class_description: "कक्षा विवरण",
    password_updated: "पासवर्ड अपडेट किया गया!",
    numberOfLicense: "लाइसेंस की संख्या",
    topic: "विषय",
    del_poll: "मतदान",
    std: "विद्यार्थी",
    profile: "प्रोफ़ाइल",
    your_test: "आपका परीक्षण",
    unattended_incomplete_Questionaire_txt_msg:
      "कुछ कारणों से अप्राप्य या अधूरा था। इसलिए स्कोर कार्ड नहीं बन सका",
    Assgnmnt_time_not_started: "असाइनमेंट का समय अभी शुरू नहीं हुआ है...",
    submitted_cnt: "प्रस्तुत सामग्री",
    stud_list: "छात्र सूची",
    test_submitted_successfully:
      "आपका परीक्षण सफलतापूर्वक सबमिट कर दिया गया है",
    score_time_finished_successfully:
      "समय समाप्त होने के बाद स्कोर प्रदर्शित किया जाएगा",
    topics_list: "विषय सूची",
    upload_highResImg: "केवल उच्च-रिज़ॉल्यूशन वाली तस्वीरें अपलोड करें",
    meetingList_upcoming_meetings: "आगामी सत्र",
    subject_list: "विषय सूची",
    plz_enter_valid_number_license: "कृपया लाइसेंस की मान्य संख्या दर्ज करें",
    no_class_assigned: "कोई वर्ग असाइन नहीं किया गया है",
    class_list: "कक्षा सूची",
    plz_fill_all_details: "कृपया सभी विवरण भरें",
    plz_click_upload_media_url: "कृपया मीडिया url अपलोड करें पर क्लिक करें",
    please_enter_msg: "कृपया दर्ज करें",
    Media_msg: "मीडिया।",
    media_url: "मीडिया यूआरएल।",
    title: "शीर्षक",
    and_msg: "और",
    wrong_answer: "गलत जवाब",
    right_answer: "सही जवाब",
    User_list: "उपयोगकर्ता सूची",
    questionaire_time_not_yet_start: "अभी प्रश्नकाल शुरू नहीं हुआ है...",
    submitted_list: "प्रस्तुत सूची",
    search_by_name: "नाम से खोजें",
    scheduleDate: "कार्यक्रम दिनांक",
    view_all: "सभी को देखें",
    view_card: "कार्ड देखें",
    confirm_submit: "क्या आप वाकई असाइनमेंट जमा करना चाहते हैं?",
    confirm_finish: "क्या आप वाकई परीक्षण समाप्त करना चाहते हैं?",
    questionaire: "प्रश्नावली",
    list_of_questns_for_above_questionaire:
      "उपरोक्त प्रश्नावली के लिए नियत प्रश्नों की सूची नीचे दी गई है",
    view_all_assignments: "सभी असाइनमेंट देखें",
    action: "गतिविधि",
    start_dte: "आरंभ करने की तिथि",
    subject: "विषय",
    digital_file_upload_and_digital_signature:
      "यहां अपलोड की गई डिजिटल फ़ाइलें छात्रों को जारी किए गए डिजिटल प्रमाणपत्रों पर दिखाई देंगी",
    upload_logo: "लोगो अपलोड करें",
    upload_signature: "हस्ताक्षर अपलोड करें",
    upload_stamp: "स्टाम्प अपलोड करें",
    drag_and_drop_file: "अपनी फ़ाइल को यहां खींचें और छोड़ें या ",
    max_file_mb_dimensions: "अधिकतम फ़ाइल आकार 20MB आयाम",
    note_assgn_qusnr_text:
      "नोट *: असाइनमेंट शुरू होने से 10 मिनट पहले से आप अपनी प्रविष्टियों को संपादित या हटा नहीं पाएंगे",
    note_qusnr_text:
      " नोट *: प्रश्नावली शुरू होने से 10 मिनट पहले से आप अपनी प्रविष्टियों को संपादित या हटा नहीं पाएंगे",
    not_attended: "भाग नहीं लिया",
    not_started: "शुरू नही हुआ",
    dont_have_stu_acc: "छात्र खाता नहीं है",
    buy_more: "अधिक खरीदें",
    product: "उत्पाद",
    no_subject_assigned: "कोई विषय असाइन नहीं किया गया है",
    logo: "प्रतीक चिन्ह",
    stamp: "टिकट",
    signature: "हस्ताक्षर",
    uploaded_successfully: "सफलतापूर्वक अपलोड किया गया",
    renewal: "नवीनीकरण",
    domain_name: "डोमेन नाम",
    pls_sel_frequency:
      "कृपया चुनें कि आप सप्ताह के किस दिन को शेड्यूल करना चाहते हैं",
    your_test_successfully_submitted:
      "आपका परीक्षण सफलतापूर्वक सबमिट कर दिया गया है",
    score_will_finished: "समय समाप्त होने के बाद स्कोर प्रदर्शित किया जाएगा",
    license_expired: "लायसेंस की समय सीमा समाप्त",
    application_longer_accessed_since__license_expired:
      "आपके लाइसेंस की समय सीमा समाप्त होने के बाद से अब एप्लिकेशन तक नहीं पहुंचा जा सकता है। पहुंच को पुनः सक्रिय करने के लिए,",
    respective_admin_license_renewal:
      "लाइसेंस नवीनीकरण के लिए कृपया अपने संबंधित व्यवस्थापक से संपर्क करें।",
    okay: " ठीक",
    delete_recurring_schedule: "आवर्ती अनुसूची हटाएं",
    are_you_sure_delete_recurring_schedule:
      "क्या आप वाकई इस आवर्ती शेड्यूल को हटाना चाहते हैं?",
    delete_all_recurring_days_completely:
      "सभी आवर्ती दिनों को पूरी तरह से हटा दें।",
    will_eleminate_all_selected: "सभी चुने हुए दिनों को शेड्यूल से हटा देंगे",
    remove_only_selected_days: "केवल चयनित दिन निकालें",
    delete_selected_days_schedule: "यह शेड्यूल से केवल चयनित दिनों को हटा देगा",
    recurring_dates: "आवर्ती तिथियां",
    enter_the_coupon_code: "कूपन कोड दर्ज करें",
    coupon_applied: "कूपन लागू",
    coupon_id: "कूपन आईडी",
    del_recurring_by_dates: "चुनें कि आप किस सत्र का दिन हटाना चाहते हैं",
    more_details: "अधिक जानकारी",
    removeStudentUser: "क्या आप वाकई इस छात्र को हटाना चाहते हैं?",
    removeTeacherUser: "क्या आप वाकई इस शिक्षक को हटाना चाहते हैं?",
    sure_you_want_to_delete: "क्या आप वाकई इसे हटाना चाहते हैं",
    deleting_information_database: "इसे हटाने से डेटाबेस से सभी जानकारी मिट जाएगी।",
    to_confirm_type: "प्रकार की पुष्टि करने के लिए",
    name_not_matched: "नाम मेल नहीं खाता।",
    confirm_this_type: "इसकी पुष्टि करने के लिए, टाइप करें",
    topic_title: "विषय शीर्षक",
    select: "चुनना",
    plz_enter_integers: "कृपया केवल पूर्णांक मान दर्ज करें",
    help_Center: "सहायता केंद्र",

  },
};
